import React, { Component } from 'react';
import { Form, FormControl, Accordion, Card, AccordionToggle, Button } from 'react-bootstrap';
import env from '../ENV';
import { Link } from 'react-router-dom';
import AuthHandlerInstance from '../Classes/AuthHandler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import SuccessFailureModal from '../Components/Success_Failure_Modal_forDispatch';
import { faLeaf, faPaintRoller } from '@fortawesome/free-solid-svg-icons';
import { GetAllDetailsOfPoUploadedForDS } from '../store/actions/vendorActions';
import { connect } from 'react-redux'
import {
    getPODetails, postComment, getPaymentTermDocuments, GetDocumentsForAdvance,
    postMapAdvanceDocumentIDsToPO, postApprovePOAcceptance, postUpdateAdvanceDocumentStatus,
    GetPaymentTermDetails, GetPaymentTermDetailByPOId, PaymentTermDocumentsApprovalByPMs,
    UpdatePartialPaymentDetails, submitInvoiceDocuments, UpdateApprovalForAdvanceDocumentPartial
} from './../store/actions/poDetailsActions'
import swal from '@sweetalert/with-react';
import Select from "react-select"
import {
    postDeliveryScheduleDetails, getAllDocumentsForExpediting, getDocumentDetailsForExpediting, postDocumentDetailsForExpediting,
    approveDocumentsForExpediting, GetDocumentApprovalDetailsForExpediting, GetNextActedRoleIdForApproval, getExpeditingStatusIdForPolineItems,
    getAllDocumentsWithDetailsForExpediting, postCommentsForPOs, updateDeliveryScheduleDetails, UpdateStatusForExpediting, GetAssignedEngineers,
    UpdateEngineerAssignment, getAllDrawingDocuments, ApproveDrawingDocuments, GetNextActedUserId, GetDrawingDocumentApprovalDetails,
    GetAssignedEngineerDetails, PostAssignedEngineerDetails, GetClaimDetailsByPoId, postPoTransmittleDocumnetDtails, GetTransmittalDocumentDetails,
    UpdateTransmittalDocumentDetails, PartialApproval, InsertProgressReportDocuments, GetProgressReportDocuments, AllDocumentsSubmittedByVendor, DeleteAssignedEngineerDetails, GetAllDocumentsForQA, RemoveRowsFromDocumentTable, InsertBillingScheduleClaimedDetail
} from './../store/actions/expediting.Actions';
import { uploadPaymentAcknowledgement, uploadFileGeneric, uploadFile, downloadFile, getDocumentVersions, GenericUploadVersionFile } from './../store/actions/fileActions';
import { getEngineeringMaster } from './../store/actions/masterActions';
import dateFormater from '../Classes/FormatDate'
import FormatDateTimeInIST from '../Classes/FormatDateTimeInIST'
import toast from 'react-hot-toast';
import DropdownFlat from '../Components/DropdownFlat'
import TableComp from '../Components/ReusableTable'
import FileVersionModal from '../Components/FileVersionModal';
// import GenericDocumentRevisePopUp from '../Components/GenericRevisePopUp';
import DocumentRejectPopUp from '../Components/DocumentRejectPopUp';
import DocumentCommentsPopUp from '../Components/DocumentCommentsPopUp';
import numberWithCommas from '../Classes/NumberwithComma'
import { GenericGetCommentsbyDocumentID, GenericPostCommentsbyDocumentID } from './../store/actions/documentCommentAction'
import DocumentCommentsByDocumentIdPopUp from '../Components/DocumentCommentsByDocumentIdPopUp';
import ProgressReportCommentsPopUp from '../Components/ProgressReportComments';
import Switch from "react-switch";
import CurrencyInput from 'react-currency-input-field';
import { setInvoicePaymentMedium, getAllInvoices, updateStatusForFinance, GetAllInvoicesForSupplier, InsertInvoiceDetails, GetInvoiceDetailsForAPteamApproval } from '../store/actions/invoiceActions';
import { InsertBillingScheduleDetails, getBillingScheduleDetails, GetGRNDetails, postGRNDetails } from '../store/actions/dispatchOrderDetailsActions'
import { CircularProgressbar, CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [day, month, year].join('-');
}

class ExpeditingApprovedPOAcceptance extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            text: "",
            headertitle: "",
            roles: AuthHandlerInstance.getRoles(),
            comments: "",
            PoNo: this.props.location.state.PoNo,
            checked: this.props.location.state.checked,
            selected: this.props.location.state.selected,
            commentsexpeditor: "",
            supplierName: "ABC Tech Inc.",
            DeliverScheduleModal: false,
            ApproveScheduleModal: false,
            datemodal: false,
            ReviseScheduleModal: false,
            assignmodal: false,
            modal: false,
            Docmodal: false,
            select: true,
            open: false,
            opacity: "",
            formattedData: [],
            multiCollapseIndex: "",
            poID: this.props.location.state.poId,
            LineItemID: this.props.location.state.lineItemID,
            serviceLineItemSAPId: this.props.location.state.serviceLineItemSAPId,
            Po: this.props.location.state.Po,
            // reviseForm: { file: [] },
            level: 0,
            engineeringData: [],
            engineer: "",
            DrawingDocID: "",
            DocumentTypeName: "",
            ExpeditingStatus: "",
            docStatus: {
                1: { title: "Document is Approved", badge: "badge-success", status: "Approved" },
                2: { title: "Document is Rejected", badge: "badge-danger", status: "Rejected" },
                3: { title: "Document sent for Revision to Supplier", badge: "badge-primary", status: "Sent for Revision" },
                4: { title: "Awaiting approval", badge: "badge-dark", status: "Awaiting" },
                0: { title: "Document Uploaded", badge: "badge-warning", status: "" },
                5: { title: "Approved As Noted", badge: "badge-info", status: "" },
                6: { title: "Document Sent For Approval", badge: "badge-warning", status: "" },
                null: { title: "Document to be Submitted", badge: "badge-warning", status: "" }
            },
            docStatus1: {
                1: { title: "Document is Forwarded", badge: "badge-success", status: "Approved" },
                2: { title: "Document is Rejected", badge: "badge-danger", status: "Rejected" },
                3: { title: "Document sent for Revision to Supplier", badge: "badge-primary", status: "Sent for Revision" },
                4: { title: "Awaiting approval", badge: "badge-dark", status: "Awaiting" },
                0: { title: "Document Uploaded", badge: "badge-warning", status: "" },
                5: { title: "Approved As Noted", badge: "badge-info", status: "" },
                6: { title: "Document Sent For Approval", badge: "badge-warning", status: "" },
                null: { title: "Document to be Submitted", badge: "badge-warning", status: "" }
            },
            TransmittalDocStatus: {
                0: { title: "Document Submitted", badge: "badge-warning", status: "" },
                1: { title: "Read", badge: "badge-success", status: "Read" },
            },
            approvalStatus: {
                approved: 1,
                rejected: 2,
                revise: 3
            },
            dropdowndata: [{ value: 1, transporter: "ABC " },
            { value: 2, transporter: "CDE " },
            { value: 3, transporter: "EFG " },
            ],
            files: {},
            selectedFile: [],
            expeditingDocumentDetails: [],
            allDocuments: [],
            allDocumentsDetails: {},
            actingRoles: {},
            Progressarray: [],
            Drawingarray: [],
            ExpectedDeliveryDate: "",
            SubmissionDueDate: "",
            newExpectedDeliveryDate: "",
            versionList: [],
            selectedFileVersion: [],
            selectedfilestageIdVersion: [],
            stageIdsVersion: [],
            fileUploadIds: [],
            uploadedId: "",
            revisedPayload: [],
            showRevisedPopUp: false,
            showRejectPopUp: false,
            uploadedfile: false,
            uploadID: 0,
            OpenVersionmodal: false,
            actionstatus: 0,
            reviseForm: {
                file: [],
                comment: ""
            },
            clearencefile: [],
            MCDocument: "",
            AssignedEngineerModal: false,
            assignedEnginnermodal: false,
            engineerList: [],
            editEngineerFlag: false,
            engineerUserID: [],
            addDrawingmodal: false,
            documentName: '',
            Drawingdetails: [],
            DrawingDetailID: "",
            DocumentCommentsByDocumentIdPopUpModal: false,
            varId: "",
            varPoLineId: "",
            varPoId: "",
            ClaimByName: "",
            ClaimByDate: "",
            vardocumentTypeId: "",
            vardrawingDocumentDetailId: "",
            ClaimById: 0,
            ClaimedByPlannerId: 0,
            transmittleDocumentName: '',
            addDocumentmodal: false,
            PoTransmittleDocumetDetails: [],
            transmittalFile: [],
            TPMData: [],
            activeEventKey: 0,
            progressReportDocuments: [],
            isSubmittedFlag: 0,
            fl: 0,
            allQADoc: [],
            QAInspectionDoc: [],
            showCommentPopUp: false,
            revisedPayload1: [],
            tpmList: [],
            editFlag: "",
            tpm: [],
            paymentTermDocuments: [],
            activeEventKey1: 10,
            showRevisedPopUpPayment: false,
            approvalDetailsByCPMorTPM: [],
            indicator: "",
            PoAnnexure: [],
            DrawingTransmittal: [],
            varIdPayment: "",
            varPoIdPayment: "",
            vardocumentTypeIdPayment: "",
            vardrawingDocumentDetailIdPayment: "",
            byPassEngineer: "Yes",
            byPassEngineerData: [
                { label: 'Yes', value: 'Yes' },
                { label: "No", value: "No" },
            ],
            ProgressReportCommentsPopUp: false,
            progressDocumentTypeId: "",
            ProgressPoId: "",
            ProgressLineId: "",
            checkedSwitch: false,
            switchValue: 0,
            checkedSwitchByApTeam: 0,
            paymentTermDocumentsPartial: [],
            approvalDetailsByCPMorTPMPartial: [],
            AcceptmodalForSupplierPartial: false,
            AcceptmodalPartial: false,
            paymentTermPartialDetails: {},
            AdvanceStageDocumentMappingIdPartial: "",
            dataFull: [],
            InvoiceDocumentId: "",
            invoiceDetails: [],
            dataFullForSupplier: [],
            BillingScheduleNo: "",
            addBillingScheduleDetails: false,
            billingScheduleDetails: [],
            polineItemTotalVale: 0,
            UnitPrice: 0,
            warningmodal: false,
            checkedBilling: false,
            billingScheduleRequiredDetails: 0,
            poLineItemDetails: {},
            GRNbyPOId: [],
            GRNDocNo: "",
            GRNModal: false,
            GRNTableData: [],
            InvoiceIdForGRN: 0,
            GRNDropDownData: [],
            infoValGRN: 0,
        }
        // this.dateformate = this.dateformate.bind(this);


        this.togglebutton = this.togglebutton.bind(this);
        this.deliverschedulemodal = this.deliverschedulemodal.bind(this);
        this.approveschedulemodal = this.approveschedulemodal.bind(this);
        this.reviseschedulemodal = this.reviseschedulemodal.bind(this);
        this.datemodal = this.datemodal.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.submitassignmodal = this.submitassignmodal.bind(this);
        this.assignmodal = this.assignmodal.bind(this);
        this.modal = this.modal.bind(this);
        this.Docmodal = this.Docmodal.bind(this);
        this.comments = this.comments.bind(this);
        this.DocumentCommentsByDocumentIdPopUpModal = this.DocumentCommentsByDocumentIdPopUpModal.bind(this);
        this.ProgressReportCommentsPopUp = this.ProgressReportCommentsPopUp.bind(this);
        this.AcceptmodalPartial = this.AcceptmodalPartial.bind(this);
        this.AcceptmodalForSupplierPartial = this.AcceptmodalForSupplierPartial.bind(this);
        this.documentRef = React.createRef()
        this.documentRef.current = []
    }



    action1() {
        this.setState({ action1: false });
    }

    togglebutton = (Index) => {

        var multiCollapseIndex = this.state.multiCollapseIndex

        if (multiCollapseIndex != Index || multiCollapseIndex == '') {
            this.setState({ multiCollapseIndex: Index })
        }
    }

    toggleSuccessModal(e) {
        this.setState({ modal: !this.state.modal });
        if (this.state.modal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    Docmodal(DocumentTypeId, DocumentTypeName, DrawingDetailID) {
        // console.log(DrawingDetailID, "DrawingDetailID")
        if (DocumentTypeId) {
            this.props.getAllDocumentsWithDetailsForExpediting(DocumentTypeId)
        }

        this.setState({ Docmodal: !this.state.Docmodal, DocumentTypeName, DrawingDetailID });
        if (this.state.Docmodal == true) {
            this.setState({ opacity: "" })
        }
        else {
            this.setState({ opacity: "0.2" })
        }
    }

    modal() {
        this.setState({ modal: !this.state.modal });
        if (this.state.DeliverScheduleModal == true) {
            this.setState({ DeliverScheduleModal: !this.state.DeliverScheduleModal });
        }
        if (this.state.ApproveScheduleModal == true) {
            this.setState({ ApproveScheduleModal: !this.state.ApproveScheduleModal });
        }
        if (this.state.ReviseScheduleModal == true) {
            this.setState({ ReviseScheduleModal: !this.state.ReviseScheduleModal });
        }
        if (this.state.assignmodal == true) {
            this.setState({ assignmodal: !this.state.assignmodal });
        }
        if (this.state.modal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }


    deliverschedulemodal() {
        this.setState({ DeliverScheduleModal: !this.state.DeliverScheduleModal });
        this.setState({ text: "The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been submitted successfully. " });
        this.setState({ headertitle: "Delivery Schedule Uploaded Successfully" });
        if (this.state.DeliverScheduleModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    approveschedulemodal() {
        this.setState({ ApproveScheduleModal: !this.state.ApproveScheduleModal });
        this.setState({ text: "The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been approved " });
        this.setState({ headertitle: "Delivery Schedule Approved Successfully" });
        if (this.state.ApproveScheduleModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    reviseschedulemodal() {
        this.setState({ ReviseScheduleModal: !this.state.ReviseScheduleModal });
        this.setState({ text: "The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been sent for revision " });
        this.setState({ headertitle: "Delivery Schedule sent for Revision" });
        if (this.state.ApproveScheduleModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    assignmodal() {
        console.log("in Assign")
        this.setState({ assignmodal: !this.state.assignmodal });
        // this. setState({text:"The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been approved and assigned an engineer successfully. "}) ;
        // this. setState({headertitle :"Successfully Assigned an Engineer"}) ;           
        if (this.state.assignmodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    handleComments = (e) => {
        this.setState({ comments: e.target.value })
        console.log(this.state.comments)
    }

    comments(event) {
        this.setState({ comments: event.target.value })
    }

    setDocumentName(event) {
        this.setState({ documentName: event.target.value })
        console.log(this.state.documentName)
    }
    setTransmittleDocumentName(event) {
        this.setState({ transmittleDocumentName: event.target.value })
        console.log(this.state.transmittleDocumentName)
    }

    // ? adds drawing to the drawing list
    addDrawingtoList = async (flag) => {
        console.log(flag, "|||||||||||||||||||||||||||")
        // return false
        if (flag == 1) {
            if (this.state.documentName == "") {
                swal("Please enter a valid document name", { icon: "error" })
                return false;
            }
            // ? inserting new document in the progress list
            await this.props.ApproveDrawingDocuments({
                PoId: this.state.poID,
                PoLineItemId: this.state.LineItemID,
                DocumentTypeName: this.state.documentName,
                DocumentTypeId: 102,
            })
        } else {
            if (this.state.documentName == "") {
                swal("Please enter a valid document name", { icon: "error" })
                return false;
            }
            // ? inserting new document in the drawing list
            await this.props.ApproveDrawingDocuments({
                PoId: this.state.poID,
                PoLineItemId: this.state.LineItemID,
                DocumentTypeName: this.state.documentName
            })
        }

        // ? setting the document name input to blank
        this.setState({
            documentName: ''
        })

        // ? syncing data
        this.dataSync()
        // ? closing modal
        this.addDrawingInputmodal()
    }
    // ? adds drawing to the drawing list
    addDocumentstoList = async () => {
        if (this.state.transmittleDocumentName == "") {
            swal("Please enter a valid document name", { icon: "error" })
            return false;
        }
        // ? inserting new document in the drawing list
        await this.props.postPoTransmittleDocumnetDtails({
            PoId: this.state.poID,
            DocumentTypeName: this.state.transmittleDocumentName
        })

        // ? setting the document name input to blank
        this.setState({
            transmittleDocumentName: ''
        })

        // ? syncing data
        this.dataSync()
        // ? closing modal
        this.addDocumentmodal()
    }

    handleCommentsExpeditor = (e) => {
        this.setState({ commentsexpeditor: e.target.value })
        console.log(this.state.commentsexpeditor)
    }

    // ? handle file input
    // ? handle file input
    handleFileInput(event, rowData) {
        console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 170 ~ Dashboard ~ handleFileInput ~ rowData", rowData)
        console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 170 ~ Dashboard ~ handleFileInput ~ event", event)
        // console.log(event, rowData, "file input")
        this.setState({ selectedFile: [], files: [] })
        let fileList = [...this.state.selectedFile];
        let fileObjList = this.state.files
        fileObjList[rowData.DocumentTypeId] = {
            fileInfo: event.target.files[0],
            documentTypeId: rowData.DocumentTypeId
        }
        fileList.push(event.target.files[0])
        this.setState({ selectedFile: fileList, files: fileObjList })
        console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 176 ~ Dashboard ~ handleFileInput ~ fileList", this.state.selectedFile, this.state.files)


    }

    handleDeliveryFileInput = (event) => {
        let reviseForm = this.state.reviseForm

        reviseForm.file.push(event.target.files[0])
        this.setState({ reviseForm });
        // console.log(this.state.reviseForm, 'file dekh')
    }

    // ? handle Delivery Schedule submission
    modalSubmit = async () => {
        if (this.state.reviseForm.file.length < 1) {
            swal("Please upload some valid document", { icon: "error" })

            return false;
        }
        swal("Document is uploading...", { button: false, icon: "info" })
        var result = await this.props.uploadPaymentAcknowledgement(this.state.reviseForm.file)

        var params = {}
        var inputComments = {}
        if (result.results[0].VersionId && result.results[0].DocumentId) {
            params = {
                POId: this.state.poID,
                PoLineItemId: this.state.LineItemID,
                Documentid: result.results[0].DocumentId,
                versionId: result.results[0].VersionId,
            }
            console.log(params)
            inputComments = {
                Comments: this.state.comments,
                POId: this.state.poID,
                PoLineItemId: this.state.LineItemID,
                UserId: AuthHandlerInstance.getUserID(),
            }
            await this.props.postDeliveryScheduleDetails(params)
            // await this.props.postCommentsForPOs(inputComments)
        }
        else
            swal("Please Upload Delivery Schedule before submit", { icon: "error" })
        // window.location.reload()
        this.deliverschedulemodal()
        // this.modal()
    }

    handleengineer = (e) => {
        console.log(e, "kkk")
        this.setState({ engineer: e })
    }
    handletpm = (e) => {
        console.log(e, "kkk")
        this.setState({ tpm: e })
    }

    submitassignmodal = async (poId, lineItemId, documentTypeId, approvalId, documentName, documentStatus) => {

        var user = AuthHandlerInstance.getUserPayLoad()
        var approvedBy = user.userId
        var approvedByName = user.fullName
        var approvedOn = new Date()
        var roleId = user.roles[0]

        console.log(this.state.editEngineerFlag, "tanmoy")
        // return false

        this.state.engineer.map(async (engineer) => {

            var params = {
                DrawingDocumentDetailsId: this.state.DrawingDocID,
                POId: poId,
                POLineItemId: lineItemId,
                RoleId: roleId,
                UserId: engineer.value,
            }
            var paramsForEdit = {
                PoId: poId,
                DocumentTypeId: this.state.editDocType,
                PoLineId: lineItemId,
                RoleId: roleId,
                updatedEngineerId: engineer
            }
            if (this.state.editEngineerFlag) {
                await this.props.UpdateEngineerAssignment(paramsForEdit)
            } else {
                await this.props.PostAssignedEngineerDetails(params)
            }
        })

        var new_params = {
            DrawingDocumentDetailsId: this.state.DrawingDocID,
            POId: poId,
            DocumentTypeId: 86,
            approvedBy: approvedBy,
            approvalStatus: approvalId,
            approvedByName: approvedByName,
            approvedOn: approvedOn,
            POLineItemId: lineItemId,
            RoleId: roleId,
            countAssignment: this.state.engineer.length
            // EngineerId: engineer.value,
        }
        if (!this.state.editEngineerFlag) {
            await this.props.approveDocumentsForExpediting(new_params)
        }

        // console.log(params, paramsForEdit, 'params vs params')
        var inputComments = {
            Comments: this.state.comments,
            POId: poId,
            PoLineItemId: lineItemId,
            UserId: AuthHandlerInstance.getUserID(),
        }
        // console.log(inputComments,"Comments")
        // console.log(params)

        // ? fetching uploaded document details
        await this.props.getDocumentDetailsForExpediting(this.state.poID, this.state.LineItemID)

        //? posting comments
        await this.props.postCommentsForPOs(inputComments)
        toast.success(`${documentName} ${documentStatus}`);

        this.setState({ editEngineerFlag: false })
        // this.assignmodal()
        this.dataSync()
    }

    handleApproval = async (poId, lineItemId, documentTypeId, approvalId, documentName, documentStatus, drawingdocID) => {

        toast.loading('Uploading Files...', {
            duration: 1000
        });
        // ? params
        // * POid, documentTypeId, approvalStatus, approvedBy, approvedByName, approvedOn
        // console.log(poId, documentTypeId, approvalId, documentName, documentStatus, "approval data")
        var user = AuthHandlerInstance.getUserPayLoad()
        // console.log(user, 'user data')
        var approvedBy = user.userId
        var approvedByName = user.fullName
        var approvedOn = new Date()
        var roleId = user.roles[0]

        var params = {
            DrawingDocumentDetailsId: drawingdocID,
            POId: poId,
            DocumentTypeId: documentTypeId,
            approvedBy: approvedBy,
            approvalStatus: approvalId,
            approvedByName: approvedByName,
            approvedOn: approvedOn,
            POLineItemId: lineItemId,
            RoleId: roleId
        }
        // console.log(drawingdocID,this.state.revisedPayload.param.DrawingDocumentDetailsid,"HOLA")
        // return false
        if (roleId == 12 && approvalId == 1) {
            if (this.props.expediting.getAllAssignedEngineerDetails.recordset.filter((elem) => elem.approvalStatus == 1 && elem.DrawingDocumentDetailsId == this.state.revisedPayload.param.DrawingDocumentDetailsid).length > 0) {
                await this.props.approveDocumentsForExpediting(params)
            }
            else if (this.state.revisedPayload.param.DrawingDocumentDetailsid) {
                await this.setState({ DrawingDocID: drawingdocID })
                await this.submitassignmodal(this.props.poDetails.poDetails.poId, this.state.LineItemID, "", this.state.approvalStatus.approved, "", this.state.docStatus['1'].status)
            }
            else {
                await this.props.approveDocumentsForExpediting(params)
            }
        }
        else if (roleId == 7 && approvalId == 1) {
            if (this.state.revisedPayload.param.DrawingDocumentDetailsid) {
                await this.setState({ DrawingDocID: drawingdocID })
                await this.submitassignmodal(this.props.poDetails.poDetails.poId, this.state.LineItemID, "", this.state.approvalStatus.approved, "", this.state.docStatus['1'].status)
            }
            else {
                await this.props.approveDocumentsForExpediting(params)
            }
        }

        else {
            // ? approving documents
            await this.props.approveDocumentsForExpediting(params)

            // ? fetching uploaded document details
            await this.props.getDocumentDetailsForExpediting(this.state.poID, this.state.LineItemID)
            toast.success(`${documentName} ${documentStatus}`);

        }
        this.dataSync()
    }

    datemodal() {
        this.setState({ datemodal: !this.state.datemodal });

        if (this.state.datemodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    addDrawingInputmodal(fl) {
        this.setState({ addDrawingmodal: !this.state.addDrawingmodal, fl: fl });

        if (this.state.addDrawingmodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    addDocumentmodal(indicator) {
        this.setState({ addDocumentmodal: !this.state.addDocumentmodal, indicator });

        if (this.state.addDocumentmodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    addBillingScheduleDetails() {
        this.setState({ addBillingScheduleDetails: !this.state.addBillingScheduleDetails });
        if (this.state.addBillingScheduleDetails == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    OpenAssignedEngineerModal = async (status, docTypeID, editFlag) => {
        // if(status==false){
        //     this.setState({versionList:[],uploadedId:"",AssignedEngineerModal:false});
        //     this.props.OpenVersionModal(null);
        // }

        await this.props.GetAssignedEngineers(this.state.poID, this.state.LineItemID, docTypeID)
        this.setState({ AssignedEngineerModal: !this.state.AssignedEngineerModal, engineerList: this.props.expediting.getAssignedEngineerDetails.recordset.filter(item => item.GroupId == 24), tpmList: this.props.expediting.getAssignedEngineerDetails.recordset.filter(item => item.GroupId == 19), editDocType: docTypeID, editFlag });
        console.log(this.state.tpmList, this.state.editFlag, "NNNNNNNNNNNNNNNNNN")
        if (this.state.assignedEnginnermodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    handleExpectedDeliveryDate(e) {
        console.log(e.target.value)
        this.setState({ ExpectedDeliveryDate: e.target.value })
    }

    handleSubmissionDueDate(e) {
        console.log(e.target.value)
        this.setState({ SubmissionDueDate: e.target.value })
    }
    approvalmodalsubmit = async () => {
        var roles = Object.keys(AuthHandlerInstance.getRoles())[0]
        var params = {
            POId: this.state.poID,
            POLineItemId: this.state.LineItemID,
            IsApproved: 1,
            ExpectedDeliveryDate: this.state.ExpectedDeliveryDate ? this.state.ExpectedDeliveryDate : null,
            DocumentSubmissionDueDate: this.state.SubmissionDueDate ? this.state.SubmissionDueDate : null,
            roleId: roles
        }
        // console.log(params)
        await this.props.updateDeliveryScheduleDetails(params)
        if (roles == 7) {
            this.approveschedulemodal()
        }
        await this.dataSync()
    }

    // ? PO data loading
    dataSync = async () => {
        // console.log(this.state.poID,this.state.LineItemID,"JJJJJJJJJJ")

        var roles = Object.keys(AuthHandlerInstance.getRoles())[0]
        var user = AuthHandlerInstance.getUserID()
        await this.props.getAllDocumentsWithDetailsForExpediting(86)
        await this.props.GetAllDetailsOfPoUploadedForDS(user)
        await this.props.getPODetails(this.state.poID)
        await this.props.GetPaymentTermDetailByPOId(this.state.poID)
        await this.props.GetClaimDetailsByPoId(this.state.poID)
        await this.props.getPaymentTermDocuments(this.state.poID)
        await this.props.GetDocumentsForAdvance(this.state.poID)
        await this.props.PaymentTermDocumentsApprovalByPMs(this.state.poID)
        await this.props.GetGRNDetails(this.state.poID)
        await this.props.getBillingScheduleDetails(this.state.LineItemID)
        var billingScheduleDetails = []
        let polineItemTotalVale = 0
        let UnitPrice = 0
        let GRNbyPOId = await this.props.dispatchOrderDetailsReducer.getGRNdata.recordset
        let GRNDropDownData = []
        GRNbyPOId.map((data) => {
            if (data.GRNDocumentId == null && !GRNDropDownData.find(elem => elem.value == data.GRNDocNo && elem.GRNDocumentId == null)) {
                GRNDropDownData.push({ label: data.GRNDocNo, value: data.GRNDocNo })
            }
        })
        let polineItemDetailsForBillingSchedule = await this.props.poDetails.paymentTermDetailsByPoId.lineItems.filter((data) => data.poLineItemId == this.state.LineItemID)
        // console.log("polineItemDetailsForBillingSchedule",polineItemDetailsForBillingSchedule[0].NetPrice,polineItemDetailsForBillingSchedule[0].NetValue)
        console.log('-----------', this.props.expediting)
        polineItemTotalVale = polineItemDetailsForBillingSchedule.length ? polineItemDetailsForBillingSchedule[0].NetValue : 0
        UnitPrice = polineItemDetailsForBillingSchedule.length ? polineItemDetailsForBillingSchedule[0].NetPrice : 0
        await this.setState({ polineItemTotalVale, UnitPrice, GRNbyPOId, GRNDropDownData })
        try {
            billingScheduleDetails = await this.props.dispatchOrderDetailsReducer.getBillingScheduleDetails.recordset
            await this.setState({ billingScheduleDetails })
        } catch (e) { console.log(e) }
        var approvalDetailsByCPMorTPM = []
        var approvalDetailsByCPMorTPMPartial = []
        try {
            if (this.props.poDetails && this.props.poDetails.paymentTermApprovalByCPMandTPM && this.props.poDetails.paymentTermApprovalByCPMandTPM.recordsets && this.props.poDetails.paymentTermApprovalByCPMandTPM.recordsets.length > 0) {
                approvalDetailsByCPMorTPM = await this.props.poDetails.paymentTermApprovalByCPMandTPM.recordset
                approvalDetailsByCPMorTPMPartial = await this.props.poDetails.paymentTermApprovalByCPMandTPM.recordsets[1]
                await this.setState({ approvalDetailsByCPMorTPM, approvalDetailsByCPMorTPMPartial })
                console.log(this.state.approvalDetailsByCPMorTPM, approvalDetailsByCPMorTPMPartial, "PPPPPP")
            }
        } catch (e) { }
        var paymentTermDocuments = []
        var paymentTermDocumentsPartial = []
        var paymentTermPartialDetails = {}
        let ConterData = []
        let GRNData = []
        try {
            if (this.props.poDetails && this.props.poDetails.paymentTermDocuments && this.props.poDetails.paymentTermDocuments.recordsets && this.props.poDetails.paymentTermDocuments.recordsets.length > 0) {

                await this.props.poDetails.paymentTermDocuments.recordset.map((item) => {
                    if (!paymentTermDocuments.find(data => data.PaymentTypeId == item.PaymentTypeId && data.TypeFor == item.TypeFor
                        && (item.PaymentTypeId == 1 || item.InvoiceId == data.InvoiceId))) {
                        let ApprovalDepartments = []
                        this.props.poDetails.paymentTermDocuments.recordset.filter(element => element.PaymentTypeId == item.PaymentTypeId && element.TypeFor == item.TypeFor && (item.PaymentTypeId == 1 || item.InvoiceId == element.InvoiceId)).map(data => {
                            if (data.DocumentTypeId !== 40) { //to exclude order acceptance from approval matrix
                                if (ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId)) {
                                    // total Approval count
                                    ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).TotalApprovalCount = ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).TotalApprovalCount + 1

                                    if (data.approvalStatus == 1) { // total approved count
                                        ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).ApprovedCount = ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).ApprovedCount + 1
                                    }
                                } else {
                                    ApprovalDepartments.push({
                                        "ActingDeptGroupId": data.ActingDeptGroupId,
                                        "TotalApprovalCount": 1,
                                        "ShortDeptName": data.ShortDeptName,
                                        "ApprovedCount": data.approvalStatus == 1 ? 1 : 0
                                    })
                                }
                            }
                        })
                        if (item.PaymentTypeId == 3) {
                            GRNData = this.state.GRNbyPOId.filter(elem => elem.InvoiceId == item.InvoiceId)
                        }
                        paymentTermDocuments.push({
                            "PaymentTypeId": item.PaymentTypeId,
                            "PaymentType": item.PaymentTypeName,
                            "TypeFor": item.TypeFor,
                            "Counter": item.Counter,
                            "InvoiceId": item.InvoiceId,
                            "InvoiceAmount": item.InvoiceAmount,
                            "Currency": item.Currency,
                            "Documents": this.props.poDetails.paymentTermDocuments.recordset.filter(element =>
                                element.PaymentTypeId == item.PaymentTypeId && element.TypeFor == item.TypeFor && (item.PaymentTypeId == 1 || item.InvoiceId == element.InvoiceId)
                            ),
                            "ApprovalDepartments": ApprovalDepartments,
                            "GRN": GRNData
                        })
                    }
                })
                if (this.props.poDetails.paymentTermDocuments.recordsets[2].length > 0) {
                    await this.props.poDetails.paymentTermDocuments.recordsets[1].map(async (item) => {
                        ConterData = this.props.poDetails.paymentTermDocuments.recordsets[2].filter(element =>
                            element.PaymentType == item.PaymentTypeId && element.TypeFor == item.TypeFor
                        )
                        ConterData.map(el => {
                            console.log(el, "IIIIIIIII")
                            let ApprovalDepartments = []
                            this.props.poDetails.paymentTermDocuments.recordsets[3].filter(elem => elem.Counter == el.Counter && elem.TypeFor == item.TypeFor && elem.PaymentType == item.PaymentTypeId).map(data => {
                                if (data.ActingDeptGroupId !== null && data.DocumentTypeId !== 40) { //to exclude order acceptance from approval matrix
                                    if (ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId)) {
                                        ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).TotalApprovalCount = ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).TotalApprovalCount + 1

                                        if (data.approvalStatus == 1) { // total approved count
                                            ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).ApprovedCount = ApprovalDepartments.find(element => element.ActingDeptGroupId === data.ActingDeptGroupId).ApprovedCount + 1
                                        }
                                    } else {
                                        ApprovalDepartments.push({
                                            "ActingDeptGroupId": data.ActingDeptGroupId,
                                            "TotalApprovalCount": 1,
                                            "ShortDeptName": data.ShortDeptName,
                                            "ApprovedCount": data.approvalStatus == 1 ? 1 : 0
                                        })
                                    }
                                }
                            })
                            paymentTermDocumentsPartial.push({
                                "PaymentTypeId": item.PaymentTypeId,
                                "PaymentType": item.PaymentTypeName,
                                "TypeFor": item.TypeFor,
                                "Counter": el.Counter,
                                "PoId": el.PoId,
                                "Documents": this.props.poDetails.paymentTermDocuments.recordsets[3].filter(elem => elem.Counter == el.Counter && elem.TypeFor == item.TypeFor && elem.PaymentType == item.PaymentTypeId),
                                "ApprovalDepartments": ApprovalDepartments,
                                "Documents": this.props.poDetails.paymentTermDocuments.recordsets[3].filter(elem => elem.Counter == el.Counter && elem.TypeFor == item.TypeFor && elem.PaymentType == item.PaymentTypeId)
                            })
                        })
                        this.props.poDetails.paymentTermDocuments.recordsets[3].map(elem => {
                            paymentTermPartialDetails[elem.AdvanceStageDocumentMappingIdPartial] = elem
                        })
                    })
                }

                await this.setState({ paymentTermDocuments, paymentTermDocumentsPartial, paymentTermPartialDetails })
            }
        } catch (e) { }
        if (this.props.expediting && this.props.expediting.getClaimDetailsByPoId && this.props.expediting.getClaimDetailsByPoId.recordsets && this.props.expediting.getClaimDetailsByPoId.recordsets.length > 0) {
            var ClaimByName = this.props.expediting.getClaimDetailsByPoId.recordset[0].ClaimBy
            var ClaimByDate = this.props.expediting.getClaimDetailsByPoId.recordset[0].ClaimedOn
            var ClaimById = this.props.expediting.getClaimDetailsByPoId.recordset[0].UserId
            var ClaimedByPlannerId = this.props.expediting.getClaimDetailsByPoId.recordset[0].ClaimedByPlannerId
            var billingScheduleRequiredDetails = 0
            if (this.props.expediting.getClaimDetailsByPoId.recordsets[1] && this.props.expediting.getClaimDetailsByPoId.recordsets[1].length > 0) {
                billingScheduleRequiredDetails = await this.props.expediting.getClaimDetailsByPoId.recordsets[1].find(data => data.poLineITemId == this.state.LineItemID) ? this.props.expediting.getClaimDetailsByPoId.recordsets[1].filter(data => data.poLineITemId == this.state.LineItemID)[0].isRequired : 0
            }
            console.log("ccccccc", this.props.expediting)
            console.log("billingScheduleRequiredDetails", ClaimByName, ClaimByDate, ClaimById, ClaimedByPlannerId, billingScheduleRequiredDetails)
            await this.setState({ ClaimByName, ClaimByDate, ClaimById, ClaimedByPlannerId, billingScheduleRequiredDetails })
        }
        await this.props.GetAllDocumentsForQA(this.state.poID, this.state.LineItemID)
        try {
            if (this.props.expediting && this.props.expediting.getDocumentsfromQA && this.props.expediting.getDocumentsfromQA.recordsets && this.props.expediting.getDocumentsfromQA.recordsets.length > 0) {
                var allQADoc = await this.props.expediting.getDocumentsfromQA.recordsets[0]
                var QAInspectionDoc = await this.props.expediting.getDocumentsfromQA.recordsets[1]
                await this.setState({ allQADoc, QAInspectionDoc })
                console.log(this.state.allQADoc, "QA DOC")
                console.log(this.state.QAInspectionDoc, "QA DOC")
            }
        } catch {
        }
        try {
            await this.props.GetDocumentApprovalDetailsForExpediting(this.state.poID, this.state.LineItemID)
            if (this.props.expediting && this.props.expediting.expDocumentApprovalDetails && this.props.expediting.expDocumentApprovalDetails.recordset && this.props.expediting.expDocumentApprovalDetails.recordset.length > 0) {
                var result = this.props.expediting.expDocumentApprovalDetails.recordset[this.props.expediting.expDocumentApprovalDetails.recordset.length - 1]
                var level = result.LevelId ? result.LevelId : 0
                this.setState({ level })
            }
            await this.props.getEngineeringMaster()
            var engineeringData = []
            var TPMData = []
            if (this.props.masterReducer && this.props.masterReducer.engineeringMaster && this.props.masterReducer.engineeringMaster.recordsets && this.props.masterReducer.engineeringMaster.recordsets.length > 0) {
                this.props.masterReducer.engineeringMaster.recordsets[0].map(ele => {
                    engineeringData.push({ label: ele.FullName, value: ele.UserId })
                })
                this.props.masterReducer.engineeringMaster.recordsets[1].map(ele => {
                    TPMData.push({ label: ele.FullName, value: ele.UserId })
                })
                this.setState({ engineeringData, TPMData })
            }
            await this.props.getExpeditingStatusIdForPolineItems(this.state.poID, this.state.LineItemID)
            if (this.props.expediting && this.props.expediting.getExpeditingStatusId && this.props.expediting.getExpeditingStatusId.recordset.length > 0) {
                var ExpeditingStatus = this.props.expediting.getExpeditingStatusId.recordset[0].ExpeditingStatusId
                var DocumentSubmissionDueDate = this.props.expediting.getExpeditingStatusId.recordset[0].DocumentSubmissionDueDate
                var ExpectedDeliveryDate = this.props.expediting.getExpeditingStatusId.recordset[0].ExpectedDeliveryDate
                var DocumentId = this.props.expediting.getExpeditingStatusId.recordset[0].DocumentId
                var isSubmittedFlag = this.props.expediting.getExpeditingStatusId.recordset[0].isAllDocSubmitted
                this.setState({ ExpeditingStatus, ExpectedDeliveryDate, DocumentSubmissionDueDate, MCDocument: DocumentId, isSubmittedFlag })
            }

            await this.props.GetDrawingDocumentApprovalDetails(this.state.poID, this.state.LineItemID)
            if (this.props.expediting && this.props.expediting.getDrawingActionDetails) {
                var Drawingdetails = await this.props.expediting.getDrawingActionDetails
                await this.setState({ Drawingdetails })
            }
            await this.props.GetTransmittalDocumentDetails()
            var PoAnnexure = []
            var DrawingTransmittal = []
            console.log(this.props.expediting.getPoTransmittleDOcuments, "llllllllllll")
            try {
                if (this.props.expediting && this.props.expediting.getPoTransmittleDOcuments) {
                    PoAnnexure = await this.props.expediting.getPoTransmittleDOcuments.filter((elem) => (elem.POId === 0 || elem.POId === this.state.poID) && elem.Indicator == 1)
                    DrawingTransmittal = await this.props.expediting.getPoTransmittleDOcuments.filter((elem) => elem.POId === this.state.poID && elem.Indicator == 2)
                    await this.setState({ PoAnnexure, DrawingTransmittal })
                }
            } catch (e) { }
            if (roles == 17 || roles == 12 || roles == 7) {
                // await this.props.GetNextActedUserId(this.state.level,86,this.state.LineItemID)
                // if (this.props.expediting && this.props.expediting.getNextActedUserId && this.props.expediting.getNextActedUserId.recordset.length > 0 ) {
                //     this.props.expediting.getNextActedUserId.recordset.map(elem=>{
                //         this.state.engineerUserID.push(elem.ActedId)
                //         this.setState({engineerUserID: this.state.engineerUserID})
                //     })

                // }
                var arrengineerdata = {}
                await this.props.GetAssignedEngineerDetails(this.state.poID, this.state.LineItemID)
                if (this.props.expediting && this.props.expediting.getAllAssignedEngineerDetails && this.props.expediting.getAllAssignedEngineerDetails.recordset.length > 0) {
                    console.log(this.props.expediting.getAllAssignedEngineerDetails.recordset, "CBm")
                    this.props.expediting.getAllAssignedEngineerDetails.recordset.map(elem => {
                        if (elem.UserId == user) {
                            arrengineerdata[elem.DrawingDocumentDetailsId] = elem

                        }
                    })
                    console.log(arrengineerdata, "arrengineerdata")
                    this.setState({ engineerUserID: arrengineerdata })

                }
            }
        }
        catch (e) { }
        await this.props.GetNextActedRoleIdForApproval(this.state.level)
        if (this.props.expediting && this.props.expediting.expeditingDocumentDetails && this.props.expediting.expeditingDocumentDetails != null) {
            var actingRoles = this.props.expediting.nextActedTeam
            this.setState({ actingRoles })
        }
        await this.props.getDocumentDetailsForExpediting(this.state.poID, this.state.LineItemID)
        if (this.props.expediting && this.props.expediting.expeditingDocumentDetails && this.props.expediting.expeditingDocumentDetails != null) {
            var allDocumentsDetails = this.props.expediting.expeditingDocumentDetails
            this.setState({ allDocumentsDetails })
            console.log(this.state.allDocumentsDetails, "{{{{{{{{{{{")
        }
        await this.props.getAllDocumentsForExpediting()
        if (this.props.expediting && this.props.expediting.expeditingDocuments && this.props.expediting.expeditingDocuments.recordset.length > 0) {
            var allDocuments = this.props.expediting.expeditingDocuments.recordset
            this.setState({ allDocuments })
        }
        await this.props.getAllDrawingDocuments({ PoId: this.state.poID, PoLineItemId: this.state.LineItemID })
        if (this.props.expediting && this.props.expediting.expeditingDrawingDocuments && this.props.expediting.expeditingDrawingDocuments.recordset.length > 0) {
            var Drawingarray = this.props.expediting.expeditingDrawingDocuments.recordset.filter(item => item.DocumentTypeId == 86)
            console.log(Drawingarray, "DrawingarrayD")
            var Progressarray = this.props.expediting.expeditingDrawingDocuments.recordset.filter(item => item.DocumentTypeId == 102)
            this.setState({ Drawingarray, Progressarray })
        }

        await this.props.GetProgressReportDocuments(this.state.LineItemID)
        if (this.props.expediting && this.props.expediting.getProgressReport && this.props.expediting.getProgressReport.recordset.length > 0) {
            var progressReportDocuments = this.props.expediting.getProgressReport.recordset
            this.setState({ progressReportDocuments })
        }
        let poLineItemDetails = await this.props.poDetails.poDetails.lineItems.find(elem => elem.poLineItemId === this.state.LineItemID)
        await this.setState({ engineer: [], tpm: [], byPassEngineer: 'Yes', poLineItemDetails })
    }

    // ? for revise action
    revisePopUpAction = (reviseParam, popUpStatus, refreshPage, uploadId, actionstatus) => {

        console.log(reviseParam, popUpStatus, refreshPage, uploadId, actionstatus, "reviseParam")

        this.setState({ revisedPayload: reviseParam, showRevisedPopUp: popUpStatus, uploadID: uploadId, actionstatus });
        if (refreshPage) {
            this.dataSync()
        }
    }

    // ? for revise reupload action from supplier
    reviseAction = async (reviseParam, popUpStatus, refreshPage, uploadId, e) => {

        await this.setState({ revisedPayload: reviseParam, showRevisedPopUp: popUpStatus, uploadID: uploadId })
        if (e) {
            await this.handleFileInputforRevision(e)
        }

    }

    // ? for reject action
    rejectPopUpAction = (reviseParam, popUpStatus, refreshPage) => {

        this.setState({ revisedPayload: reviseParam, showRejectPopUp: popUpStatus });
        if (refreshPage) {
            this.dataSync()
        }
    }

    handlerequestclearence = async () => {
        console.log("manufactering clearence= ", this.state.ExpeditingStatus, this.state.poID, this.state.LineItemID)
        var status = parseInt(this.state.ExpeditingStatus) + 1
        await this.props.UpdateStatusForExpediting(this.state.poID, this.state.LineItemID, status)
        this.dataSync()
    }

    handleFileInputclearence(e) {
        this.setState({ clearencefile: e.target.files[0] })
    }

    handleuploadclearence = async () => {
        var result = await this.props.uploadFileGeneric([this.state.clearencefile], AuthHandlerInstance.getUserID())

        var out_result = result.results
        console.log(out_result)
        out_result.map(async (elem) => {
            var status = parseInt(this.state.ExpeditingStatus) + 1
            await this.props.UpdateStatusForExpediting(this.state.poID, this.state.LineItemID, status, elem.DocumentId)
        })

        this.dataSync()
    }

    componentDidMount() {
        // this.props.GenericGetCommentsbyDocumentID(1,1,101)
        this.dataSync()
        // setTimeout(function(){ this.refreshData() }.bind(this), 30000);
    }
    refreshData() {
        this.dataSync()
        setTimeout(function () { this.refreshData() }.bind(this), 30000);
    }
    // ? open version modal
    async OpenVersionModal(uploadedId) {
        let versionList = [];

        //
        // if(this.state.OpenVersionModal ==false){
        //     this.setState({opacity:"0.2"})
        // }else{
        //     this.setState({opacity:""})
        // }
        let stateVal = this.state.OpenVersionmodal;
        this.setState({ OpenVersionmodal: !stateVal, uploadedId: uploadedId });

    }

    editEngineerAssignment = async (engineerDetails) => {
        console.log(engineerDetails, 'engineerDetails')
        this.setState({ AssignedEngineerModal: !this.state.AssignedEngineerModal, editEngineerFlag: true });
        this.assignmodal()
    }

    formSaveAction = async (flag) => {
        var userId = AuthHandlerInstance.getUserID()
        console.log(this.state.revisedPayload)
        if (this.state.revisedPayload.actionType == "Supplier Documents partial") {
            if (this.state.reviseForm.file.length < 1 && this.state.reviseForm.comment == "") {
                if (this.state.actionstatus == 1) {
                    await this.handleApprovalPartial(this.state.revisedPayload.param.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.approved, this.state.revisedPayload.param, this.state.invoiceDetails)
                }
                else { await this.handleApprovalPartial(this.state.revisedPayload.param.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.revise, this.state.revisedPayload.param, this.state.invoiceDetails) }
                await this.revisePopUpAction(false);
            }
            else {
                // only comment
                if (this.state.reviseForm.file.length < 1) {

                    let input = {
                        Comment: this.state.reviseForm.comment,
                        RoleId: parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]),
                        GroupId: parseInt(Object.keys(AuthHandlerInstance.getGroups())[0]),
                        UserId: AuthHandlerInstance.getUserID(),
                        DocumentId: this.state.uploadID,
                        PoId: this.props.poDetails.paymentTermDetailsByPoId.poId,
                        PoLineItemId: 0,
                        rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        indicatorForComments: 1
                    }
                    console.log(input, "#####")
                    await this.props.GenericPostCommentsbyDocumentID(input)
                    if (this.state.actionstatus == 1) {
                        await this.handleApprovalPartial(this.state.revisedPayload.param.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.approved, this.state.revisedPayload.param, this.state.invoiceDetails)

                    }
                    else { await this.handleApprovalPartial(this.state.revisedPayload.param.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.revise, this.state.revisedPayload.param, this.state.invoiceDetails) }
                    await this.revisePopUpAction(false);
                }
                //only file
                else {
                    console.log(this.state.revisedPayload, 'payload')

                    // swal("Saving...", { icon: "info", button: false });
                    let comments = [this.state.reviseForm.comment];
                    let input = {
                        Comment: this.state.reviseForm.comment,
                        RoleId: parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]),
                        GroupId: parseInt(Object.keys(AuthHandlerInstance.getGroups())[0]),
                        UserId: AuthHandlerInstance.getUserID(),
                        DocumentId: this.state.revisedPayload.param.DocumentId,
                        PoId: this.props.poDetails.paymentTermDetailsByPoId.poId,
                        PoLineItemId: 0,
                        rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        indicatorForComments: 1
                    }
                    console.log(input, "#####")
                    await this.props.GenericPostCommentsbyDocumentID(input)
                    await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.uploadID, comments, AuthHandlerInstance.getUserID());
                    if (this.state.actionstatus == 1) {
                        await this.handleApprovalPartial(this.state.revisedPayload.param.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.approved, this.state.revisedPayload.param, this.state.invoiceDetails)
                    }
                    else {
                        await this.handleApprovalPartial(this.state.revisedPayload.param.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.revise, this.state.revisedPayload.param, this.state.invoiceDetails)
                    }
                }
                let reviseForm = {
                    comment: "",
                    file: ""
                }
                await this.revisePopUpAction(false);
                await this.setState({ reviseForm })
            }
        } else {
            if (this.state.revisedPayload.actionType == "Supplier Documents-New Version") {
                let DocumentName = ""
                if (this.state.revisedPayload.param.DocumentName) {
                    DocumentName = this.state.revisedPayload.param.DocumentName
                }
                if (this.state.revisedPayload.param.DocumentTypeName) {
                    DocumentName = this.state.revisedPayload.param.DocumentTypeName
                }
                //no comment no file
                if (this.state.reviseForm.file.length < 1 && this.state.reviseForm.comment == "") {
                    if (flag == 1) {
                        this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.revisedPayload.param.DocumentTypeId, 0, DocumentName, this.state.docStatus[this.state.actionstatus].status, this.state.revisedPayload.param.DrawingDocumentDetailsid)
                    } else {
                        this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.revisedPayload.param.DocumentTypeId, this.state.actionstatus, DocumentName, this.state.docStatus[this.state.actionstatus].status, this.state.revisedPayload.param.DrawingDocumentDetailsid)
                    }
                    this.revisePopUpAction(false);
                }
                else {
                    // only comment
                    if (this.state.reviseForm.file.length < 1) {

                        var roles = AuthHandlerInstance.getRoles()
                        let input = {
                            Comment: this.state.reviseForm.comment,
                            RoleId: parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]),
                            GroupId: parseInt(Object.keys(AuthHandlerInstance.getGroups())[0]),
                            UserId: AuthHandlerInstance.getUserID(),
                            DocumentId: this.state.uploadID,
                            PoId: this.props.poDetails.poDetails.poId,
                            PoLineItemId: this.state.LineItemID,
                            rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                            rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                            indicatorForComments: 1
                        }
                        console.log(input, "#####")
                        await this.props.GenericPostCommentsbyDocumentID(input)
                        console.log(this.state.revisedPayload, 'payload')
                        // ! instead we will use approval approval prop
                        // this.changeDocStatus(5,this.state.revisedPayload.param.uploadId)
                        if (flag == 1) {
                            this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.revisedPayload.param.DocumentTypeId, 0, DocumentName, this.state.docStatus[this.state.actionstatus].status, this.state.revisedPayload.param.DrawingDocumentDetailsid)
                        } else {
                            this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.revisedPayload.param.DocumentTypeId, this.state.actionstatus, DocumentName, this.state.docStatus[this.state.actionstatus].status, this.state.revisedPayload.param.DrawingDocumentDetailsid)
                        }
                        this.revisePopUpAction(false);

                    }
                    //only file
                    else {
                        console.log(this.state.revisedPayload.param, 'payload')
                        console.log(flag, "flag")
                        console.log(this.state.actionstatus, "status")

                        // swal("Saving...", { icon: "info", button: false });
                        console.log(this.state.uploadID, "uploadId")
                        let comments = [this.state.reviseForm.comment];
                        let input = {
                            Comment: this.state.reviseForm.comment,
                            RoleId: parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]),
                            GroupId: parseInt(Object.keys(AuthHandlerInstance.getGroups())[0]),
                            UserId: AuthHandlerInstance.getUserID(),
                            DocumentId: this.state.uploadID,
                            PoId: this.props.poDetails.poDetails.poId,
                            PoLineItemId: this.state.LineItemID,
                            rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                            rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                            indicatorForComments: 1
                        }
                        console.log(input, "#####")
                        await this.props.GenericPostCommentsbyDocumentID(input)
                        var result = await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.uploadID, comments, AuthHandlerInstance.getUserID());
                        // console.log(result,"result")
                        // return false
                        if (flag == 1) {
                            this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.revisedPayload.param.DocumentTypeId, 0, DocumentName, this.state.docStatus[this.state.actionstatus].status, this.state.revisedPayload.param.DrawingDocumentDetailsid)
                        } else {
                            this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.revisedPayload.param.DocumentTypeId, this.state.actionstatus, DocumentName, this.state.docStatus[this.state.actionstatus].status, this.state.revisedPayload.param.DrawingDocumentDetailsid)
                        }
                        this.revisePopUpAction(false);
                    }
                    let reviseForm = {
                        comment: "",
                        file: ""
                    }
                    this.setState({ reviseForm })

                    this.dataSync()
                }
            }
            if (this.state.revisedPayload.actionType == "New Version Documents with flow") {
                let input = {}
                var params = {}
                await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.uploadID, "", userId).then(async () => {
                    input = {
                        Comment: this.state.reviseForm.comment,
                        RoleId: parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]),
                        GroupId: parseInt(Object.keys(AuthHandlerInstance.getGroups())[0]),
                        UserId: AuthHandlerInstance.getUserID(),
                        DocumentId: this.state.uploadID,
                        PoId: this.props.poDetails.poDetails.poId,
                        PoLineItemId: this.state.LineItemID,
                        rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        indicatorForComments: 1
                    }
                    params = {
                        DocumentId: this.state.uploadID,
                        DocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        POId: this.props.poDetails.poDetails.poId,
                        PoLineItemId: this.state.LineItemID,
                        DrawingDocumentDetailsid: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        approvalStatus: 0
                    }
                    console.log(input, "#####")
                    await this.props.GenericPostCommentsbyDocumentID(input)
                    await this.props.postDocumentDetailsForExpediting(params).then(async () => {
                        await this.props.getDocumentDetailsForExpediting(this.state.poID, this.state.LineItemID)
                        toast.success("Document Has Benn Uploaded Succesfully", {
                            duration: 5000
                        })
                    })
                });
                this.revisePopUpAction(false);
                await this.dataSync()
                return false
            }
            if (this.state.revisedPayload.actionType == "New Version Documents with out flow") {
                await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.uploadID, "", userId).then(async () => {
                    let input = {
                        Comment: this.state.reviseForm.comment,
                        RoleId: parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]),
                        GroupId: parseInt(Object.keys(AuthHandlerInstance.getGroups())[0]),
                        UserId: AuthHandlerInstance.getUserID(),
                        DocumentId: this.state.uploadID,
                        PoId: this.props.poDetails.poDetails.poId,
                        PoLineItemId: this.state.LineItemID,
                        rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        indicatorForComments: 1
                    }
                    console.log(input, "#####")
                    await this.props.GenericPostCommentsbyDocumentID(input)
                    toast.success("Document Has Benn Uploaded Succesfully", {
                        duration: 5000
                    })
                });
                this.revisePopUpAction(false);
                this.dataSync()
                return false
            }
            if (this.state.revisedPayload.actionType == "Partial Approval") {
                await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.uploadID, "", userId).then(async () => {
                    let input = {
                        Comment: this.state.reviseForm.comment,
                        RoleId: parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]),
                        GroupId: parseInt(Object.keys(AuthHandlerInstance.getGroups())[0]),
                        UserId: AuthHandlerInstance.getUserID(),
                        DocumentId: this.state.uploadID,
                        PoId: this.props.poDetails.poDetails.poId,
                        PoLineItemId: this.state.LineItemID,
                        rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        indicatorForComments: 1
                    }
                    console.log(input, "#####")
                    await this.props.GenericPostCommentsbyDocumentID(input)
                    await this.partialApproval(this.state.revisedPayload.param)
                    toast.success("Document Has Benn Uploaded Succesfully", {
                        duration: 5000
                    })
                });
                let reviseForm = {
                    comment: "",
                    file: ""
                }
                await this.setState({ reviseForm })
                await this.revisePopUpAction(false);
                await this.dataSync()
                return false
            }
            if (this.state.revisedPayload.actionType == "Progress Report Documents") {
                let comments = [this.state.reviseForm.comment];
                if (this.state.revisedPayload.param.DocumentId) {
                    var result = await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.uploadID, "", userId);
                } else {
                    var result = await this.props.uploadFileGeneric(this.state.reviseForm.file, userId);


                    var params = {
                        DocumentId: result.results[0].DocumentId,
                        DocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        POId: this.props.poDetails.poDetails.poId,
                        PoLineItemId: this.state.LineItemID,
                        DrawingDocumentDetailsid: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        approvalStatus: 0,
                        userName: AuthHandlerInstance.getUserPayLoad().fullName
                    }
                    toast.success(`Document Status Has Been Updated For ${this.state.revisedPayload.param.DocumentName}`, {
                        duration: 5000
                    });
                    await this.props.postDocumentDetailsForExpediting(params)
                }
                console.log(result)
                let input = {
                    Comment: this.state.reviseForm.comment,
                    RoleId: parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]),
                    GroupId: parseInt(Object.keys(AuthHandlerInstance.getGroups())[0]),
                    UserId: AuthHandlerInstance.getUserID(),
                    DocumentId: this.state.revisedPayload.param.DocumentId ? this.state.revisedPayload.param.DocumentId : result.results[0].DocumentId,
                    PoId: this.props.poDetails.poDetails.poId,
                    PoLineItemId: this.state.LineItemID,
                    rowDocumentTypeId: 102,
                    rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                    indicatorForComments: 1
                }
                console.log(input, "#####")
                await this.props.GenericPostCommentsbyDocumentID(input)
                toast.success("Document Has Benn Sent Succesfully", {
                    duration: 2000
                })
                this.revisePopUpAction(false);
                this.dataSync()
                return false
            }
            if (this.state.reviseForm.file.length == 0 && this.state.roles[5]) {
                swal("Please upload some valid document", { icon: "error" })
                return false;
            }
            console.log(this.state.docStatus[this.state.actionstatus].status, this.state.actionstatus, 'this.status')
            if (this.state.roles[12] && this.state.revisedPayload.param.DrawingDocumentDetailsid) {
                if (this.props.expediting.getAllAssignedEngineerDetails.recordset.filter((elem) => elem.approvalStatus == 1 && elem.DrawingDocumentDetailsId == this.state.revisedPayload.param.DrawingDocumentDetailsid).length > 0) { }
                else if (this.state.byPassEngineer == 'Yes' && this.state.engineer.length == 0 && this.state.actionstatus == 1) {
                    swal("Please select at least 1 engineer", { icon: "error" })
                    return false;
                }
            }
            if (this.state.roles[7] && this.state.revisedPayload.param.DrawingDocumentDetailsid && this.state.engineer.length == 0 && this.state.actionstatus == 1) {
                swal("Please select at least 1 technical project manager", { icon: "error" })
                return false;
            }
            let DocumentName = ""
            if (this.state.revisedPayload.param.DocumentName) {
                DocumentName = this.state.revisedPayload.param.DocumentName
            }
            if (this.state.revisedPayload.param.DocumentTypeName) {
                DocumentName = this.state.revisedPayload.param.DocumentTypeName
            }
            //no comment no file
            if (this.state.reviseForm.file.length < 1 && this.state.reviseForm.comment == "") {
                if (flag == 1) {
                    this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.revisedPayload.param.DocumentTypeId, 0, DocumentName, this.state.docStatus[this.state.actionstatus].status, this.state.revisedPayload.param.DrawingDocumentDetailsid)
                } else {
                    this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.revisedPayload.param.DocumentTypeId, this.state.actionstatus, DocumentName, this.state.docStatus[this.state.actionstatus].status, this.state.revisedPayload.param.DrawingDocumentDetailsid)
                }
                this.revisePopUpAction(false);
            }
            else {
                // only comment
                if (this.state.reviseForm.file.length < 1) {

                    var roles = AuthHandlerInstance.getRoles()
                    let input = {
                        Comment: this.state.reviseForm.comment,
                        RoleId: parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]),
                        GroupId: parseInt(Object.keys(AuthHandlerInstance.getGroups())[0]),
                        UserId: AuthHandlerInstance.getUserID(),
                        DocumentId: this.state.uploadID,
                        PoId: this.props.poDetails.poDetails.poId,
                        PoLineItemId: this.state.LineItemID,
                        rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        indicatorForComments: 1
                    }
                    console.log(input, "#####")
                    await this.props.GenericPostCommentsbyDocumentID(input)
                    console.log(this.state.revisedPayload, 'payload')
                    // ! instead we will use approval approval prop
                    // this.changeDocStatus(5,this.state.revisedPayload.param.uploadId)
                    if (flag == 1) {
                        this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.revisedPayload.param.DocumentTypeId, 0, DocumentName, this.state.docStatus[this.state.actionstatus].status, this.state.revisedPayload.param.DrawingDocumentDetailsid)
                    } else {
                        this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.revisedPayload.param.DocumentTypeId, this.state.actionstatus, DocumentName, this.state.docStatus[this.state.actionstatus].status, this.state.revisedPayload.param.DrawingDocumentDetailsid)
                    }
                    this.revisePopUpAction(false);

                }
                //only file
                else {
                    console.log(this.state.revisedPayload.param, 'payload')
                    console.log(flag, "flag")
                    console.log(this.state.actionstatus, "status")

                    // swal("Saving...", { icon: "info", button: false });
                    console.log(this.state.uploadID, "uploadId")
                    let comments = [this.state.reviseForm.comment];
                    let input = {
                        Comment: this.state.reviseForm.comment,
                        RoleId: parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]),
                        GroupId: parseInt(Object.keys(AuthHandlerInstance.getGroups())[0]),
                        UserId: AuthHandlerInstance.getUserID(),
                        DocumentId: this.state.uploadID,
                        PoId: this.props.poDetails.poDetails.poId,
                        PoLineItemId: this.state.LineItemID,
                        rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                        rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                        indicatorForComments: 1
                    }
                    console.log(input, "#####")
                    await this.props.GenericPostCommentsbyDocumentID(input)
                    var result = await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.uploadID, comments, AuthHandlerInstance.getUserID());
                    // console.log(result,"result")
                    // return false
                    if (flag == 1) {
                        this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.revisedPayload.param.DocumentTypeId, 0, DocumentName, this.state.docStatus[this.state.actionstatus].status, this.state.revisedPayload.param.DrawingDocumentDetailsid)
                    } else {
                        this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.revisedPayload.param.DocumentTypeId, this.state.actionstatus, DocumentName, this.state.docStatus[this.state.actionstatus].status, this.state.revisedPayload.param.DrawingDocumentDetailsid)
                    }
                    this.documentRef.current[this.state.revisedPayload.param.DocumentTypeId].value = ""
                    this.revisePopUpAction(false);
                }
            }
        }
        let reviseForm = {
            comment: "",
            file: ""
        }
        this.setState({ reviseForm })

        this.dataSync()
    }

    handleFileInputforRevision = (event) => {
        let fileList = [];
        fileList.push(event.target.files[0])
        let reviseForm = this.state.reviseForm
        reviseForm.file = fileList

        let selectedfilestageIdVersion = [this.state.revisedPayload.param.documentTypeId]
        let stageIdsVersion = [this.state.revisedPayload.param.stageDocumentId];
        let fileUploadIds = [this.state.revisedPayload.param.uploadId]
        this.setState({
            reviseForm,
            selectedfilestageIdVersion,
            stageIdsVersion,
            fileUploadIds
        });
    }

    formChange = (e) => {
        console.log("Event", e.target.value);
        let reviseForm = this.state.reviseForm
        reviseForm.comment = e.target.value;
        this.setState({ reviseForm });
    }

    // ? handle file upload for PO Details Document
    onclickUpload = async (rowData) => {

        // onclickUpload = async (documentTypeId, DrawingDocumentDetailsid, approvalId) => {
        // console.log(rowData,"YYYJJJ")
        // return false
        let approvalStatus = (rowData.approvalId == null ? 0 : rowData.approvalId)
        console.log("DoctypeID", rowData)
        // console.log("uploadID",uploadID, "POID=", poID)
        if (rowData.DocumentTypeName === 'Technical Queries format') {
            if (this.state.selectedFile.length < 1) {
                swal("Please upload some valid document", { icon: "error" })
                return false;
            }
            var result = ''
            if (this.state.allDocumentsDetails[rowData.DocumentTypeId] != null && this.state.allDocumentsDetails[rowData.DocumentTypeId]['DocumentId']) {
                await this.props.GenericUploadVersionFile([this.state.files[rowData.DocumentTypeId].fileInfo], this.state.allDocumentsDetails[rowData.DocumentTypeId]['DocumentId'], "", AuthHandlerInstance.getUserID())
                toast.success(`Document Status Has Been Updated For ${rowData.DocumentName}`, {
                    duration: 3000
                });
                await this.props.getDocumentDetailsForExpediting(this.state.poID, this.state.LineItemID)
                document.getElementById("exampleFormControlFile-TechnicalQueries").value = "";
                this.dataSync()
                return false
            } else {
                result = await this.props.uploadFileGeneric([this.state.files[rowData.DocumentTypeId].fileInfo], AuthHandlerInstance.getUserID())
            }
            toast.success(`New File has been uploaded for ${rowData.DocumentName}`, {
                duration: 2000
            });
            console.log("result", result.results)
            var userID = AuthHandlerInstance.getUserID()
            var POId = this.props.poDetails.poDetails.poId
            console.log("POId", POId)
            console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 203 ~ Dashboard ~ onclickUpload=async ~ userID", userID)
            var documentId = result.results[0].DocumentId
            var params = {
                DocumentId: documentId,
                DocumentTypeId: rowData.DocumentTypeId,
                POId: this.props.poDetails.poDetails.poId,
                PoLineItemId: this.state.LineItemID,
                DrawingDocumentDetailsid: rowData.DrawingDocumentDetailsid ? rowData.DrawingDocumentDetailsid : 0,
                approvalStatus: approvalStatus
            }
        }
        if (rowData.DocumentId) {
            if (this.state.selectedFile.length < 1) {

                swal("Please upload some valid document", { icon: "error" })

                return false;
            }
            // console.log("result", this.state.files[rowData.DocumentTypeId])
            // var result = await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.uploadID, comments);
            var result = await this.props.GenericUploadVersionFile([this.state.files[rowData.DocumentTypeId].fileInfo], rowData.DocumentId, "", AuthHandlerInstance.getUserID())
            toast.success(`New File has been uploaded for ${rowData.DocumentName}`, {
                duration: 2000
            });
            var userID = AuthHandlerInstance.getUserID()
            var POId = this.props.poDetails.poDetails.poId
            console.log("POId", POId)
            console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 203 ~ Dashboard ~ onclickUpload=async ~ userID", userID)
            var documentId = result.results[0].DocumentId
            var params = {
                DocumentId: documentId,
                DocumentTypeId: rowData.DocumentTypeId,
                POId: this.props.poDetails.poDetails.poId,
                PoLineItemId: this.state.LineItemID,
                DrawingDocumentDetailsid: rowData.DrawingDocumentDetailsid ? rowData.DrawingDocumentDetailsid : 0,
                approvalStatus: approvalStatus
            }
            this.documentRef.current[rowData.DrawingDocumentDetailsid ? rowData.DrawingDocumentDetailsid : rowData.DocumentId].value = ""
        } else {
            if (this.state.selectedFile.length < 1) {
                swal("Please upload some valid document", { icon: "error" })
                return false;
            }
            var result = await this.props.uploadFileGeneric([this.state.files[rowData.DocumentTypeId].fileInfo], AuthHandlerInstance.getUserID())
            toast.success(`New File has been uploaded for ${rowData.DocumentName}`, {
                duration: 2000
            });
            console.log("result", result.results)
            var userID = AuthHandlerInstance.getUserID()
            var POId = this.props.poDetails.poDetails.poId
            console.log("POId", POId)
            console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 203 ~ Dashboard ~ onclickUpload=async ~ userID", userID)
            var documentId = result.results[0].DocumentId
            var params = {
                DocumentId: documentId,
                DocumentTypeId: rowData.DocumentTypeId,
                POId: this.props.poDetails.poDetails.poId,
                PoLineItemId: this.state.LineItemID,
                DrawingDocumentDetailsid: rowData.DrawingDocumentDetailsid ? rowData.DrawingDocumentDetailsid : 0,
                approvalStatus: approvalStatus
            }
        }
        // var versionId = result.results[0].VersionId
        // this.setState({versionId,documentId})
        toast.success(`Document Status Has Been Updated For ${rowData.DocumentName}`, {
            duration: 3000
        });
        await this.props.postDocumentDetailsForExpediting(params)
        await this.props.getDocumentDetailsForExpediting(this.state.poID, this.state.LineItemID)
        document.getElementById("exampleFormControlFile-TechnicalQueries").value = "";
        await this.setState({ selectedFile: [], files: [] })
        this.dataSync()
        // await this.props.uploadFileforPOAcceptanceAdvance(this.state.selectedFile,uploadID);
    }

    DocumentCommentsByDocumentIdPopUpModal = async () => {
        await this.setState({ DocumentCommentsByDocumentIdPopUpModal: !this.state.DocumentCommentsByDocumentIdPopUpModal, RetentionDocumentsModal: false });
        if (this.state.DocumentCommentsByDocumentIdPopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    toggleDocumentCommentsByDocumentIdPopUpModal = async (e) => {
        await this.setState({ DocumentCommentsByDocumentIdPopUpModal: !this.state.DocumentCommentsByDocumentIdPopUpModal });
        if (this.state.DocumentCommentsByDocumentIdPopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2", varId: "", varPoId: "", varPoLineId: "", vardocumentTypeId: "", vardrawingDocumentDetailId: "", varIdPayment: "", varPoIdPayment: "", vardocumentTypeIdPayment: "", vardrawingDocumentDetailIdPayment: "" }
            )
        }
    }
    rowClick = async (drawingDocumentDetailId, documentTypeId, documentId, poId, poLineId) => {
        console.log(documentTypeId, drawingDocumentDetailId, documentId, poId, poLineId, 'incdex')
        // console.log(this.state.invoicetabledata, 'invoicetabledata')
        // let id = this.state.invoicetabledata[index].InvoiceId
        // console.log(id,"idddd")
        await this.setState({ varId: documentId, varPoId: poId, varPoLineId: poLineId, vardocumentTypeId: documentTypeId, vardrawingDocumentDetailId: drawingDocumentDetailId })
        await this.DocumentCommentsByDocumentIdPopUpModal()
    }
    close() {
        let reviseForm = {
            comment: "",
            file: ""
        }
        this.setState({ reviseForm })
        this.revisePopUpAction(false)
    }
    allDocumentSubmitted = async (poId, LineId) => {
        console.log(poId, LineId)
        await this.props.AllDocumentsSubmittedByVendor(LineId, poId)
        toast.success("Status Updated", {
            duration: 2000
        })
        await this.dataSync()
    }
    handleFileForTransmittleDoc(e) {
        let transmittalFile = []
        console.log(e.target.files, "PPPPPPPPPPPP")
        transmittalFile = e.target.files
        this.setState({ transmittalFile })
    }
    uploadTransmittalFile = async (DocumentDetailsid) => {
        if (this.state.transmittalFile.length < 1) {

            swal("Please upload some valid document", { icon: "error" })

            return false;
        }
        var result = await this.props.uploadFileGeneric([this.state.transmittalFile[0]], AuthHandlerInstance.getUserID())
        console.log(result, "IIIIIIIIIIIIIIIIIIIIIIIIIIII")
        // console.log(result.results[0].DocumentId,result.results[0].CreatedOn,"IIIIIIIIIIIIIIIIIIIIIIIIIIII")
        const input = {
            DocumentDetailsid: DocumentDetailsid,
            DocumentId: result.results[0].DocumentId,
            RoleId: Object.keys(AuthHandlerInstance.getRoles())[0],
            GroupId: Object.keys(AuthHandlerInstance.getGroups())[0],
            UploadedBy: AuthHandlerInstance.getUserID(),
            CreatedOn: result.results[0].CreatedOn
        }
        // console.log(input,"IKIKIIIKIKK")
        await this.props.UpdateTransmittalDocumentDetails(input)
        await this.dataSync()
    }
    updateTransmittleStatus = async (DocumentDetailsid) => {
        const input = {
            DocumentDetailsid: DocumentDetailsid,
            DocumentId: 0,
            RoleId: 0,
            GroupId: 0,
            UploadedBy: 0,
            CreatedOn: 0,
            isDownloaded: 1,
            DownloadedDate: new Date()
        }
        // console.log(input,"IKIKIIIKIKK")
        await this.props.UpdateTransmittalDocumentDetails(input)
        await this.dataSync()
    }
    partialApproval = async (data) => {
        // console.log(data,"123Partial")
        await this.props.PartialApproval(data.DrawingDocumentDetailsid, data.POId, data.POLineItemId, parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]), AuthHandlerInstance.getUserID(), AuthHandlerInstance.getUserPayLoad().fullName)
        toast.success(`Partial Clearence given for ${data.DocumentName}`);
        await this.dataSync()
    }
    deleteEngineer = async (itemId) => {
        await this.props.DeleteAssignedEngineerDetails(itemId)
        await this.props.GetAssignedEngineers(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.editDocType).then(async () => {
            await this.setState({
                engineerList: this.props.expediting.getAssignedEngineerDetails.recordset.filter(item => item.GroupId == 24), engineer: [],
                tpmList: this.props.expediting.getAssignedEngineerDetails.recordset.filter(item => item.GroupId == 19), tpm: [],
            })
        })
    }
    saveEngineerDetails = async (DrawingDocumentDetailsId, indicator) => {
        if (indicator == 0) {
            this.state.engineer.map(async (item) => {
                let params = {
                    DrawingDocumentDetailsId: DrawingDocumentDetailsId,
                    POId: this.props.poDetails.poDetails.poId,
                    POLineItemId: this.state.LineItemID,
                    RoleId: Object.keys(AuthHandlerInstance.getRoles())[0],
                    UserId: item.value,
                }
                await this.props.PostAssignedEngineerDetails(params).then(() => {
                    toast.success("Engineer(s) assignment details updated successfully", { duration: 6000 })
                })
            })
            await this.props.GetAssignedEngineers(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.editDocType).then(async () => {
                await this.setState({ engineerList: this.props.expediting.getAssignedEngineerDetails.recordset.filter(item => item.GroupId == 24), engineer: [] })
            })
        } else {
            this.state.tpm.map(async (item) => {
                let params = {
                    DrawingDocumentDetailsId: DrawingDocumentDetailsId,
                    POId: this.props.poDetails.poDetails.poId,
                    POLineItemId: this.state.LineItemID,
                    RoleId: Object.keys(AuthHandlerInstance.getRoles())[0],
                    UserId: item.value,
                }
                await this.props.PostAssignedEngineerDetails(params).then(() => {
                    toast.success("Engineer(s) assignment details updated successfully", { duration: 6000 })
                })
            })
            await this.props.GetAssignedEngineers(this.props.poDetails.poDetails.poId, this.state.LineItemID, this.state.editDocType).then(async () => {
                await this.setState({ tpmList: this.props.expediting.getAssignedEngineerDetails.recordset.filter(item => item.GroupId == 19), tpm: [] })
            })
        }
    }
    documentComments = async (reviseParam, uploadId) => {
        console.log(reviseParam, uploadId, "@@@@")
        let stateVal = this.state.showCommentPopUp;
        this.setState({ revisedPayload1: reviseParam, showCommentPopUp: !stateVal, uploadedId: uploadId });
    }
    onPressDelete = async (rowData) => {
        console.log(rowData.DrawingDocumentDetailsid, "ggggggg")
        toast.loading(`please wait`, { duration: 2000 })
        await this.props.RemoveRowsFromDocumentTable(rowData.DrawingDocumentDetailsid).then(async () => {
            await this.dataSync().then(async () => {
                await toast.success(`row has been removed`, { duration: 2000 })
            })
        })
    }
    rowClickPayment = async (documentId, poId, documentTypeId, drawingDocumentDetailId) => {
        console.log(documentId, poId, documentTypeId, drawingDocumentDetailId, 'incdex')
        await this.setState({
            varIdPayment: documentId ? documentId : 0,
            varPoIdPayment: poId ? poId : 0,
            varPoLineId: 0,
            vardocumentTypeIdPayment: documentTypeId ? documentTypeId : 0,
            vardrawingDocumentDetailIdPayment: drawingDocumentDetailId ? drawingDocumentDetailId : 0
        })
        await this.DocumentCommentsByDocumentIdPopUpModal(this.state.varId)
    }
    handleFileInputPayment(event, rowData) {
        console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 170 ~ Dashboard ~ handleFileInput ~ rowData", rowData)
        console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 170 ~ Dashboard ~ handleFileInput ~ event", event)
        // console.log(event, rowData, "file input")
        let fileList = [...this.state.selectedFile];
        let fileObjList = this.state.files
        fileObjList[rowData.DocumentTypeId] = {   //?????????????????????
            fileInfo: event.target.files[0],
            dataForFile: rowData
        }
        fileList.push(event.target.files[0])
        this.setState({ selectedFile: fileList, files: fileObjList })
        console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 176 ~ Dashboard ~ handleFileInput ~ fileList", this.state.selectedFile, this.state.files)


    }
    // ? handle file upload for PO Details Document
    onclickUploadPayment = async (documentTypeId) => {
        let comments = ""
        var documentId = 0
        var userID = AuthHandlerInstance.getUserID()
        if (this.props.poDetails.poDetailsForAdvance[documentTypeId] !== undefined) {
            documentId = await this.props.poDetails.poDetailsForAdvance[documentTypeId].DocumentId
        }
        console.log("uploadID", documentId, this.state.files[documentTypeId].fileInfo)
        if (documentId != 0) {
            console.log("Enteeeeerrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr")
            await this.props.GenericUploadVersionFile([this.state.files[documentTypeId].fileInfo], documentId, comments, AuthHandlerInstance.getUserID());
        } else {
            if (this.state.selectedFile.length < 1) {
                swal("Please upload some valid document", { icon: "error" })
                return false;
            }
            toast.loading('Uploading Files...', {
                duration: 1000
            });
            var para = this.state.files[documentTypeId].fileInfo
            console.log("para", para)
            var result = await this.props.uploadFileGeneric([this.state.files[documentTypeId].fileInfo], AuthHandlerInstance.getUserID())
            console.log("result", result.results)
            console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 203 ~ Dashboard ~ onclickUpload=async ~ userID", userID)
            documentId = result.results[0].DocumentId
        }
        var params = {
            documentId: documentId,
            POId: this.state.poID,
            documentTypeId: documentTypeId,
            isSubmitted: 1,
            UploadedBy: userID
        }
        await this.props.postMapAdvanceDocumentIDsToPO(params)
        await this.dataSync()
    }
    revisePopUpActionPayment = (reviseParam, popUpStatus, refreshPage, uploadId, actionstatus) => {

        console.log(reviseParam, popUpStatus, refreshPage, uploadId, actionstatus, "reviseParam")

        this.setState({ revisedPayload: reviseParam, showRevisedPopUpPayment: popUpStatus, uploadID: uploadId, actionstatus });
        if (refreshPage) {
            this.dataSync()
        }
    }
    handleFileInputforRevisionPayment = (event) => {
        let fileList = [];
        fileList.push(event.target.files[0])
        let reviseForm = this.state.reviseForm
        reviseForm.file = fileList

        let selectedfilestageIdVersion = [this.state.revisedPayload.param.documentTypeId]
        let stageIdsVersion = [this.state.revisedPayload.param.stageDocumentId];
        let fileUploadIds = [this.state.revisedPayload.param.uploadId]
        this.setState({
            reviseForm,
            selectedfilestageIdVersion,
            stageIdsVersion,
            fileUploadIds
        });
    }
    formSaveActionPayment = async (flag) => {
        console.log(this.state.reviseForm.file, "______________")
        //no comment no file
        if (this.state.reviseForm.file.length < 1 && this.state.reviseForm.comment == "") {
            if (this.state.actionstatus == 1) {
                await this.handleApprovalPayments(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.revisedPayload.param.DocumentTypeId, this.state.approvalStatus.approved, this.state.revisedPayload.param.DocumentTypeName, this.state.docStatus['1'].status)

            }
            else { await this.handleApprovalPayments(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.revisedPayload.param.DocumentTypeId, this.state.approvalStatus.revise, this.state.revisedPayload.param.DocumentTypeName, this.state.docStatus['3'].status) }
            await this.revisePopUpActionPayment(false);
        }
        else {
            // only comment
            if (this.state.reviseForm.file.length < 1) {

                let input = {
                    Comment: this.state.reviseForm.comment,
                    RoleId: parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]),
                    GroupId: parseInt(Object.keys(AuthHandlerInstance.getGroups())[0]),
                    UserId: AuthHandlerInstance.getUserID(),
                    DocumentId: this.state.uploadID,
                    PoId: this.props.poDetails.paymentTermDetailsByPoId.poId,
                    PoLineItemId: 0,
                    rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                    rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                }
                console.log(input, "#####")
                await this.props.GenericPostCommentsbyDocumentID(input)
                if (this.state.actionstatus == 1) {
                    await this.handleApprovalPayments(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.revisedPayload.param.DocumentTypeId, this.state.approvalStatus.approved, this.state.revisedPayload.param.DocumentTypeName, this.state.docStatus['1'].status)

                }
                else { await this.handleApprovalPayments(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.revisedPayload.param.DocumentTypeId, this.state.approvalStatus.revise, this.state.revisedPayload.param.DocumentTypeName, this.state.docStatus['3'].status) }
                await this.revisePopUpActionPayment(false);
            }
            //only file
            else {
                console.log(this.state.revisedPayload, 'payload')

                // swal("Saving...", { icon: "info", button: false });
                let comments = [this.state.reviseForm.comment];
                let input = {
                    Comment: this.state.reviseForm.comment,
                    RoleId: parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]),
                    GroupId: parseInt(Object.keys(AuthHandlerInstance.getGroups())[0]),
                    UserId: AuthHandlerInstance.getUserID(),
                    DocumentId: this.state.revisedPayload.param.DocumentId,
                    PoId: this.props.poDetails.paymentTermDetailsByPoId.poId,
                    PoLineItemId: 0,
                    rowDocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
                    rowDrawingDocumentDetailId: this.state.revisedPayload.param.DrawingDocumentDetailsid ? this.state.revisedPayload.param.DrawingDocumentDetailsid : 0,
                }
                console.log(input, "#####")
                await this.props.GenericPostCommentsbyDocumentID(input)
                await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.uploadID, comments, AuthHandlerInstance.getUserID());
                if (this.state.actionstatus == 1) {
                    await this.handleApprovalPayments(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.revisedPayload.param.DocumentTypeId, this.state.approvalStatus.approved, this.state.revisedPayload.param.DocumentTypeName, this.state.docStatus['1'].status)
                }
                else {
                    await this.handleApprovalPayments(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.revisedPayload.param.DocumentTypeId, this.state.approvalStatus.revise, this.state.revisedPayload.param.DocumentTypeName, this.state.docStatus['3'].status)
                }
            }
            let reviseForm = {
                comment: "",
                file: ""
            }
            await this.revisePopUpActionPayment(false);
            await this.setState({ reviseForm })
        }
        await this.dataSync()
    }
    // Change document approval status
    handleApprovalPayments = async (poId, documentTypeId, approvalStatus, documentName, documentStatus) => {
        var roles = AuthHandlerInstance.getRoles();
        var groups = AuthHandlerInstance.getGroups();
        console.log(approvalStatus, "{{{{{{{")
        // ? getting the userId for approvedBy
        const approveBy = parseInt(AuthHandlerInstance.getUserID())
        const userName = AuthHandlerInstance.getUserPayLoad()
        console.log("🚀 ~ file: Advanced-PoAcceptanceTrail.js ~ line 194 ~ PoAcceptanceTrail ~ handleApproval=async ~ userName", userName)
        // ? toast alert
        toast.loading(`${documentStatus} Document : ${documentName}...`, {
            duration: 1000
        });
        // ? calling store to update Advance Document Status
        await this.props.postUpdateAdvanceDocumentStatus(
            poId,
            documentTypeId,
            approvalStatus,
            approveBy,
            userName.fullName,
            new Date()
        )
        toast.success(`Document ${documentName} ${documentStatus}!`, {
            duration: 6000
        });
        await this.dataSync()

    }
    formChangePayment = (e) => {
        console.log("Event", e.target.value);
        let reviseForm = this.state.reviseForm
        reviseForm.comment = e.target.value;
        this.setState({ reviseForm });
    }
    approveByCPMandTPM = async (item, ActedGroupId) => {
        // if (item.find())
        // console.log(item,this.state.poID,AuthHandlerInstance.getUserPayLoad().fullName,"{{{{{{{{{{")
        await this.props.postUpdateAdvanceDocumentStatus(
            0,
            ActedGroupId,
            this.state.poID,
            0,
            1,
            AuthHandlerInstance.getUserID(),
            AuthHandlerInstance.getUserPayLoad().fullName,
            new Date(),
            item.PaymentTypeId,
            item.TypeFor
        ).then(async () => {
            toast.success(`Document is Approved`, {
                duration: 6000
            });
            await this.dataSync()
        })

    }
    handleByPassEngineer = async (e) => {
        this.setState({ byPassEngineer: e.target.value });
    }
    ProgressReportCommentsPopUp = async () => {
        await this.setState({ ProgressReportCommentsPopUp: !this.state.ProgressReportCommentsPopUp, RetentionDocumentsModal: false });
        if (this.state.ProgressReportCommentsPopUp == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    toggleProgressReportCommentsPopUp = async (e) => {
        await this.setState({ ProgressReportCommentsPopUp: !this.state.ProgressReportCommentsPopUp });
        if (this.state.ProgressReportCommentsPopUp == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2", progressDocumentTypeId: "", ProgressPoId: "", varPoLineId: "", ProgressLineId: "" }
            )
        }
    }
    rowClickProgress = async (progressDocumentTypeId, ProgressPoId, ProgressLineId) => {
        // console.log(progressDocumentTypeId,ProgressPoId,ProgressLineId,"Chek-data")
        await this.setState({ progressDocumentTypeId, ProgressPoId, ProgressLineId })
        console.log(this.state.progressDocumentTypeId, this.state.ProgressPoId, this.state.ProgressLineId, "Chek-data")

        await this.ProgressReportCommentsPopUp()
    }
    submitInvoiceDocuments = async (item) => {
        console.log(item, this.state.poID)
        let count = 0;
        for (let index = 0; index < item.Documents.length; index++) {
            if (item.Documents[index].DocumentTypeId !== 40 && !this.props.poDetails.poDetailsForAdvance[item.Documents[index].DocumentTypeId]) {
                count = count + 1
            }
        }
        if (count > 0) {
            swal("Please upload all invoice document", { icon: "error" })
            return false;
        }
        let data = {
            PoId: this.state.poID,
            PaymentTypeId: item.PaymentTypeId,
            PaymentType: item.PaymentType,
            TypeFor: item.TypeFor
        }
        // console.log(data,"DataCheck")
        // return false
        await this.props.submitInvoiceDocuments(data)
        await this.dataSync()
        console.log(this.props.poDetails.poDetailsForAdvance, count, 'this.props.poDetails.poDetailsForAdvance')
    }
    submitInvoiceDocumentsPartial = async (item) => {
        // console.log(item, this.state.poID)
        // return false
        let count = 0;
        for (let index = 0; index < item.Documents.length; index++) {
            if (item.Documents[index].DocumentTypeId !== 40 && !this.state.paymentTermPartialDetails[item.Documents[index].AdvanceStageDocumentMappingIdPartial]) {
                count = count + 1
            }
        }
        if (count > 0) {
            swal("Please upload all invoice document", { icon: "error" })
            return false;
        }
        item.Documents.map(async (elem) => {
            var params = {
                documentId: 0,
                AdvanceStageDocumentMappingId: elem.AdvanceStageDocumentMappingIdPartial,
            }
            await this.props.UpdatePartialPaymentDetails(params)
        })
        // await this.props.submitInvoiceDocuments(data)
        await this.dataSync()
        console.log(this.state.paymentTermPartialDetails, count, 'this.state.paymentTermPartialDetails')
    }
    InsertInvoiceDetailsForSupplier = async (data) => {
        if (this.state.selectedFile.length < 1) {
            swal("Please upload some valid document", { icon: "error" })
            return false;
        }
        if (this.state.InvoiceNo.trim() == '') {
            swal("Please enter invoice number", { icon: "error" })
            return false;
        }
        if (this.state.InvoiceDate.trim() == '') {
            swal("Please enter invoice date", { icon: "error" })
            return false;
        }
        if (parseFloat(this.state.InvoiceAmount) == 0) {
            swal("Please enter invoice amount", { icon: "error" })
            return false;
        }
        await this.onclickUpload(data, 1)
        await this.AcceptmodalForSupplier()
    }
    InsertInvoiceDetailsForSupplierPartial = async (data) => {
        if (this.state.selectedFile.length < 1) {
            swal("Please upload some valid document", { icon: "error" })
            return false;
        }
        if (this.state.InvoiceNo.trim() == '') {
            swal("Please enter invoice number", { icon: "error" })
            return false;
        }
        if (this.state.InvoiceDate.trim() == '') {
            swal("Please enter invoice date", { icon: "error" })
            return false;
        }
        if (parseFloat(this.state.InvoiceAmount) == 0) {
            swal("Please enter invoice amount", { icon: "error" })
            return false;
        }
        await this.onclickUploadPartial(data, 1)
        await this.AcceptmodalForSupplierPartial()
    }
    handleSwitch = async (checkedSwitch) => {
        console.log(checkedSwitch, "event.target")
        await this.setState({ checkedSwitch, switchValue: 1 })
    }
    handleSwitchByApTeam = async (checkedSwitch) => {
        console.log(checkedSwitch, "hjhjhjhjhj")
        let val = 0
        if (checkedSwitch == true) {
            val = 2
        }
        await this.setState({ checkedSwitch, checkedSwitchByApTeam: 1, switchValue: val })
    }
    handleDueDate = (event) => {
        this.setState({ DueDate: event.target.value });
    };
    handleInvoiceDate = async (event) => {
        await this.setState({ InvoiceDate: event.target.value });
    };
    InvoiceNoInput = async (e) => {
        await this.setState({ InvoiceNo: e.target.value });
    };
    ApprovedAmountInput = (e) => {
        this.setState({ ApprovedAmount: e.target.value });
    };
    handleWBSNo = (e) => {
        this.setState({ WBSNo: e.target.value });
    };
    handlecurrency = (e) => {
        this.setState({ currency: e.target.value })
    }
    handleINRinvoiceAmount = (e) => {
        this.setState({ INRInvoiceAmount: e.target.value })
    }
    InvoiceAmountInput = async (value) => {
        console.log(value, 'value')
        await this.setState({ InvoiceAmount: value });
    };
    handleExchangeRate = async (value) => {
        let InvoiceAmount = this.state.InvoiceAmount
        let ExchangeRate = value
        let INRInvoiceAmount = parseFloat(InvoiceAmount) * parseFloat(ExchangeRate)
        await this.setState({ ExchangeRate, INRInvoiceAmount })
    }
    handleApprovalPartial = async (AdvanceStageDocumentMappingIdPartial, approvalStatus, dataFull, invoiceDetails) => {
        // console.log(this.state.checkedSwitch, this.state.checkedSwitchByApTeam, this.state.switchValue, invoiceDetails[0].IsPartial, "Input BY AP Team")
        var roles = AuthHandlerInstance.getRoles();
        var groups = AuthHandlerInstance.getGroups();
        if (roles[8] == true && groups[8] == true && (dataFull.DocumentTypeId == 41 || dataFull.DocumentTypeId == 46 || dataFull.DocumentTypeId == 101 || dataFull.DocumentTypeId == 110 || dataFull.DocumentTypeId == 111 || dataFull.DocumentTypeId == 112 || dataFull.DocumentTypeId == 113 || dataFull.DocumentTypeId == 114 || dataFull.DocumentTypeId == 115 || dataFull.DocumentTypeId == 118 || dataFull.DocumentTypeId == 119)) {
            if (this.state.InvoiceDate == '' && this.state.DueDate == '') {
                swal("Please enter value in Date Field", { button: true, icon: "error" })
                return false
            }
            var input = {
                POSAPId: this.state.poSAPID,
                InvoiceNo: this.state.InvoiceNo ? this.state.InvoiceNo : this.state.invoiceDetails[0].InvoiceNo,
                InvoiceDate: this.state.InvoiceDate ? this.state.InvoiceDate : this.state.invoiceDetails[0].InvoiceDate,
                PayableAmount: this.state.ApprovedAmount,
                DueDate: this.state.DueDate,
                InvoiceAmount: this.state.InvoiceAmount ? this.state.InvoiceAmount : this.state.invoiceDetails[0].InvoiceAmount,
                WBSNo: this.props.poDetails.paymentTermDetailsByPoId.wbsCode,
                CurrencyType: this.props.poDetails.paymentTermDetailsByPoId.Currency,
                InvoiceAmountinINR: this.state.INRInvoiceAmount ? this.state.INRInvoiceAmount : this.state.InvoiceAmount,
                PaymentTypeId: dataFull.PaymentType ? dataFull.PaymentType : 0,
                TypeFor: dataFull.TypeFor ? dataFull.TypeFor : "",
                exchangeRate: this.state.ExchangeRate ? this.state.ExchangeRate : 1,
                InvoiceDocId: this.state.InvoiceDocumentId,
                Indicator: 1,
                IsPartial: this.state.checkedSwitchByApTeam == 0 ? 2 : this.state.switchValue
            };
            // console.log(input,"Input BY AP Team")
            // return false
            await this.props.InsertInvoiceDetails(input)
            console.log(input, "Selected Values::");
            if (approvalStatus == 1) {
                await this.AcceptmodalPartial();
            }
            const approveBy = parseInt(AuthHandlerInstance.getUserID())
            const userName = AuthHandlerInstance.getUserPayLoad()
            var params = {
                AdvanceStageDocumentMappingIdPartial: AdvanceStageDocumentMappingIdPartial,
                approvalStatus: approvalStatus,
                approvedBy: approveBy,
                approvedByName: userName.fullName,
                approvedOn: new Date(),
                documentTypeId: dataFull.DocumentTypeId
            }
            await this.props.UpdateApprovalForAdvanceDocumentPartial(params)
            await this.dataSync()
            return false
        }

        // ? getting the userId for approvedBy
        const approveBy = parseInt(AuthHandlerInstance.getUserID())
        const userName = AuthHandlerInstance.getUserPayLoad()
        console.log("🚀 ~ file: Advanced-PoAcceptanceTrail.js ~ line 194 ~ PoAcceptanceTrail ~ handleApproval=async ~ userName", userName)

        // ? toast alert
        toast.loading(`Processing...`, {
            duration: 1000
        });
        // ? calling store to update Advance Document Status
        var params = {
            AdvanceStageDocumentMappingIdPartial: AdvanceStageDocumentMappingIdPartial,
            approvalStatus: approvalStatus,
            approvedBy: approveBy,
            approvedByName: userName.fullName,
            approvedOn: new Date(),
            documentTypeId: dataFull.DocumentTypeId
        }
        await this.props.UpdateApprovalForAdvanceDocumentPartial(params)
        toast.success(`Approved`, {
            duration: 6000
        });
        await this.dataSync()

    }
    Acceptmodal = async (DocumentTypeId, DocumentTypeName, dataFull, InvoiceDocumentId) => {
        await this.props.GetInvoiceDetailsForAPteamApproval(InvoiceDocumentId)
        let invoiceDetails = await this.props.invoices.getAllInvoicesforApTeamApproval.recordset
        console.log(InvoiceDocumentId, invoiceDetails, "DatFull")
        await this.setState({ DocumentTypeId, DocumentTypeName, dataFull, InvoiceDocumentId, invoiceDetails, Acceptmodal: !this.state.Acceptmodal });
    }
    AcceptmodalForSupplier(dataFullForSupplier) {
        this.setState({ AcceptmodalForSupplier: !this.state.AcceptmodalForSupplier });
        if (this.state.AcceptmodalForSupplier == true) {
            this.setState({ opacity: "" });
        } else {
            this.setState({ opacity: "0.2", dataFullForSupplier });
        }
    }
    AcceptmodalPartial = async (AdvanceStageDocumentMappingIdPartial, dataFull, InvoiceDocumentId) => {
        await this.props.GetInvoiceDetailsForAPteamApproval(InvoiceDocumentId)
        let invoiceDetails = await this.props.invoices.getAllInvoicesforApTeamApproval.recordset
        console.log(InvoiceDocumentId, invoiceDetails, "DatFull")
        await this.setState({ AdvanceStageDocumentMappingIdPartial, dataFull, InvoiceDocumentId, invoiceDetails, AcceptmodalPartial: !this.state.AcceptmodalPartial });
    }
    AcceptmodalForSupplierPartial(dataFullForSupplier) {
        this.setState({ AcceptmodalForSupplierPartial: !this.state.AcceptmodalForSupplierPartial });
        if (this.state.AcceptmodalForSupplierPartial == true) {
            this.setState({ opacity: "" });
        } else {
            this.setState({ opacity: "0.2", dataFullForSupplier });
        }
    }
    onclickUploadPartial = async (data, flag = 0) => {
        // console.log(data,"data-partial")
        // return false
        let comments = ""
        var documentId = 0
        var userID = AuthHandlerInstance.getUserID()
        if (data.DocumentId == null) {
            if (this.state.selectedFile.length < 1) {
                swal("Please upload some valid document", { icon: "error" })
                return false;
            }
            // swal("Document is uploading...",{button:false,icon:"info"})
            toast.loading('Uploading Files...', {
                duration: 1000
            });
            var para = this.state.files[data.DocumentTypeId].fileInfo
            console.log("para", para)
            var result = await this.props.uploadFileGeneric([this.state.files[data.DocumentTypeId].fileInfo], AuthHandlerInstance.getUserID())
            console.log("result", result.results)
            console.log("🚀 ~ file: Advanced-RequestPOAcceptance.js ~ line 203 ~ Dashboard ~ onclickUpload=async ~ userID", userID)
            documentId = result.results[0].DocumentId
        }
        else {
            await this.props.GenericUploadVersionFile([this.state.files[data.DocumentTypeId].fileInfo], data.DocumentId, comments, AuthHandlerInstance.getUserID());
            documentId = data.DocumentId
        }
        var params = {
            documentId: documentId,
            AdvanceStageDocumentMappingId: data.AdvanceStageDocumentMappingIdPartial,
        }
        var input = {
            POSAPId: this.state.poSAPID,
            InvoiceNo: this.state.InvoiceNo,
            InvoiceDate: this.state.InvoiceDate,
            InvoiceAmount: this.state.InvoiceAmount,
            WBSNo: this.props.poDetails.paymentTermDetailsByPoId.wbsCode,
            CurrencyType: this.props.poDetails.paymentTermDetailsByPoId.Currency,
            PaymentTypeId: data.PaymentType ? data.PaymentType : 0,
            TypeFor: data.TypeFor ? data.TypeFor : "",
            InvoiceDocId: documentId,
            IsPartial: this.state.switchValue
        };
        await this.props.UpdatePartialPaymentDetails(params)
        if (flag == 1) {
            await this.props.InsertInvoiceDetails(input)
        }
        await this.dataSync()
    }
    approveByCPMandTPMPartial = async (item, ActedGroupId) => {
        // if (item.find())
        // console.log(item, this.state.approvalDetailsByCPMorTPMPartial,"{{{{{{{{{{")
        // return false
        var userDetails = AuthHandlerInstance.getUserPayLoad()
        // console.log(userDetails,"{{{{{{{{{{")
        var params = {
            AdvanceStageDocumentMappingIdPartial: 0,
            approvalStatus: 1,
            approvedBy: userDetails.userId,
            approvedByName: userDetails.fullName,
            approvedOn: new Date(),
            poId: item.PoId,
            PaymentType: item.PaymentTypeId,
            TypeFor: item.TypeFor,
            Counter: item.Counter,
            ActedGroupId: ActedGroupId,
            documentTypeId: 0
        }
        await this.props.UpdateApprovalForAdvanceDocumentPartial(params)
        await toast.success(`Document is Approved`, {
            duration: 6000
        });
        await this.dataSync()

    }
    handleBillingScheduleNo = (e) => {
        let input = e.target.value
        this.setState({ BillingScheduleNo: input })
    }
    handleaddBillingScheduleDetails = async () => {
        if (this.state.BillingScheduleNo == '') {
            swal("Kindly Input A Valid Name", { icon: "error" })
            return false;
        }
        let params = {
            PoLineItemId: this.state.LineItemID,
            BillingScheduleNo: this.state.BillingScheduleNo,
            indicator: 1,
        }
        await this.props.InsertBillingScheduleDetails(params)
        await toast.success(`Successfully Added`, {
            duration: 3000
        });
        await this.addBillingScheduleDetails()
        await this.dataSync()
    }
    handleBillingScheduleNoUpdate = (e, data) => {
        let input = e.target.value
        let billingScheduleDetails = [...this.state.billingScheduleDetails]
        billingScheduleDetails.filter(inputData => inputData.BillingScheduleDetailsId == data.BillingScheduleDetailsId)[0].BillingScheduleNo = input
        this.setState({ billingScheduleDetails })
    }
    handleDescription = (e, data) => {
        let input = e.target.value
        let billingScheduleDetails = [...this.state.billingScheduleDetails]
        billingScheduleDetails.filter(inputData => inputData.BillingScheduleDetailsId == data.BillingScheduleDetailsId)[0].Description = input
        this.setState({ billingScheduleDetails })
    }
    handleQuantity = (e, data) => {
        let input = e.target.value
        let TotalValue = 0
        let billingScheduleDetails = [...this.state.billingScheduleDetails]
        //billingScheduleDetails.map((elem) => {
        //    TotalValue = (TotalValue + elem.Quantity + input) * this.state.UnitPrice
        //})
        //if (TotalValue > this.state.polineItemTotalVale) {
        //    swal("You have exceeded total line item value", { icon: "error" })
        //    billingScheduleDetails.filter(inputData => inputData.BillingScheduleDetailsId == data.BillingScheduleDetailsId)[0].Quantity = 0
        //    return false;
        //}
        billingScheduleDetails.filter(inputData => inputData.BillingScheduleDetailsId == data.BillingScheduleDetailsId)[0].Quantity = input
        this.setState({ billingScheduleDetails })
    }
    handleUnit = (e, data) => {
        let input = e.target.value
        let billingScheduleDetails = [...this.state.billingScheduleDetails]
        billingScheduleDetails.filter(inputData => inputData.BillingScheduleDetailsId == data.BillingScheduleDetailsId)[0].Unit = input
        this.setState({ billingScheduleDetails })
    }
    handleUnitRate = (e, data) => {
        let input = e.target.value
        let count = 0
        let billingScheduleDetails = [...this.state.billingScheduleDetails]
        billingScheduleDetails.filter(inputData => inputData.BillingScheduleDetailsId == data.BillingScheduleDetailsId)[0].UnitRate = input
        billingScheduleDetails.map((elem) => {
            count = count + (elem.UnitRate * elem.Quantity)
        })
        console.log("POPOPOuuu", count)
        if (count > this.state.polineItemTotalVale) {
            swal("You have exceeded total line item value", { icon: "error" })
            billingScheduleDetails.filter(inputData => inputData.BillingScheduleDetailsId == data.BillingScheduleDetailsId)[0].UnitRate = 0
            return false
        }
        else {
            this.setState({ billingScheduleDetails })
        }
    }
    updateBillingScheduleNo = async (val, data) => {
        if (val == 6) {
            let params = {
                BillingScheduleNo: data.BillingScheduleNo,
                indicator: val,
                BillingScheduleDetailsId: data.BillingScheduleDetailsId
            }
            await this.props.InsertBillingScheduleDetails(params)
            await toast.success(`Successfully Saved`, {
                duration: 3000
            });
        }
        else if (val == 2) {
            let params = {
                Description: data.Description,
                indicator: val,
                BillingScheduleDetailsId: data.BillingScheduleDetailsId
            }
            await this.props.InsertBillingScheduleDetails(params)
            await toast.success(`Successfully Saved`, {
                duration: 3000
            });
        }
        else if (val == 3) {
            let params = {
                Quantity: data.Quantity,
                indicator: val,
                BillingScheduleDetailsId: data.BillingScheduleDetailsId
            }
            await this.props.InsertBillingScheduleDetails(params)
            // await toast.success(`Successfully Saved`, {
            //     duration: 3000
            // });
        }
        else if (val == 4) {
            let params = {
                unit: data.Unit,
                indicator: val,
                BillingScheduleDetailsId: data.BillingScheduleDetailsId
            }
            await this.props.InsertBillingScheduleDetails(params)
            await toast.success(`Successfully Saved`, {
                duration: 3000
            });
        }
        else if (val == 5) {
            let params = {
                PoLineItemId: data,
                indicator: val,
            }
            await this.props.InsertBillingScheduleDetails(params)
            await toast.success(`Successfully Submitted`, {
                duration: 3000
            });
        }
        else if (val == 7) {
            let params = {
                PoLineItemId: data,
                indicator: val,
                userId: AuthHandlerInstance.getUserID()
            }
            await this.props.InsertBillingScheduleDetails(params)
            await toast.success(`Approved`, {
                duration: 3000
            });
        }
        else if (val == 8) {
            let params = {
                PoLineItemId: data,
                indicator: val,
            }
            await this.props.InsertBillingScheduleDetails(params)
            await toast.success(`Sent For Revision`, {
                duration: 3000
            });
        }
        else if (val == 9) {
            let params = {
                PoLineItemId: data,
                indicator: val,
                userId: AuthHandlerInstance.getUserID()
            }
            await this.props.InsertBillingScheduleDetails(params)
            await toast.success(`Sent For Revision`, {
                duration: 3000
            });
        }
        else if (val == 10) {
            let params = {
                UnitRate: data.UnitRate,
                indicator: val,
                BillingScheduleDetailsId: data.BillingScheduleDetailsId
            }
            await this.props.InsertBillingScheduleDetails(params)
            await toast.success(`Successfully Saved`, {
                duration: 3000
            });
        }
        if (this.state.warningmodal == true) {
            await this.warningmodal()
        }
        await this.dataSync()
    }
    warningmodal() {
        this.setState({ warningmodal: !this.state.warningmodal });
        if (this.state.warningmodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    submitBillingSchedule = async () => {
        let billingScheduleDetails = [...this.state.billingScheduleDetails]
        let count = 0
        billingScheduleDetails.map((elem) => {
            count = count + (elem.Quantity * elem.UnitRate)
        })
        if (count < this.state.polineItemTotalVale) {
            await this.warningmodal()
        } else {
            await this.updateBillingScheduleNo(5, this.state.LineItemID)
        }
    }
    handleCheck = async () => {
        let billingScheduleRequiredDetails = !this.state.billingScheduleRequiredDetails
        await this.setState({ billingScheduleRequiredDetails })
        console.log("Check", this.state.billingScheduleRequiredDetails)
    }
    SaveToggleBillingInput = async () => {
        let input = {
            poId: this.state.poID,
            poLineItemId: this.state.LineItemID,
            userId: AuthHandlerInstance.getUserID(),
            isRequired: this.state.billingScheduleRequiredDetails == 1 ? 1 : 0
        }
        console.log("jhCheck", input)
        await this.props.InsertBillingScheduleClaimedDetail(input)
        await this.dataSync()
        await toast.success(`Successfully Saved`, {
            duration: 3000
        });
    }
    handleSelectGRN = async (e) => {
        let input = e.value
        let GRNbyPOId = this.state.GRNbyPOId
        let GRNTableData = GRNbyPOId.filter((data) => data.GRNDocNo == input)
        console.log("Dlklklkl", GRNTableData, GRNbyPOId)
        await this.setState({ GRNDocNo: input, GRNTableData })
    }
    GRNSubmit = async (item) => {
        if (this.state.selectedFile.length < 1) {
            swal("Please upload some valid document", { icon: "error" })
            return false;
        }
        await this.setState({ InvoiceIdForGRN: item.InvoiceId, infoValGRN: 0, GRNTableData: [] })
        await this.GRNModal()
    }
    SubmitGRNData = async () => {
        if (this.state.GRNDocNo == '') {
            swal("Please A GRN First", { icon: "error" })
            return false;
        }
        var result = await this.props.uploadFileGeneric([this.state.files[122].fileInfo], AuthHandlerInstance.getUserID())
        let documentId = result.results[0].DocumentId
        console.log("documentId", documentId)
        let inputdata = {
            InvoiceId: this.state.InvoiceIdForGRN,
            GRNDocNo: this.state.GRNDocNo,
            GRNDocumentId: documentId
        }
        await this.props.postGRNDetails(inputdata)
        await this.GRNModal()
        await this.dataSync()
        await toast.success(`GRN Submitted`, {
            duration: 4000
        });

    }
    GRNinfo = async (infoValGRN, input) => {
        let GRNTableData = input
        console.log(input)
        await this.setState({ infoValGRN, GRNTableData })
        await this.GRNModal()
    }
    paymentDocument = () => {
        let searchData = {
            poId: this.state.poID,
            poSAPId: this.state.PoNo,
            InvoiceId: 0,
            InvoiceStatusId: 0
        }
        this.props.history.push({
            pathname: '/PoAcceptanceTrail',
            search: "?" + new URLSearchParams(searchData).toString()
        })
    }
    render() {
        console.log(this.state.engineerList, "")
        console.log(this.props.location.state.selected, "")
        var roles = AuthHandlerInstance.getRoles()
        console.log(roles, "llllllkkk")
        var userID = AuthHandlerInstance.getUserID()
        var groups = AuthHandlerInstance.getGroups()
        var user = AuthHandlerInstance.getUserPayLoad()
        var varId = this.state.varId
        var varPoId = this.state.varPoId
        var varPoLineId = this.state.varPoLineId
        var vardocumentTypeId = this.state.vardocumentTypeId
        var vardrawingDocumentDetailId = this.state.vardrawingDocumentDetailId
        var varIdPayment = this.state.varIdPayment
        var varPoIdPayment = this.state.varPoIdPayment
        var vardocumentTypeIdPayment = this.state.vardocumentTypeIdPayment
        var vardrawingDocumentDetailIdPayment = this.state.vardrawingDocumentDetailIdPayment
        var ProgressPoId = this.state.ProgressPoId
        var ProgressLineId = this.state.ProgressLineId
        var progressDocumentTypeId = this.state.progressDocumentTypeId
        console.log(this.state.vardrawingDocumentDetailId, "&&&&&****")
        var groupsArray = Object.keys(groups)
        var tempPayment = Object.keys(this.props.poDetails.poDetailsForAdvance)
        let temp = []
        const InvoiceAmountinINR = this.state.ExchangeRate ? (parseFloat(this.state.InvoiceAmount) * parseFloat(this.state.ExchangeRate)) : (parseFloat(this.state.InvoiceAmount) * 1)

        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }

        if (this.props.poDetails.poDetails && this.props.poDetails.poDetails.lineItems) {
            this.props.poDetails.poDetails.lineItems.forEach(element => {
                if (element.poLineItemId == this.state.LineItemID) {
                    temp = element
                }
            });
        }

        console.log(this.state.allDocumentsDetails, this.state.allDocuments, temp, "++++++++++++++")

        // ? on button click of table function
        const handleClickTableButton = (item) => () => {
            // write your logic
            alert(JSON.stringify(item))
        }

        // ? All Document table column headers
        const tableConstants = (handleEdit, approverData) => {
            if (roles[5]) {
                return [
                    {
                        title: 'Document Name',
                        className: 'headeralign',
                        render: rowData => {
                            return <span>{rowData.DocumentTypeName}</span>;
                            // return <span>{JSON.stringify(handleEdit[rowData.DocumentTypeId])}</span>;
                        },
                    },
                    {
                        title: 'Submitted On',
                        className: 'text-center',
                        render: rowData => {

                            if (handleEdit != null && handleEdit[rowData.DocumentTypeId] != null) {
                                return <span>{handleEdit[rowData.DocumentTypeId]['CreatedOn'] ? formatDate(handleEdit[rowData.DocumentTypeId]['CreatedOn']) : '---'}</span>;
                            } else {
                                return <span>{'---'}</span>;
                            }

                        },
                    },
                    {
                        title: 'Actions',
                        className: 'text-center',
                        render: rowData => {
                            if (rowData.DocumentTypeName === 'Technical Queries format') {
                                return (
                                    <div className="view-button">
                                        <div className="row">
                                            <div className="pt-2 pl-4">
                                                <input type="file" ref={(ref) => { this.documentRef.current[rowData.DocumentTypeId] = ref; return true; }} accept=".xlsx,.xls" className="form-control-file" onChange={(e) => { this.handleFileInput(e, rowData) }} id="exampleFormControlFile-TechnicalQueries" />
                                            </div>
                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={(e) => { this.onclickUpload(rowData) }} icon={"cloud-upload-alt"} title={`Upload ${rowData.DocumentTypeName}`} color={"black"} size="2x" />
                                            {rowData.DocumentTypeId && handleEdit[rowData.DocumentTypeId] != null && handleEdit[rowData.DocumentTypeId]['DocumentId'] ?
                                                <>
                                                    <FontAwesomeIcon
                                                        className="align-middle mt-2 pr-2"
                                                        icon={"code-branch"}
                                                        color={"black"}
                                                        title="Document Version"
                                                        size="2x" onClick={() => this.OpenVersionModal(handleEdit[rowData.DocumentTypeId]['DocumentId'])} />
                                                    {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, rowData.DocumentTypeId, handleEdit[rowData.DocumentTypeId].DocumentId, handleEdit[rowData.DocumentTypeId].PoId, handleEdit[rowData.DocumentTypeId].PoLineItemId)} />
                                                        : null}
                                                </>
                                                : null}
                                        </div>
                                    </div>
                                )
                            }
                            else if (rowData.DocumentTypeId == 2 && (handleEdit[rowData.DocumentTypeId] && handleEdit[rowData.DocumentTypeId]['DocumentId'])) {
                                return (
                                    <div className="view-button">
                                        <div className="row">
                                            <div className="col align-middle">
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + handleEdit[rowData.DocumentTypeId]['DocumentId'] + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                </a>
                                                {/* </div> */}
                                                {/* <div className="col"> */}
                                                {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, rowData.DocumentTypeId, handleEdit[rowData.DocumentTypeId].DocumentId, handleEdit[rowData.DocumentTypeId].PoId, handleEdit[rowData.DocumentTypeId].PoLineItemId)} />
                                                    : null}
                                            </div>
                                        </div>
                                        <span className={"badge badge-success"}>{`${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']} by SMS`}</span>
                                    </div>
                                )

                            } else if (rowData.DocumentTypeId == 2 && (!handleEdit[rowData.DocumentTypeId])) {
                                return (
                                    <div className="view-button">
                                        <FontAwesomeIcon icon={"stopwatch"} title="Awaiting upload from supplier" color={"black"} size="lg" />
                                    </div>
                                )
                            }
                            else if (rowData.DocumentTypeId !== 2 && (handleEdit[rowData.DocumentTypeId] == null || (handleEdit[rowData.DocumentTypeId] && !handleEdit[rowData.DocumentTypeId]['DocumentId'])) && !temp.DeletionIndicator && temp.isHold !== 1) {
                                return (
                                    <div className="row view-button">
                                        <div className="col-md-8 pt-2">
                                            <input type="file" className="form-control-file" ref={(ref) => { this.documentRef.current[rowData.DocumentTypeId] = ref; return true; }} onChange={(e) => { this.handleFileInput(e, rowData) }} id="exampleFormControlFile1" />
                                        </div>
                                        <div className="col-md-2">
                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={(e) => { this.onclickUpload(rowData) }} icon={"cloud-upload-alt"} title={`Upload ${rowData.DocumentTypeName}`} color={"black"} size="2x" />
                                        </div>
                                    </div>
                                )
                            }
                            else if (rowData.DocumentTypeId !== 2 && handleEdit[rowData.DocumentTypeId] == null || (handleEdit[rowData.DocumentTypeId] && handleEdit[rowData.DocumentTypeId]['DocumentId'] && (handleEdit[rowData.DocumentTypeId]['approvalStatus'] == 3 || handleEdit[rowData.DocumentTypeId]['approvalStatus'] == 0))) {
                                return (
                                    <>
                                        <div className="row view-button">
                                            {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                !handleEdit[rowData.DocumentTypeId] ?
                                                    <>
                                                        <div className="pt-2">
                                                            <input type="file" className="form-control-file" onChange={(e) => { this.handleFileInput(e, rowData) }} ref={(ref) => { this.documentRef.current[rowData.DocumentTypeId] = ref; return true; }} id="exampleFormControlFile1" />
                                                        </div>
                                                        <div className="">
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={(e) => { this.onclickUpload(rowData) }} icon={"cloud-upload-alt"} title="Upload Document" color={"black"} size="2x" />
                                                        </div>
                                                    </>
                                                    : handleEdit[rowData.DocumentTypeId] && (handleEdit[rowData.DocumentTypeId]['approvalStatus'] == 3 || handleEdit[rowData.DocumentTypeId]['approvalStatus'] == 0) ?
                                                        <>
                                                            <div className="pt-2 pl-4">
                                                                <input type="file" className="form-control-file" onChange={(e) => this.reviseAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, false, 0, handleEdit[rowData.DocumentTypeId]['DocumentId'], e)} ref={(ref) => { this.documentRef.current[rowData.DocumentTypeId] = ref; return true; }} id="exampleFormControlFile1" />
                                                            </div>
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={() => this.formSaveAction(1)} icon={"cloud-upload-alt"} title="Upload" color={"black"} size="2x" />
                                                        </>
                                                        : null
                                                : null}
                                            <FontAwesomeIcon
                                                className="align-middle mt-2 pr-2"
                                                icon={"code-branch"}
                                                color={"black"}
                                                title="Document Version"
                                                size="2x" onClick={() => this.OpenVersionModal(handleEdit[rowData.DocumentTypeId]['DocumentId'])} />
                                        </div>
                                        <div className='view-button'>
                                            {this.props.expediting && this.props.expediting.expeditingDocumentDetails && this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId] ? (<span className={"badge " + this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['badge']}>
                                                {this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus'] == 0 ?

                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']}`
                                                    :
                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']} by ${this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] ? this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] : approverData[rowData.DocumentTypeId]['RoleName']}`}
                                            </span>) : null}
                                        </div>
                                    </>
                                )
                            } else if (rowData.DocumentTypeId !== 2 && handleEdit[rowData.DocumentTypeId] && (handleEdit[rowData.DocumentTypeId]['approvalStatus'] == 1 || handleEdit[rowData.DocumentTypeId]['approvalStatus'] == 0))
                                return (
                                    <div className="view-button">
                                        <div className="row">
                                            <div className="col align-middle">
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + handleEdit[rowData.DocumentTypeId]['DocumentId'] + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                </a>
                                                {/* </div> */}
                                                {/* <div className="col"> */}
                                                <FontAwesomeIcon
                                                    className="align-middle mt-2 pr-2"
                                                    icon={"code-branch"}
                                                    color={"black"}
                                                    title="Document Version"
                                                    size="2x" onClick={() => this.OpenVersionModal(handleEdit[rowData.DocumentTypeId]['DocumentId'])} />
                                                {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, rowData.DocumentTypeId, handleEdit[rowData.DocumentTypeId].DocumentId, handleEdit[rowData.DocumentTypeId].PoId, handleEdit[rowData.DocumentTypeId].PoLineItemId)} />
                                                    : null}
                                            </div>
                                        </div>
                                        {this.props.expediting && this.props.expediting.expeditingDocumentDetails && this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId] ? (<span className={"badge " + this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['badge']}>
                                            {this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus'] == 0 ?

                                                `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']}`
                                                :
                                                `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']} by ${this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] ? this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] : approverData[rowData.DocumentTypeId]['RoleName']}`}
                                        </span>) : null}
                                    </div>
                                )
                        }
                    },
                ];
            }
            else {
                return [
                    {
                        title: 'Document Name',
                        className: 'headeralign',
                        render: rowData => {
                            return <span>{rowData.DocumentTypeName}</span>;
                            // return <span>{JSON.stringify(handleEdit[rowData.DocumentTypeId])}</span>;
                        },
                    },
                    {
                        title: 'Acting Department',
                        className: 'headeralign',
                        render: rowData => {
                            return (
                                rowData.DocumentTypeName === 'Technical Queries format' ?
                                    <span>All</span>
                                    :
                                    <span>{rowData.GroupName ? rowData.GroupName : '--'}</span>
                            )
                            // return <span>{Object.keys(groups)[0]}=={rowData.ActingDeptGroupId}</span>;
                        },
                    },
                    {
                        title: 'Submitted On',
                        className: 'text-center',
                        render: rowData => {

                            if (handleEdit != null && handleEdit[rowData.DocumentTypeId] != null) {
                                return <span>{handleEdit[rowData.DocumentTypeId]['CreatedOn'] ? formatDate(handleEdit[rowData.DocumentTypeId]['CreatedOn']) : '---'}</span>;
                            } else {
                                return <span>{'---'}</span>;
                            }

                        },
                    },
                    {
                        title: 'Acted On',
                        className: 'text-center',
                        render: rowData => {
                            if (handleEdit != null && handleEdit[rowData.DocumentTypeId] != null) {
                                return <span>{handleEdit[rowData.DocumentTypeId]['approvedOn'] ? formatDate(handleEdit[rowData.DocumentTypeId]['approvedOn']) : '---'}</span>;
                            } else {
                                return <span>{'---'}</span>;
                            }
                            // return <span>{this.state.ExpeditingStatus}</span>;
                        },
                    },
                    {
                        title: 'Actions',
                        className: 'text-center',
                        render: rowData => {
                            if (rowData.DocumentTypeName === 'Technical Queries format') {
                                return (
                                    <div className="view-button">
                                        <div className="row">
                                            <div className="pt-2 pl-4">
                                                <input type="file" accept=".xlsx,.xls" className="form-control-file" onChange={(e) => { this.handleFileInput(e, rowData) }} id="exampleFormControlFile-TechnicalQueries" />
                                            </div>
                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={(e) => { this.onclickUpload(rowData) }} icon={"cloud-upload-alt"} title={`Upload ${rowData.DocumentTypeName}`} color={"black"} size="2x" />
                                            {rowData.DocumentTypeId && handleEdit[rowData.DocumentTypeId] != null && handleEdit[rowData.DocumentTypeId]['DocumentId'] ?
                                                <FontAwesomeIcon
                                                    className="align-middle mt-2 pr-2"
                                                    icon={"code-branch"}
                                                    color={"black"}
                                                    title="Document Version"
                                                    size="2x" onClick={() => this.OpenVersionModal(handleEdit[rowData.DocumentTypeId]['DocumentId'])} />
                                                : null}
                                            {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, rowData.DocumentTypeId, handleEdit[rowData.DocumentTypeId].DocumentId, handleEdit[rowData.DocumentTypeId].PoId, handleEdit[rowData.DocumentTypeId].PoLineItemId)} />
                                                : null}
                                        </div>
                                    </div>
                                )
                            }
                            // ? When document is not uploaded yet and supplier can upload and others will see Stopwatch
                            else if (rowData.DocumentTypeId == 2 && rowData.ActingDeptGroupId == 4 && (this.state.ClaimedByPlannerId == AuthHandlerInstance.getUserID() || roles[1] || roles[3] || roles[4] || roles[6] || roles[20] || roles[21] || roles[22] || roles[23] || roles[24] || roles[53]) && !temp.DeletionIndicator && temp.isHold !== 1) {
                                if (handleEdit[rowData.DocumentTypeId] && handleEdit[rowData.DocumentTypeId]['DocumentId']) {
                                    return (
                                        <div className="view-button">
                                            <div className="row">
                                                <div className="col align-middle">
                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + handleEdit[rowData.DocumentTypeId]['DocumentId'] + "/download"} target="_blank" download>
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                    </a>
                                                    {/* </div> */}
                                                    {/* <div className="col"> */}
                                                    {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, rowData.DocumentTypeId, handleEdit[rowData.DocumentTypeId].DocumentId, handleEdit[rowData.DocumentTypeId].PoId, handleEdit[rowData.DocumentTypeId].PoLineItemId)} />
                                                        : null}
                                                </div>
                                            </div>
                                            <span className={"badge badge-success"}>{`${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']} by SMS`}</span>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div className="row view-button">
                                            <div className="col-md-8 pt-2">
                                                <input type="file" className="form-control-file" onChange={(e) => { this.handleFileInput(e, rowData) }} id="exampleFormControlFile1" />
                                            </div>
                                            <div className="col-md-2">
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={(e) => { this.onclickUpload(rowData) }} icon={"cloud-upload-alt"} title={`Upload ${rowData.DocumentTypeName}`} color={"black"} size="2x" />
                                            </div>
                                        </div>
                                    )
                                }
                            }
                            else if ((handleEdit[rowData.DocumentTypeId] == null || (handleEdit[rowData.DocumentTypeId] && !handleEdit[rowData.DocumentTypeId]['DocumentId']))) {
                                return (
                                    <div className="view-button">
                                        <FontAwesomeIcon icon={"stopwatch"} title="Awaiting upload from supplier" color={"black"} size="lg" />
                                    </div>
                                )
                            }
                            // ? (multi level approval) if document Status is 4 it will show approval ui to SMS
                            else if (handleEdit[rowData.DocumentTypeId]['approvalStatus'] == 4 || handleEdit[rowData.DocumentTypeId]['approvalStatus'] == 0) {
                                // ? if doctype not = 86 and the role is same as master table
                                if (rowData.DocumentTypeId != 86 && groupsArray.find(item => parseInt(item) == rowData.ActingDeptGroupId)) {
                                    return (
                                        <div className="view-button">
                                            <div className="row">
                                                <div className="col align-middle">
                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + handleEdit[rowData.DocumentTypeId]['DocumentId'] + "/download"} target="_blank" download>
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                    </a>

                                                    <FontAwesomeIcon
                                                        className="align-middle mt-2 pr-2"
                                                        icon={"code-branch"}
                                                        color={"black"}
                                                        title="Document Version"
                                                        size="2x" onClick={() => this.OpenVersionModal(handleEdit[rowData.DocumentTypeId]['DocumentId'])} />
                                                    {groupsArray.find(item => parseInt(item) == rowData.ActingDeptGroupId) && this.state.ClaimedByPlannerId == AuthHandlerInstance.getUserID() && !temp.DeletionIndicator && temp.isHold !== 1 ?
                                                        <>
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, handleEdit[rowData.DocumentTypeId]['DocumentId'], this.state.approvalStatus.approved)} />

                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, handleEdit[rowData.DocumentTypeId]['DocumentId'], this.state.approvalStatus.revise)} />
                                                        </>
                                                        : groupsArray.find(item => parseInt(item) == rowData.ActingDeptGroupId) && rowData.DocumentTypeId === 99 && !temp.DeletionIndicator && temp.isHold !== 1 ?
                                                            <>
                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, handleEdit[rowData.DocumentTypeId]['DocumentId'], this.state.approvalStatus.approved)} />
                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, handleEdit[rowData.DocumentTypeId]['DocumentId'], this.state.approvalStatus.revise)} />
                                                            </>

                                                            : null}
                                                    {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, rowData.DocumentTypeId, handleEdit[rowData.DocumentTypeId].DocumentId, handleEdit[rowData.DocumentTypeId].PoId, handleEdit[rowData.DocumentTypeId].PoLineItemId)} />
                                                        : null}
                                                </div>
                                            </div>
                                            {this.props.expediting && this.props.expediting.expeditingDocumentDetails && this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId] ? (<span className={"badge " + this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['badge']}>
                                                {this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus'] == 0 ?

                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']}`
                                                    :
                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']} by ${this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] ? this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] : approverData[rowData.DocumentTypeId]['RoleName']}`}
                                            </span>) : null}
                                        </div>
                                    )
                                }
                                else if (approverData != null && approverData[rowData.DocumentTypeId] != null && parseInt(Object.keys(roles)[0]) == approverData[rowData.DocumentTypeId]['NextActedTeamRoleId'] && parseInt(Object.keys(roles)[0]) != 17) {
                                    return (
                                        <div className="view-button">
                                            <div className="row">
                                                <div className="col align-middle">
                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + handleEdit[rowData.DocumentTypeId]['DocumentId'] + "/download"} target="_blank" download>
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                    </a>
                                                    <FontAwesomeIcon
                                                        className="align-middle mt-2 pr-2"
                                                        icon={"code-branch"}
                                                        color={"black"}
                                                        title="Document Version"
                                                        size="2x" onClick={() => this.OpenVersionModal(handleEdit[rowData.DocumentTypeId]['DocumentId'])} />
                                                    {this.state.ClaimById == AuthHandlerInstance.getUserID() && !temp.DeletionIndicator && temp.isHold !== 1 ?
                                                        <>
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, handleEdit[rowData.DocumentTypeId]['DocumentId'], this.state.approvalStatus.approved)} />
                                                            {/* <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"times-circle"} color={"red"} title="Reject" size="2x" onClick={() => this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, element.DocumentTypeId, this.state.approvalStatus.rejected, element.DocumentTypeName, this.state.docStatus['2'].status)} /> */}
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, handleEdit[rowData.DocumentTypeId]['DocumentId'], this.state.approvalStatus.revise)} />
                                                        </>
                                                        : null}
                                                    {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, rowData.DocumentTypeId, handleEdit[rowData.DocumentTypeId].DocumentId, handleEdit[rowData.DocumentTypeId].PoId, handleEdit[rowData.DocumentTypeId].PoLineItemId)} />
                                                        : null}
                                                </div>
                                            </div>
                                            {this.props.expediting && this.props.expediting.expeditingDocumentDetails && this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId] ? (<span className={"badge " + this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['badge']}>
                                                {this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus'] == 0 ?

                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']}`
                                                    :
                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']} by ${this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] ? this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] : approverData[rowData.DocumentTypeId]['RoleName']}`}
                                            </span>) : null}
                                        </div>
                                    )
                                    // ? view for all users who do not have permission to approve, includes SMS users and Supplier will show Download UI
                                } else {
                                    return (
                                        <div className="view-button">
                                            <div className="row ">
                                                <div className="col align-middle">

                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + handleEdit[rowData.DocumentTypeId]['DocumentId'] + "/download"} target="_blank" download>
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                    </a>
                                                    {/* </div> */}
                                                    {/* <div className="col"> */}
                                                    <FontAwesomeIcon
                                                        className="align-middle mt-2 pr-2"
                                                        icon={"code-branch"}
                                                        color={"black"}
                                                        title="Document Version"
                                                        size="2x" onClick={() => this.OpenVersionModal(handleEdit[rowData.DocumentTypeId]['DocumentId'])} />
                                                    {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, rowData.DocumentTypeId, handleEdit[rowData.DocumentTypeId].DocumentId, handleEdit[rowData.DocumentTypeId].PoId, handleEdit[rowData.DocumentTypeId].PoLineItemId)} />
                                                        : null}
                                                </div>
                                            </div>
                                            {this.props.expediting && this.props.expediting.expeditingDocumentDetails && this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId] ? (<span className={"badge " + this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['badge']}>
                                                {this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus'] == 0 ?

                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']}`
                                                    :
                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']} by ${this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] ? this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] : approverData[rowData.DocumentTypeId]['RoleName']}`}
                                            </span>) : null}
                                        </div>
                                    )
                                }
                            }

                            // ? if document is approved and status > 0
                            else if (handleEdit[rowData.DocumentTypeId]['approvalStatus'] > 0) {
                                return (
                                    <div className="view-button">
                                        <div className="row">
                                            <div className="col align-middle">
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + handleEdit[rowData.DocumentTypeId]['DocumentId'] + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                </a>
                                                {/* </div> */}
                                                {/* <div className="col"> */}
                                                <FontAwesomeIcon
                                                    className="align-middle mt-2 pr-2"
                                                    icon={"code-branch"}
                                                    color={"black"}
                                                    title="Document Version"
                                                    size="2x" onClick={() => this.OpenVersionModal(handleEdit[rowData.DocumentTypeId]['DocumentId'])} />
                                                {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, rowData.DocumentTypeId, handleEdit[rowData.DocumentTypeId].DocumentId, handleEdit[rowData.DocumentTypeId].PoId, handleEdit[rowData.DocumentTypeId].PoLineItemId)} />
                                                    : null}
                                            </div>
                                        </div>
                                        {this.props.expediting && this.props.expediting.expeditingDocumentDetails && this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId] ? (<span className={"badge " + this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['badge']}>
                                            {this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus'] == 0 ?

                                                `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']}`
                                                :
                                                `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']} by ${this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] ? this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] : approverData[rowData.DocumentTypeId]['RoleName']}`}
                                        </span>) : null}
                                    </div>
                                )
                            }

                            // ? if document is uploaded, for supplier it will show download button, for SMS if not approvers then it will show download, if approvers then it will show approval buttons
                            else if (handleEdit[rowData.DocumentTypeId] == null || handleEdit[rowData.DocumentTypeId]['DocumentId']) {
                                if (roles[5]) {
                                    return (
                                        <div className="view-button">
                                            <div className="row">
                                                <div className="col align-middle">
                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + handleEdit[rowData.DocumentTypeId]['DocumentId'] + "/download"} target="_blank" download>
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                    </a>
                                                    {/* </div> */}
                                                    {/* <div className="col"> */}
                                                    <FontAwesomeIcon
                                                        className="align-middle mt-2 pr-2"
                                                        icon={"code-branch"}
                                                        color={"black"}
                                                        title="Document Version"
                                                        size="2x" onClick={() => this.OpenVersionModal(handleEdit[rowData.DocumentTypeId]['DocumentId'])} />
                                                    {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, rowData.DocumentTypeId, handleEdit[rowData.DocumentTypeId].DocumentId, handleEdit[rowData.DocumentTypeId].PoId, handleEdit[rowData.DocumentTypeId].PoLineItemId)} />
                                                        : null}
                                                </div>
                                            </div>
                                            {this.props.expediting && this.props.expediting.expeditingDocumentDetails && this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId] ? (<span className={"badge " + this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['badge']}>
                                                {this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus'] == 0 ?

                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']}`
                                                    :
                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']} by ${this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] ? this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] : approverData[rowData.DocumentTypeId]['RoleName']}`}
                                            </span>) : null}
                                        </div>
                                    )
                                    // ? original, can be used for 86
                                    // } else if(approverData != null && approverData[rowData.DocumentTypeId] != null && parseInt(Object.keys(roles)[0]) == approverData[rowData.DocumentTypeId]['NextActedTeamRoleId']) {
                                    // ? when the doctype is not 86 and others approve
                                } else if (rowData.DocumentTypeId != 86 && parseInt(Object.keys(roles)[0]) == rowData.ActingDeptGroupId) {
                                    return (
                                        <div className="view-button">
                                            <div className="row">
                                                <div className="col align-middle">
                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + handleEdit[rowData.DocumentTypeId]['DocumentId'] + "/download"} target="_blank" download>
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                    </a>
                                                    <FontAwesomeIcon
                                                        className="align-middle mt-2 pr-2"
                                                        icon={"code-branch"}
                                                        color={"black"}
                                                        title="Document Version"
                                                        size="2x" onClick={() => this.OpenVersionModal(handleEdit[rowData.DocumentTypeId]['DocumentId'])} />
                                                    {this.state.ClaimById == AuthHandlerInstance.getUserID() && !temp.DeletionIndicator && temp.isHold !== 1 ?
                                                        <>
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, handleEdit[rowData.DocumentTypeId]['DocumentId'], this.state.approvalStatus.approved)} />
                                                            {/* <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"times-circle"} color={"red"} title="Reject" size="2x" onClick={() => this.handleApproval(this.props.poDetails.poDetails.poId, this.state.LineItemID, element.DocumentTypeId, this.state.approvalStatus.rejected, element.DocumentTypeName, this.state.docStatus['2'].status)} /> */}
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, handleEdit[rowData.DocumentTypeId]['DocumentId'], this.state.approvalStatus.revise)} />
                                                        </>
                                                        : null}
                                                    {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, rowData.DocumentTypeId, handleEdit[rowData.DocumentTypeId].DocumentId, handleEdit[rowData.DocumentTypeId].PoId, handleEdit[rowData.DocumentTypeId].PoLineItemId)} />
                                                        : null}
                                                </div>
                                            </div>
                                            {this.props.expediting && this.props.expediting.expeditingDocumentDetails && this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId] ? (<span className={"badge " + this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['badge']}>
                                                {this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus'] == 0 ?

                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']}`
                                                    :
                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']} by ${this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] ? this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] : approverData[rowData.DocumentTypeId]['RoleName']}`}
                                            </span>) : null}
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div className="view-button">
                                            <div className="row">
                                                <div className="col align-middle">
                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + handleEdit[rowData.DocumentTypeId]['DocumentId'] + "/download"} target="_blank" download>
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                    </a>
                                                    {/* </div> */}
                                                    {/* <div className="col"> */}
                                                    <FontAwesomeIcon
                                                        className="align-middle mt-2 pr-2"
                                                        icon={"code-branch"}
                                                        color={"black"}
                                                        title="Document Version"
                                                        size="2x" onClick={() => this.OpenVersionModal(handleEdit[rowData.DocumentTypeId]['DocumentId'])} />
                                                    {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, rowData.DocumentTypeId, handleEdit[rowData.DocumentTypeId].DocumentId, handleEdit[rowData.DocumentTypeId].PoId, handleEdit[rowData.DocumentTypeId].PoLineItemId)} />
                                                        : null}
                                                </div>
                                            </div>
                                            {this.props.expediting && this.props.expediting.expeditingDocumentDetails && this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId] ? (<span className={"badge " + this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['badge']}>
                                                {this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus'] == 0 ?

                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']}`
                                                    :
                                                    `${this.state.docStatus[this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvalStatus']]['title']} by ${this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] ? this.props.expediting.expeditingDocumentDetails[rowData.DocumentTypeId]['approvedByName'] : approverData[rowData.DocumentTypeId]['RoleName']}`}
                                            </span>) : null}
                                        </div>
                                    )
                                }
                            }

                        },
                    },
                    {
                        title: 'Details',
                        className: 'text-center',
                        render: rowData => {
                            return (
                                <div className="view-button pt-2">
                                    {rowData.DocumentTypeName === 'Technical Queries format' ? null :
                                        <FontAwesomeIcon icon={"info-circle"} title="View approval details" color={"black"} size="lg" onClick={(e) => this.Docmodal(rowData.DocumentTypeId, rowData.DocumentTypeName)} />}
                                </div>
                            );
                        },
                    },
                ];
            }
        };


        const ProgresstableConstants = (handleEdit, approverData) => {

            if (roles[7] || roles[5]) {
                return [
                    {
                        title: 'Document Name',
                        className: 'headeralign',
                        render: rowData => {
                            return <span>{rowData.DocumentName}</span>;
                        },
                    },
                    {
                        title: 'Latest Submission Date',
                        className: 'text-center',
                        render: rowData => {
                            return <span>{rowData.CreatedOn ? FormatDateTimeInIST(rowData.CreatedOn) : '---'}</span>;
                            // return JSON.stringify(this.state.progressReportDocuments);
                        },
                    },
                    {
                        title: 'Actions',
                        className: 'text-center',
                        render: rowData => {
                            return (
                                <div className="view-button">
                                    {rowData.DocumentId ?
                                        <FontAwesomeIcon
                                            className="align-middle pr-2"
                                            style={{ cursor: 'pointer' }}
                                            icon={"code-branch"}
                                            color={"black"}
                                            title="Document Version"
                                            size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                        :
                                        <>
                                            <FontAwesomeIcon icon={"trash"} className="align-middle pr-2" color="red" size="2x" cursor="pointer" onClick={() => this.onPressDelete(rowData)} />
                                            <FontAwesomeIcon
                                                className="align-middle pr-2"
                                                icon={"code-branch"}
                                                color={"grey"}
                                                title="No Document Version Available"
                                                size="2x" />
                                        </>
                                    }
                                    {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                        <FontAwesomeIcon className="mr-2" style={{ cursor: 'pointer' }} icon={"cloud-upload-alt"} title="Upload" color={"black"} size="lg" onClick={() => this.revisePopUpAction({ actionType: "Progress Report Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} />
                                        : null}
                                    {rowData.DocumentId && !temp.DeletionIndicator && temp.isHold !== 1 ?
                                        <FontAwesomeIcon className="align-middle pr-2" style={{ cursor: 'pointer' }} icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, 102, rowData.DocumentId, this.props.poDetails.poDetails.poId, this.state.LineItemID)} />
                                        :
                                        <FontAwesomeIcon className="align-middle pr-2" icon={"sms"} color={"grey"} title="No Comments" size="2x" />
                                    }
                                </div>
                            );
                        },
                    },
                ];
            } else {
                return [
                    {
                        title: 'Document Name',
                        className: 'headeralign',
                        render: rowData => {
                            return <span>{rowData.DocumentName}</span>;
                        },
                    },
                    // {
                    //     title: 'Latest Uploaded By',
                    //     render: rowData => {
                    //         return <span>{rowData.FullName ? rowData.FullName : "---"}</span>;
                    //     },
                    // },
                    {
                        title: 'Latest Submission Date',
                        className: 'text-center',
                        render: rowData => {
                            return <span>{rowData.CreatedOn ? FormatDateTimeInIST(rowData.CreatedOn) : '---'}</span>;
                            // return JSON.stringify(this.state.progressReportDocuments);
                        },
                    },
                    {
                        title: 'Actions',
                        className: 'text-center',
                        render: rowData => {
                            return (
                                <div className="view-button">
                                    {rowData.DocumentId ?
                                        <FontAwesomeIcon
                                            className="align-middle pr-2"
                                            style={{ cursor: 'pointer' }}
                                            icon={"code-branch"}
                                            color={"black"}
                                            title="Document Version"
                                            size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                        :
                                        <FontAwesomeIcon
                                            className="align-middle pr-2"
                                            icon={"code-branch"}
                                            color={"grey"}
                                            title="No Document Version Available"
                                            size="2x" />
                                    }
                                    {rowData.DocumentId && !temp.DeletionIndicator && temp.isHold !== 1 ?
                                        <FontAwesomeIcon className="align-middle pr-2" style={{ cursor: 'pointer' }} icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, 102, rowData.DocumentId, this.props.poDetails.poDetails.poId, this.state.LineItemID)} />
                                        :
                                        <FontAwesomeIcon className="align-middle pr-2" icon={"sms"} color={"grey"} title="No Comments" size="2x" />
                                    }
                                </div>
                            );
                        },
                    },
                ];
            }
        };
        const StageDocumentTableConstant = () => {

            return [
                {
                    title: 'Stage Name',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{(rowData.StageName ? rowData.StageName : "") + " " + (rowData.StageCounter ? rowData.StageCounter : "")}</span>;
                    },
                },
                {
                    title: 'Document Name',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.DocumentTypeName ? rowData.DocumentTypeName : '---'}</span>;
                    },
                },
                {
                    title: 'Claimed By Planner Name',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.EmployeeName ? rowData.EmployeeName : '---'}</span>;
                    },
                },
                {
                    title: 'Actions',
                    className: 'text-center',
                    render: rowData => {
                        return (
                            <div className="view-button">
                                {rowData.UploadId ?
                                    <FontAwesomeIcon
                                        className="align-middle pr-2"
                                        style={{ cursor: 'pointer' }}
                                        icon={"code-branch"}
                                        color={"black"}
                                        title="Document Version"
                                        size="2x" onClick={() => this.OpenVersionModal(rowData.UploadId)} />
                                    :
                                    <FontAwesomeIcon
                                        className="align-middle pr-2"
                                        icon={"code-branch"}
                                        color={"grey"}
                                        title="No Document Version Available"
                                        size="2x" />
                                }
                                {rowData.UploadId ?
                                    <FontAwesomeIcon className="align-middle float-left mt-2 mr-6 pr-2" icon={"sms"} color="black" title="Comments" size="2x" onClick={() => this.documentComments({ actionType: "Supplier Documents", param: rowData }, rowData.UploadId)} />
                                    :
                                    <FontAwesomeIcon className="align-middle pr-2" icon={"sms"} color={"grey"} title="No Comments" size="2x" />
                                }
                            </div>
                        );
                    },
                },
            ];
        };
        const InspectionDocumentTableConstant = () => {

            return [
                {
                    title: 'Stage Name',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{(rowData.StageName ? rowData.StageName : "") + " " + (rowData.StageCounter ? rowData.StageCounter : "")}</span>;
                    },
                },
                {
                    title: 'Document Name',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.InspectionDocumentName ? rowData.InspectionDocumentName : '---'}</span>;
                    },
                },
                {
                    title: 'Acted Planner Name',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.QAPlannerName ? rowData.QAPlannerName : '---'}</span>;
                    },
                },
                {
                    title: 'Inspector Type',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.InspectorTypeName ? rowData.InspectorTypeName : '---'}</span>;
                    },
                },
                {
                    title: 'Inspector Name',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.InspectorName ? rowData.InspectorName : '---'}</span>;
                    },
                },
                {
                    title: 'Actions',
                    className: 'text-center',
                    render: rowData => {
                        return (
                            <div className="view-button">
                                {rowData.DocumentUploadId ?
                                    <FontAwesomeIcon
                                        className="align-middle pr-2"
                                        style={{ cursor: 'pointer' }}
                                        icon={"code-branch"}
                                        color={"black"}
                                        title="Document Version"
                                        size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentUploadId)} />
                                    :
                                    <FontAwesomeIcon
                                        className="align-middle pr-2"
                                        icon={"code-branch"}
                                        color={"grey"}
                                        title="No Document Version Available"
                                        size="2x" />
                                }
                                {rowData.DocumentUploadId ?
                                    <FontAwesomeIcon className="align-middle pr-2" style={{ cursor: 'pointer' }} icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(0, 102, rowData.DocumentUploadId, this.props.poDetails.poDetails.poId, this.state.LineItemID)} />
                                    :
                                    <FontAwesomeIcon className="align-middle pr-2" icon={"sms"} color={"grey"} title="No Comments" size="2x" />
                                }
                            </div>
                        );
                    },
                },
            ];
        };
        //? 
        const TransmittalTableConstants = () => {
            if (roles[15]) {
                return [
                    {
                        title: 'Document Name',
                        className: 'headeralign',
                        render: rowData => {
                            return <span>{rowData.DocumentName}</span>;
                        },
                    },
                    {
                        title: 'Uploaded By',
                        className: 'headeralign',
                        render: rowData => {
                            return <span>{rowData.UploadedByName}</span>;
                        },
                    },
                    {
                        title: 'Submitted On',
                        className: 'text-center',
                        render: rowData => {
                            return <span>{rowData.CreatedOn ? FormatDateTimeInIST(rowData.CreatedOn) : '---'}</span>;
                        },
                    },
                    {
                        title: 'Downloaded On',
                        className: 'text-center',
                        render: rowData => {
                            return <span>{rowData.DownloadedDate ? FormatDateTimeInIST(rowData.DownloadedDate) : '---'}</span>;
                        },
                    },
                    {
                        title: 'Actions',
                        className: 'text-center',
                        render: rowData => {
                            if (rowData.DocumentId == null) {
                                if (!temp.DeletionIndicator && temp.isHold !== 1) {
                                    if (roles[15]) {
                                        return (
                                            <div className="row view-button">
                                                <div className="col pt-2">
                                                    <input type="file" className="form-control-file" onChange={(e) => this.handleFileForTransmittleDoc(e)} id="exampleFormControlFile1" />
                                                </div>
                                                <div className="col">
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={() => this.uploadTransmittalFile(rowData.DocumentDetailsid)} icon={"cloud-upload-alt"} title="Upload Document" color={"black"} size="2x" />
                                                </div>
                                                <div className="col">
                                                    <FontAwesomeIcon icon={"trash"} className="align-middle mt-2 pr-2" color="red" size="2x" cursor="pointer" onClick={() => this.onPressDelete(rowData)} />
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div className="view-button">
                                                <FontAwesomeIcon icon={"stopwatch"} title="Awaiting for upload" color={"black"} size="lg" />
                                            </div>
                                        );
                                    }
                                }
                            }
                            else {
                                return (
                                    <div className="view-button">
                                        <div className="row">
                                            <div className="col align-middle">
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                    {roles[5] && rowData.POId !== 0 ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" onClick={() => this.updateTransmittleStatus(rowData.DocumentDetailsid)} />
                                                        :
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                    }
                                                </a>
                                            </div>
                                        </div>
                                        {this.props.expediting && this.props.expediting.getPoTransmittleDOcuments ?
                                            rowData.POId === 0 ?
                                                <span className="badge badge-primary">Fixed PO Annexure</span>
                                                : (<span className={"badge " + this.state.TransmittalDocStatus[rowData.isDownloaded]['badge']}>
                                                    {`${this.state.TransmittalDocStatus[[rowData.isDownloaded]]['title']}`}
                                                </span>)
                                            : null}
                                    </div>
                                )
                            }
                        },
                    },
                ];
            } else {
                return [
                    {
                        title: 'Document Name',
                        className: 'headeralign',
                        render: rowData => {
                            return <span>{rowData.DocumentName}</span>;
                        },
                    },
                    {
                        title: 'Uploaded By',
                        className: 'headeralign',
                        render: rowData => {
                            return <span>{rowData.UploadedByName}</span>;
                        },
                    },
                    {
                        title: 'Submitted On',
                        className: 'text-center',
                        render: rowData => {
                            return <span>{rowData.CreatedOn ? FormatDateTimeInIST(rowData.CreatedOn) : '---'}</span>;
                        },
                    },
                    {
                        title: 'Downloaded On',
                        className: 'text-center',
                        render: rowData => {
                            return <span>{rowData.DownloadedDate ? FormatDateTimeInIST(rowData.DownloadedDate) : '---'}</span>;
                        },
                    },
                    {
                        title: 'Actions',
                        className: 'text-center',
                        render: rowData => {
                            if (rowData.DocumentId == null) {
                                if (!temp.DeletionIndicator && temp.isHold !== 1) {
                                    if (roles[15]) {
                                        return (
                                            <div className="row view-button">
                                                <div className="col pt-2">
                                                    <input type="file" className="form-control-file" onChange={(e) => this.handleFileForTransmittleDoc(e)} id="exampleFormControlFile1" />
                                                </div>
                                                <div className="col">
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={() => this.uploadTransmittalFile(rowData.DocumentDetailsid)} icon={"cloud-upload-alt"} title="Upload Document" color={"black"} size="2x" />
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div className="view-button">
                                                <FontAwesomeIcon icon={"stopwatch"} title="Awaiting for upload" color={"black"} size="lg" />
                                            </div>
                                        );
                                    }
                                }
                            }
                            else {
                                return (
                                    <div className="view-button">
                                        <div className="row">
                                            <div className="col align-middle">
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                    {roles[5] && rowData.POId !== 0 ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" onClick={() => this.updateTransmittleStatus(rowData.DocumentDetailsid)} />
                                                        :
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                    }
                                                </a>
                                            </div>
                                        </div>
                                        {this.props.expediting && this.props.expediting.getPoTransmittleDOcuments ?
                                            rowData.POId === 0 ?
                                                <span className="badge badge-primary">Fixed PO Annexure</span>
                                                : (<span className={"badge " + this.state.TransmittalDocStatus[rowData.isDownloaded]['badge']}>
                                                    {`${this.state.TransmittalDocStatus[[rowData.isDownloaded]]['title']}`}
                                                </span>)
                                            : null}
                                    </div>
                                )
                            }
                        },
                    },
                ];
            }
        };
        const TransmittalTableConstantsDrawing = () => {
            return [
                {
                    title: 'Document Name',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.DocumentName}</span>;
                    },
                },
                {
                    title: 'Uploaded By',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.UploadedByName}</span>;
                    },
                },
                {
                    title: 'Submitted On',
                    className: 'text-center',
                    render: rowData => {
                        return <span>{rowData.CreatedOn ? dateFormater(rowData.CreatedOn) : '---'}</span>;
                    },
                },
                {
                    title: 'Downloaded On',
                    className: 'text-center',
                    render: rowData => {
                        return <span>{rowData.DownloadedDate ? dateFormater(rowData.DownloadedDate) : '---'}</span>;
                    },
                },
                {
                    title: 'Actions',
                    className: 'text-center',
                    render: rowData => {
                        if (rowData.DocumentId == null) {
                            if (roles[15]) {
                                return (
                                    <div className="row view-button">
                                        <div className="col pt-2">
                                            <input type="file" className="form-control-file" onChange={(e) => this.handleFileForTransmittleDoc(e)} id="exampleFormControlFile1" />
                                        </div>
                                        <div className="col">
                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={() => this.uploadTransmittalFile(rowData.DocumentDetailsid)} icon={"cloud-upload-alt"} title="Upload Document" color={"black"} size="2x" />
                                        </div>
                                    </div>
                                );
                            } else {
                                return (
                                    <div className="view-button">
                                        <FontAwesomeIcon icon={"stopwatch"} title="Awaiting for upload" color={"black"} size="lg" />
                                    </div>
                                );
                            }
                        }
                        else {
                            return (
                                <div className="view-button">
                                    <div className="row">
                                        <div className="col align-middle">
                                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                {roles[5] ?
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" onClick={() => this.updateTransmittleStatus(rowData.DocumentDetailsid)} />
                                                    :
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                }
                                            </a>
                                        </div>
                                    </div>
                                    {this.props.expediting && this.props.expediting.getPoTransmittleDOcuments ?
                                        (<span className={"badge " + this.state.TransmittalDocStatus[rowData.isDownloaded]['badge']}>
                                            {`${this.state.TransmittalDocStatus[[rowData.isDownloaded]]['title']}`}
                                        </span>)
                                        : null}
                                </div>
                            )
                        }
                    },
                },
            ];
        };
        const BillingScheduleTableConstant = () => {
            return [
                {
                    title: 'Billing Schedule No.',
                    className: 'headeralign',
                    render: rowData => {
                        return <input className="form-control" value={rowData.BillingScheduleNo} onChange={(e) => this.handleBillingScheduleNoUpdate(e, rowData)} onBlur={() => this.updateBillingScheduleNo(6, rowData)} />;
                    },
                },
                {
                    title: 'Description',
                    className: 'headeralign',
                    render: rowData => {
                        return <input className="form-control" value={rowData.Description} onChange={(e) => this.handleDescription(e, rowData)} onBlur={() => this.updateBillingScheduleNo(2, rowData)} />;
                    },
                },
                {
                    title: 'Quantity',
                    className: 'text-center',
                    render: rowData => {
                        return <input className="form-control" value={rowData.Quantity} onChange={(e) => this.handleQuantity(e, rowData)} onBlur={() => this.updateBillingScheduleNo(3, rowData)} />;
                    },
                },
                {
                    title: 'Unit',
                    className: 'text-center',
                    render: rowData => {
                        return <input className="form-control" value={rowData.Unit} onChange={(e) => this.handleUnit(e, rowData)} onBlur={() => this.updateBillingScheduleNo(4, rowData)} />;
                    },
                },
                {
                    title: 'Unit Rate',
                    className: 'text-center',
                    render: rowData => {
                        if (rowData.Quantity != null) {
                            return <input className="form-control" value={rowData.UnitRate} onChange={(e) => this.handleUnitRate(e, rowData)} onBlur={() => this.updateBillingScheduleNo(10, rowData)} />;
                        } else {
                            return <input className="form-control" value={rowData.UnitRate} readOnly />;
                        }
                    },
                },
                {
                    title: 'Total Value',
                    className: 'text-center',
                    render: rowData => {
                        return <input className="form-control" value={rowData.TotalValue} readOnly />;
                    },
                },
            ];
        };
        const BillingScheduleTableConstantNotEditable = () => {
            return [
                {
                    title: 'Billing Schedule No.',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.BillingScheduleNo}</span>
                    },
                },
                {
                    title: 'Description',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.Description}</span>
                    },
                },
                {
                    title: 'Quantity',
                    className: 'text-center',
                    render: rowData => {
                        return <span>{rowData.Quantity}</span>
                    },
                },
                {
                    title: 'Unit',
                    className: 'text-center',
                    render: rowData => {
                        return <span>{rowData.Unit}</span>
                    },
                },
                {
                    title: 'Unit Rate',
                    className: 'text-center',
                    render: rowData => {
                        return <input className="form-control" value={rowData.UnitRate} readOnly />;
                    }
                },
                {
                    title: 'Total Value',
                    className: 'text-center',
                    render: rowData => {
                        return <input className="form-control" value={rowData.TotalValue} readOnly />;
                    },
                },
            ];
        };

        // ?! handleEdit = has all drawing information - like documentid, status etc
        const DrawingtableConstants = (handleEdit, approverData) => {
            console.log(approverData, "approverData")
            if (roles[5]) {
                return [
                    {
                        title: 'Document Name',
                        className: 'headeralign',
                        render: rowData => {
                            return <span>{rowData.DocumentName}</span>;
                            // return <span>{JSON.stringify(handleEdit[rowData.DrawingDocumentDetailsid].approvedByName)}</span>;
                            // return <span>{JSON.stringify(rowData)}</span>;
                        },
                    },
                    {
                        title: 'Submitted On',
                        className: 'text-center',
                        render: rowData => {

                            if (rowData.DocumentId != null) {
                                return <span>{rowData.CreatedOn ? FormatDateTimeInIST(rowData.CreatedOn) : '---'}</span>;
                            }
                            else {
                                return (
                                    <div className="justify-content-between">
                                        <span>{'---'}</span>
                                    </div>
                                )
                            }
                        },
                    },
                    {
                        title: 'Actions',
                        className: 'text-center',
                        render: rowData => {

                            if (roles[5] && (rowData.DocumentId == null || rowData.approvalStatus == 3 || rowData.approvalStatus == 0)) {
                                return (
                                    <>
                                        <div className="row view-button d-inline-flex">
                                            <div className="pt-2">
                                                <input type="file" ref={(ref) => { this.documentRef.current[rowData.DrawingDocumentDetailsid] = ref; return true; }} className="form-control-file" onChange={(e) => { this.handleFileInput(e, rowData) }} id="exampleFormControlFile1" />
                                            </div>
                                            {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                <div className="">
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={(e) => { this.onclickUpload(rowData) }} icon={"cloud-upload-alt"} title="Upload Document" color={"black"} size="2x" />
                                                </div>
                                                : null}
                                            {rowData.DocumentId == null && temp.DeletionIndicator && temp.isHold === 1 ? null :
                                                <>
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"code-branch"} color={"black"} title="Document Version" size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DrawingDocumentDetailsid, rowData.DocumentTypeId, rowData.DocumentId, rowData.POId, rowData.POLineItemId)} />
                                                </>
                                            }
                                            {!rowData.DocumentId ?
                                                <FontAwesomeIcon icon={"trash"} className="align-middle mt-2 pr-2" color="red" size="2x" cursor="pointer" title="Delete" onClick={() => this.onPressDelete(rowData)} />
                                                : <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                </a>}
                                        </div>
                                        <div className=" view-button">
                                            <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                                {rowData.approvalStatus == 0 ?
                                                    `${this.state.docStatus[rowData.approvalStatus]['title']}`
                                                    : rowData.approvalStatus == 4 ? `Document is in process`
                                                        : rowData.approvalStatus == 1 ? `Document is Approved`
                                                            : rowData.approvalStatus == 3 ? `Document is Revised`
                                                                : rowData.approvalStatus == 5 ? `Approved as Noted`
                                                                    : null}
                                            </span>
                                        </div>

                                    </>
                                )
                            }
                            else {
                                return (
                                    <div>
                                        <div className="row view-button">
                                            <div className="col align-middle">
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                </a>
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"code-branch"} color={"black"} title="Document Version" size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                                {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                    <>
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DrawingDocumentDetailsid, rowData.DocumentTypeId, rowData.DocumentId, rowData.POId, rowData.POLineItemId)} />
                                                        {rowData.approvalStatus == 1 ?
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"cloud-upload-alt"} color={"block"} title="Upload New Version" size="2x" onClick={() => this.revisePopUpAction({ actionType: "New Version Documents with out flow", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} />
                                                            : rowData.PartialApproval == 1 ?
                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"cloud-upload-alt"} color={"block"} title="Upload New Version" size="2x" onClick={() => this.revisePopUpAction({ actionType: "New Version Documents with flow", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} />
                                                                : null}
                                                    </>
                                                    : null}
                                            </div>
                                        </div>
                                        <div className="view-button">
                                            {rowData.approvalStatus == 4 && rowData.PartialApproval == 1 ?
                                                <span className={"badge " + this.state.docStatus[5]['badge']}>
                                                    {`${this.state.docStatus[5]['title']}`}
                                                </span>
                                                :
                                                <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                                    {rowData.approvalStatus == 0 ?
                                                        `${this.state.docStatus[rowData.approvalStatus]['title']}`
                                                        : rowData.approvalStatus == 4 ?
                                                            `Document is in process`
                                                            : `${this.state.docStatus[rowData.approvalStatus]['title']} by SMS`}
                                                </span>}
                                        </div>
                                    </div>
                                )
                            }



                        },
                    },
                ];
            }
            return [
                {
                    title: 'Document Name',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{rowData.DocumentName}</span>;
                        // return <span>{JSON.stringify(handleEdit[rowData.DrawingDocumentDetailsid] && handleEdit[rowData.DrawingDocumentDetailsid].RoleId)}</span>;
                        // return <span>{rowData.NextActingRoleName}</span>;
                    },
                },
                {
                    title: 'Acting Department',
                    className: 'headeralign',
                    render: rowData => {
                        if (rowData.approvalStatus == 1) {
                            return (
                                <div className="justify-content-between">
                                    <span>NONE</span>
                                </div>
                            )
                        }
                        else if (rowData.PartialApproval == 1) {
                            return (
                                <div className="justify-content-between">
                                    <span>{this.props.poDetails.poDetails.vendorName}</span>
                                </div>
                            )
                        }
                        else if (rowData.DocumentId != null && rowData.approvalStatus != 3) {
                            return (
                                <div className="justify-content-between">
                                    <span>{rowData.NextActingRoleName ? rowData.NextActingRoleName : '--'}</span>
                                    {roles[12]
                                        &&
                                        this.props.expediting.getExpeditingDocumentsWithDetails.recordset && this.props.expediting.getExpeditingDocumentsWithDetails.recordset.length > 0 && this.props.expediting.getExpeditingDocumentsWithDetails.recordset.find((elem) => elem.DrawingDocumentDetailsId == rowData.DrawingDocumentDetailsid && elem.RoleId == parseInt(Object.keys(AuthHandlerInstance.getRoles())[0]))
                                        &&
                                        this.props.expediting.getAllAssignedEngineerDetails.recordset.filter((elem) => elem.approvalStatus == 1 && elem.DrawingDocumentDetailsId == rowData.DrawingDocumentDetailsid).length > 0 && rowData.approvalStatus != 1 && rowData.approvalStatus != 3 && !temp.DeletionIndicator && temp.isHold !== 1 ?
                                        <FontAwesomeIcon icon={"user-edit"} className="float-right align-middle" title="Edit Engineer Assignment" color={"black"} size="lg" onClick={(e) => this.OpenAssignedEngineerModal(true, rowData.DrawingDocumentDetailsid, 0)} />
                                        : null}
                                    {roles[7]
                                        &&
                                        this.props.expediting.getExpeditingDocumentsWithDetails.recordset && this.props.expediting.getExpeditingDocumentsWithDetails.recordset.length > 0 && this.props.expediting.getExpeditingDocumentsWithDetails.recordset.find((elem) => elem.DrawingDocumentDetailsId == rowData.DrawingDocumentDetailsid && elem.approvedBy == AuthHandlerInstance.getUserID())
                                        &&
                                        this.props.expediting.getAllAssignedEngineerDetails.recordset.filter((elem) => elem.approvalStatus == 1 && elem.DrawingDocumentDetailsId == rowData.DrawingDocumentDetailsid).length > 0 && rowData.approvalStatus != 1 && rowData.approvalStatus != 3 && !temp.DeletionIndicator && temp.isHold !== 1 ?
                                        <FontAwesomeIcon icon={"user-edit"} className="float-right align-middle" title="Edit TPM Assignment" color={"black"} size="lg" onClick={(e) => this.OpenAssignedEngineerModal(true, rowData.DrawingDocumentDetailsid, 1)} />
                                        : null}
                                </div>
                            )
                        }
                        else if ((rowData.approvalStatus == 3) || (handleEdit[rowData.DrawingDocumentDetailsid] && handleEdit[rowData.DrawingDocumentDetailsid].NextActedRoleId == 0)) {
                            return (
                                <div className="justify-content-between">
                                    <span>{this.props.poDetails.poDetails.vendorName}</span>
                                </div>
                            )
                        }
                        else {
                            return (
                                <div className="justify-content-between">
                                    <span>{'---'}</span>
                                </div>
                            )
                        }
                    },
                },
                {
                    title: 'Submitted On',
                    className: 'text-center',
                    render: rowData => {

                        if (rowData.DocumentId != null) {
                            return <span>{rowData.CreatedOn ? FormatDateTimeInIST(rowData.CreatedOn) : '---'}</span>;
                        }
                        else {
                            return (
                                <div className="justify-content-between">
                                    <span>{'---'}</span>
                                </div>
                            )
                        }
                    },
                },
                {
                    title: 'Acted On',
                    className: 'text-center',
                    render: rowData => {
                        if (rowData.DocumentId != null) {
                            return (
                                <div className="justify-content-between">
                                    <span>{rowData.approvedOn ? FormatDateTimeInIST(rowData.approvedOn) : '--'}</span>
                                </div>
                            )
                        }
                        else {
                            return (
                                <div className="justify-content-between">
                                    <span>{'---'}</span>
                                </div>
                            )
                        }
                    },
                },
                {
                    title: 'Actions',
                    className: 'text-center',
                    render: rowData => {

                        if (rowData.approvalStatus == 2) {
                            return (
                                <>
                                    <div className="view-button">
                                        <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                        </a>
                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"code-branch"} color={"black"} title="Document Version" size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DrawingDocumentDetailsid, rowData.DocumentTypeId, rowData.DocumentId, rowData.POId, rowData.POLineItemId)} />
                                    </div>
                                    <div className=" view-button">
                                        <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                            {`${this.state.docStatus[rowData.approvalStatus]['title']} by
                                                ${rowData.approvedByName != '0' ? rowData.approvedByName : rowData.NextActingRoleName}`}
                                        </span>
                                    </div>

                                </>
                            )
                        }
                        else if (roles[5] != true && rowData.DocumentId == null) {
                            if (roles[7] && (rowData.DocumentId == null || rowData.approvalStatus == 3)) {
                                return (
                                    <>
                                        <div className="row view-button d-inline-flex">
                                            <div className="pt-2">
                                                <input type="file" className="form-control-file" onChange={(e) => { this.handleFileInput(e, rowData) }} id="exampleFormControlFile1" />
                                            </div>
                                            {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                <div className="">
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" onClick={(e) => { this.onclickUpload(rowData) }} icon={"cloud-upload-alt"} title="Upload Document" color={"black"} size="2x" />
                                                </div>
                                                : null}
                                            {rowData.approvalStatus != 3 ? null :
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"code-branch"} color={"black"} title="Document Version" size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                            }
                                            {rowData.DocumentId == null && temp.DeletionIndicator && temp.isHold === 1 ? null :
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DrawingDocumentDetailsid, rowData.DocumentTypeId, rowData.DocumentId, rowData.POId, rowData.POLineItemId)} />
                                            }
                                            {!rowData.DocumentId ?
                                                <FontAwesomeIcon icon={"trash"} className="align-middle mt-2 pr-2" color="red" size="2x" cursor="pointer" title="Delete" onClick={() => this.onPressDelete(rowData)} />
                                                : null}
                                        </div>
                                        <div className=" view-button">
                                            {rowData.approvalStatus == 3 ?
                                                <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                                    {rowData.approvalStatus == 0 ?
                                                        `${this.state.docStatus[rowData.approvalStatus]['title']}`
                                                        : rowData.approvalStatus == 4 ? `Document is in process`
                                                            : rowData.approvalStatus == 1 ? `Document is Approved`
                                                                : rowData.approvalStatus == 3 ? `Document is Revised`
                                                                    : rowData.approvalStatus == 5 ? `Approved as Noted`
                                                                        : null}
                                                </span>
                                                : null}
                                        </div>

                                    </>
                                )
                            }
                            else {
                                return (
                                    <div className="view-button">
                                        <FontAwesomeIcon icon={"stopwatch"} title="Awaiting upload from supplier" color={"black"} size="lg" />
                                    </div>
                                );
                            }
                        }
                        else if (roles[17] && approverData[rowData.DrawingDocumentDetailsid] && approverData[rowData.DrawingDocumentDetailsid].UserId == userID && approverData[rowData.DrawingDocumentDetailsid].approvalStatus == 0 && rowData.approvalStatus != 3) {
                            return (
                                <div className="view-button">
                                    <div className="row">
                                        <div className="col align-middle">
                                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                            </a>
                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"code-branch"} color={"black"} title="Document Version" size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                            {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                <>
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.approved)} />
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} />
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DrawingDocumentDetailsid, rowData.DocumentTypeId, rowData.DocumentId, rowData.POId, rowData.POLineItemId)} />
                                                </>
                                                : null}
                                        </div>
                                    </div>
                                    {rowData.DocumentId != null ?
                                        (<span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                            {rowData.approvalStatus == 0 ?
                                                `${this.state.docStatus[rowData.approvalStatus]['title']}`
                                                : rowData.approvalStatus == 4 ? roles[5] ? `Document is in process` :
                                                    `${this.state.docStatus[rowData.approvalStatus]['title']} by ${rowData.approvedByName != '0' ? rowData.approvedByName : rowData.NextActingRoleName}`
                                                    : `${this.state.docStatus[rowData.approvalStatus]['title']} by
                                                    ${rowData.approvedByName != '0' ? rowData.approvedByName : rowData.NextActingRoleName}`}
                                        </span>) : null}
                                </div>
                            )
                        }
                        else if (roles[17] != true && rowData.DocumentId != null && rowData.NextActedRoleId == parseInt(Object.keys(roles)[0]) && rowData.approvalStatus != 3) {
                            return (
                                <div className="view-button">
                                    <div className="row">
                                        <div className="col align-middle">
                                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                            </a>
                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"code-branch"} color={"black"} title="Document Version" size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                            {roles[7] && !temp.DeletionIndicator && temp.isHold !== 1 ?
                                                (this.state.ClaimById == AuthHandlerInstance.getUserID() ?
                                                    <>
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.approved)} />
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"times-circle"} color={"red"} title="Reject" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.rejected)} />
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} />
                                                    </>
                                                    : null)
                                                : roles[12] && !temp.DeletionIndicator && temp.isHold !== 1 && rowData.NextActedRoleId != 7 && handleEdit[rowData.DrawingDocumentDetailsid] && handleEdit[rowData.DrawingDocumentDetailsid].RoleId != 7 ?
                                                    (approverData[rowData.DrawingDocumentDetailsid] && approverData[rowData.DrawingDocumentDetailsid].UserId == userID
                                                        ?
                                                        (<>
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.approved)} />
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"times-circle"} color={"red"} title="Reject" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.rejected)} />
                                                            {this.props.expediting.getExpeditingDocumentsWithDetails.recordset && this.props.expediting.getExpeditingDocumentsWithDetails.recordset.length > 0 && this.props.expediting.getExpeditingDocumentsWithDetails.recordset.find((elem) => elem.DrawingDocumentDetailsId == rowData.DrawingDocumentDetailsid) && this.props.expediting.getAllAssignedEngineerDetails.recordset.filter((elem) => elem.approvalStatus == 1 && elem.DrawingDocumentDetailsId == rowData.DrawingDocumentDetailsid && elem.approvedBy == userID).length > 0 && rowData.approvalStatus != 1 && rowData.approvalStatus != 3 ? <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"clipboard-check"} color={"blue"} title="Partial Approval" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Partial Approval", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} /> : null}
                                                            {rowData.PartialApproval != 1 ?
                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} />
                                                                : null
                                                            }
                                                        </>)
                                                        : null)
                                                    : !temp.DeletionIndicator && temp.isHold !== 1 ?
                                                        (<>
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.approved)} />
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"times-circle"} color={"red"} title="Reject" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.rejected)} />
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} />
                                                        </>)

                                                        : null}
                                            {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DrawingDocumentDetailsid, rowData.DocumentTypeId, rowData.DocumentId, rowData.POId, rowData.POLineItemId)} />
                                                : null}
                                        </div>
                                    </div>
                                    {rowData.DocumentId != null ?
                                        rowData.approvalStatus == 4 && rowData.PartialApproval == 1 ?
                                            <span className={"badge " + this.state.docStatus[5]['badge']}>
                                                {`${this.state.docStatus[5]['title']}`}
                                            </span>
                                            :
                                            (<span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                                {rowData.approvalStatus == 0 ?
                                                    `${this.state.docStatus[rowData.approvalStatus]['title']}`
                                                    : rowData.approvalStatus == 4 ? roles[5] ? `Document is in process` :
                                                        `${this.state.docStatus[rowData.approvalStatus]['title']} by ${rowData.approvedByName != '0' ? rowData.approvedByName : rowData.NextActingRoleName}`
                                                        : `${this.state.docStatus[rowData.approvalStatus]['title']} by
                                                    ${rowData.approvedByName != '0' ? rowData.approvedByName : rowData.NextActingRoleName}`}
                                            </span>) : null}
                                </div>
                            )
                        }
                        else {
                            return (
                                <div>
                                    <div className="row view-button">
                                        <div className="col align-middle">
                                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                            </a>
                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"code-branch"} color={"black"} title="Document Version" size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                            {roles[12]
                                                &&
                                                handleEdit[rowData.DrawingDocumentDetailsid] && handleEdit[rowData.DrawingDocumentDetailsid].RoleId == 17
                                                &&
                                                this.props.expediting.getExpeditingDocumentsWithDetails.recordset && this.props.expediting.getExpeditingDocumentsWithDetails.recordset.length > 0 && this.props.expediting.getExpeditingDocumentsWithDetails.recordset.find((elem) => elem.DrawingDocumentDetailsId == rowData.DrawingDocumentDetailsid && elem.approvedBy == userID)
                                                &&
                                                this.props.expediting.getAllAssignedEngineerDetails.recordset.filter((elem) => (elem.approvalStatus == 1 || elem.approvalStatus == 3) && elem.DrawingDocumentDetailsId == rowData.DrawingDocumentDetailsid && elem.RoleId == 12).length > 0 && rowData.approvalStatus != 1 && rowData.approvalStatus != 3 && rowData.approvalStatus != 0 && !temp.DeletionIndicator && temp.isHold !== 1 ?
                                                (<>
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.approved)} />
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"times-circle"} color={"red"} title="Reject" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.rejected)} />
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"clipboard-check"} color={"blue"} title="Partial Approval" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Partial Approval", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} />
                                                    {rowData.PartialApproval != 1 ?
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} />
                                                        : null
                                                    }
                                                </>)
                                                : null
                                            }
                                            {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DrawingDocumentDetailsid, rowData.DocumentTypeId, rowData.DocumentId, rowData.POId, rowData.POLineItemId)} />
                                                : null}
                                            {!temp.DeletionIndicator && temp.isHold !== 1 && (rowData.approvalStatus == 1 || rowData.PartialApproval == 1) ?
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"cloud-upload-alt"} color={"block"} title="Upload New Version" size="2x" onClick={() => this.revisePopUpAction({ actionType: "New Version Documents with out flow", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} />
                                                : null}
                                        </div>
                                    </div>
                                    <div className="view-button">
                                        {rowData.approvalStatus == 4 && rowData.PartialApproval == 1 ?
                                            <span className={"badge " + this.state.docStatus[5]['badge']}>
                                                {`${this.state.docStatus[5]['title']}`}
                                            </span>
                                            :
                                            <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                                {rowData.approvalStatus == 0 ?
                                                    `${this.state.docStatus[rowData.approvalStatus]['title']}`
                                                    : rowData.approvalStatus == 4 ? roles[5] ? `Document is in process` :
                                                        `${this.state.docStatus[rowData.approvalStatus]['title']} by ${rowData.approvedByName != '0' ? rowData.approvedByName : rowData.NextActingRoleName}`
                                                        : `${this.state.docStatus[rowData.approvalStatus]['title']} by
                                                ${rowData.approvedByName != '0' ? rowData.approvedByName : rowData.NextActingRoleName}`}
                                            </span>}
                                    </div>
                                </div>
                            )
                        }



                    },
                },
                {
                    title: 'Details',
                    className: 'text-center',
                    render: rowData => {
                        return (
                            <div className="view-button pt-4">
                                <FontAwesomeIcon icon={"info-circle"} title="View" color={"black"} size="lg" onClick={(e) => this.Docmodal(rowData.DocumentTypeId, rowData.DocumentName, rowData.DrawingDocumentDetailsid)} />
                            </div>
                        );
                    },
                },
            ];
        };

        var Tabledata = []
        this.props.udploadedpofords && this.props.udploadedpofords.allpofords.length > 0 && this.props.udploadedpofords.allpofords[0].map((value, index) => {
            if (value.POSAPId == this.state.Po) {
                Tabledata.push(value)
            }

        })
        console.log(this.props.expediting.getExpeditingDocumentsWithDetails.recordset, "]]]]]]]]]]]]]]]")
        console.log(this.props.expediting.getAllAssignedEngineerDetails.recordset, "))))))))))")

        const partialPayment = () => {
            return [
                // console.log(rowData,"popopopopop")
                {
                    title: 'Document Type',
                    className: 'headeralign',
                    render: rowData => {
                        // return JSON.stringify(rowData.DocumentId);
                        return <span>{rowData.DocumentTypeName}</span>;
                    },
                },
                {
                    title: 'Acting Depart',
                    className: 'headeralign',
                    render: rowData => {
                        return <span>{roles[5] ? "SMS Team" : rowData.approvalStatus == 3 ? this.props.poDetails.paymentTermDetailsByPoId.vendorName : rowData.GroupName}</span>;
                    },
                },
                {
                    title: 'Submitted On',
                    className: 'text-center',
                    render: rowData => {
                        return <span>{rowData.CreatedOn ? dateFormater(rowData.CreatedOn) : '---'}</span>;
                    },
                },
                {
                    title: 'Acted On',
                    className: 'text-center',
                    render: rowData => {
                        return <span>{rowData.approvedOn ? dateFormater(rowData.approvedOn) : '---'}</span>;
                    },
                },
                {
                    title: 'Actions',
                    className: 'text-center',
                    render: rowData => {
                        if (roles[5]) {
                            if (rowData.DocumentId == null || rowData.approvalStatus == 3 || rowData.approvalStatus == 2) {
                                return (
                                    <>
                                        <div className="view-button justify-content-between row">
                                            <div className="col dark">
                                                <input type="file" className="form-control-file" style={{ width: "69%" }} onChange={(e) => { this.handleFileInput(e, rowData) }} id="exampleFormControlFile1" />
                                            </div>
                                            <div className="col-md-4 mr-2">
                                                {rowData.DocumentTypeId == 41 || rowData.DocumentTypeId == 46 || rowData.DocumentTypeId == 101 || rowData.DocumentTypeId == 110 || rowData.DocumentTypeId == 111 || rowData.DocumentTypeId == 112 || rowData.DocumentTypeId == 113 || rowData.DocumentTypeId == 114 || rowData.DocumentTypeId == 115 || rowData.DocumentTypeId == 118 || rowData.DocumentTypeId == 119 ?
                                                    <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={(e) => { this.AcceptmodalForSupplierPartial(rowData) }} color={"black"} title={"Upload File"} size="lg" />
                                                    : <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={(e) => { this.onclickUploadPartial(rowData) }} color={"black"} title={"Upload File"} size="lg" />
                                                }
                                                {rowData.approvalStatus == 3 ?
                                                    <>
                                                        <FontAwesomeIcon className="align-middle mr-2" icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                                        <FontAwesomeIcon className="align-middle" icon={"sms"} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(rowData.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, rowData.DocumentTypeId, 0)} />
                                                    </>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                        <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                            {this.state.docStatus[rowData.approvalStatus]['title']}
                                        </span>
                                    </>
                                )
                            }
                            else if (rowData.DocumentId != null) {
                                return (
                                    <>
                                        <div className="row align-middle">
                                            <div className="col align-middle">
                                                <FontAwesomeIcon
                                                    className="align-middle pr-2"
                                                    icon={"code-branch"}
                                                    color={"black"}
                                                    title="Document Version"
                                                    size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon icon={"file-download"} title="Download" color={"black"} size="lg" />
                                                </a>
                                                <FontAwesomeIcon className="align-middle ml-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, rowData.DocumentTypeId, 0)} />
                                            </div>
                                        </div>
                                        <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                            {this.state.docStatus[rowData.approvalStatus]['title']}
                                        </span>
                                    </>
                                )
                            }
                        }
                        else {
                            if (rowData.approvalStatus == 6 && parseInt(rowData.ActingDeptGroupId) == parseInt(Object.keys(groups)[0])) {
                                return (
                                    <>
                                        <div className="row">
                                            <div className="col align-middle">
                                                <FontAwesomeIcon
                                                    className="align-middle pr-2"
                                                    icon={"code-branch"}
                                                    color={"black"}
                                                    title="Document Version"
                                                    size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="Download" color={"black"} size="2x" />
                                                </a>

                                                {roles[8] == true && groups[8] == true && ((rowData.DocumentTypeId == 41 || rowData.DocumentTypeId == 46 || rowData.DocumentTypeId == 101 || rowData.DocumentTypeId == 110 || rowData.DocumentTypeId == 111 || rowData.DocumentTypeId == 112 || rowData.DocumentTypeId == 113 || rowData.DocumentTypeId == 114 || rowData.DocumentTypeId == 115 || rowData.DocumentTypeId == 118 || rowData.DocumentTypeId == 119)) ?
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.AcceptmodalPartial(rowData.AdvanceStageDocumentMappingIdPartial, rowData, rowData.DocumentId)} />
                                                    //: <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.handleApproval(this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, this.state.approvalStatus.approved, element.DocumentTypeName, this.state.docStatus['1'].status)} />
                                                    : <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents partial", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.approved)} />
                                                }

                                                {/* <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"times-circle"} color={"red"} title="Reject" size="2x" onClick={() => this.handleApproval(this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, this.state.approvalStatus.rejected, element.DocumentTypeName, this.state.docStatus['2'].status)} /> */}
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents partial", param: rowData, qATemplateStageId: 1 }, true, 0, rowData.DocumentId, this.state.approvalStatus.revise)} />
                                                {/* onClick={() => this.handleApproval(this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, this.state.approvalStatus.revise, element.DocumentTypeName, this.state.docStatus['3'].status)} /> */}
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, rowData.DocumentTypeId, 0)} />
                                            </div>
                                        </div>
                                        <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                            {this.state.docStatus[rowData.approvalStatus]['title']}
                                        </span>
                                    </>
                                )
                            }
                            else if (rowData.DocumentId != null) {
                                return (
                                    <>
                                        <div className="row align-middle">
                                            <div className="col align-middle">
                                                <FontAwesomeIcon
                                                    className="align-middle pr-2"
                                                    icon={"code-branch"}
                                                    color={"black"}
                                                    title="Document Version"
                                                    size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                                    <FontAwesomeIcon icon={"file-download"} title="Download" color={"black"} size="lg" />
                                                </a>
                                                <FontAwesomeIcon className="align-middle ml-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(rowData.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, rowData.DocumentTypeId, 0)} />
                                            </div>
                                        </div>
                                        <span className={"badge " + this.state.docStatus[rowData.approvalStatus]['badge']}>
                                            {this.state.docStatus[rowData.approvalStatus]['title']}
                                        </span>
                                    </>
                                )
                            }
                        }
                    },
                },
            ];
        };

        return (


            <div className="Container-fluid pageheight"  >
                {/* { (Getdate()).toLocaleString() } */}
                {/*----------Document comment-------------- */}
                {
                    varIdPayment || varId ? (<DocumentCommentsByDocumentIdPopUp action={this.state.DocumentCommentsByDocumentIdPopUpModal} toggleDocumentCommentsByDocumentIdPopUpModal={(e) => this.toggleDocumentCommentsByDocumentIdPopUpModal(e)} DocumentId={varIdPayment ? varIdPayment : varId} PoId={varPoIdPayment ? varPoIdPayment : varPoId} PoLineId={varPoLineId} rowDocumentTypeId={vardocumentTypeIdPayment ? vardocumentTypeIdPayment : vardocumentTypeId} rowDrawingDocumentDetailId={vardrawingDocumentDetailIdPayment ? vardrawingDocumentDetailIdPayment : vardrawingDocumentDetailId}
                        path='/ExpeditingPOAcceptanceTrail' />) : null
                }
                {/*----------Document Comment end  */}
                {/*----------Document comment-------------- */}
                {
                    ProgressPoId && ProgressLineId ? (<ProgressReportCommentsPopUp action={this.state.ProgressReportCommentsPopUp} toggleProgressReportCommentsPopUp={(e) => this.toggleProgressReportCommentsPopUp(e)} ProgressPoId={ProgressPoId} ProgressLineId={ProgressLineId} progressDocumentTypeId={progressDocumentTypeId} path='/ExpeditingPOAcceptanceTrail' />) : null
                }
                {/*----------Document Comment end  */}

                <div className="Container-fluid p-4" >
                    <Modal isOpen={this.state.warningmodal} >
                        <div className={"modal-bg" + (this.state.warningmodal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 >Warning Modal </h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={(e) => this.warningmodal(e)} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body">
                                    <div className="row ml-2 pt-2">
                                        <div className="col-md-10"><b>Are You Sure To Submit As The TotalValue Is Less Than Total PO Line Item Value ?</b></div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className=" btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.warningmodal()} type="submit">NO</button>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.updateBillingScheduleNo(5, this.state.LineItemID)} type="submit">YES</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* ---------Approve DeliverScheduleModal by Expeditor Start-------- */}
                    <Modal isOpen={this.state.datemodal}>

                        <ModalHeader HeaderStyle=" modal-header">
                            <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Set Dates</h4>
                            <button type="button" className="close" aria-label="Close" onClick={this.datemodal} style={{ color: 'black' }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>


                        <ModalBody Style="modal-body modalbodyssmall">

                            <div className="row mt-2">
                                <div className="col pt-2 ">
                                    <div className="row">
                                        <div className="col-md-6"><b>Set Expected Delivery Date : </b></div>
                                        <div className="col">

                                            <input type='date' id="myDate" value={this.state.value} onChange={(e) => this.handleExpectedDeliveryDate(e)} />
                                            {/* <button onClick={this.handleClick} className='btn-border'> <p id="demo"></p></button> */}

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col pt-2">
                                    <div className="row">
                                        <div className="col-md-6"><b>Set Document Submission Due Date : </b></div>
                                        <div className="col">

                                            <input type='date' id="myDate1" value={this.state.value} onChange={(e) => this.handleSubmissionDueDate(e)} />
                                            {/* <button onClick={this.handleClick} className='btn-border'> <p id="demo1"></p></button> */}

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </ModalBody>
                        <ModalFooter FooterStyle="modal-footer ">
                            <div>

                                <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={this.approvalmodalsubmit} type="submit">OK</button>

                                <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={this.datemodal} type="submit">Cancel</button>

                            </div>

                        </ModalFooter>
                    </Modal>
                    {/* --------Approve DeliverScheduleModal by Expeditor  End-------------- */}

                    {/* Modal start */}
                    <Modal isOpen={this.state.Docmodal} className="modal-lg">
                        <div className={"modal-bg" + (this.state.Docmodal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header  ">
                                    <div><h4 >Document Details</h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={() => this.Docmodal(0, "")} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>

                            <div >
                                <ModalBody Style="modal-body modalbodysWideBudget ">
                                    <div className="col-md-12 pt-2">
                                        <div className="row ">
                                            <div className="col-md-4 pt-2 " ><b>Document Name :</b></div>
                                            <div className="col-md-6 pt-2"> {this.state.DocumentTypeName}</div>
                                        </div>

                                        <div className="row  mt-4 align">
                                            <div className="col ">
                                                <table border="1" className="table5 table" >
                                                    <thead>
                                                        <tr className="headerbar ">
                                                            <th>Acted Department</th>
                                                            <th>Acted Person</th>
                                                            <th>Acted On</th>
                                                            <th>Action Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.props.expediting && this.props.expediting.getExpeditingDocumentsWithDetails && this.props.expediting.getExpeditingDocumentsWithDetails.recordset && this.props.expediting.getExpeditingDocumentsWithDetails.recordset.length > 0 && this.props.expediting.getExpeditingDocumentsWithDetails.recordset.map((element, index) =>
                                                            element.DrawingDocumentDetailsId == this.state.DrawingDetailID ?
                                                                <tr key={index} className="rows headeralign">
                                                                    {/* <td>{JSON.stringify(element)}</td> */}
                                                                    <td>{element.departmentName}</td>
                                                                    <td>{element.approvedByName}</td>
                                                                    <td>{FormatDateTimeInIST(element.approvedOn)}</td>
                                                                    <td>{element.CountAssignment !== 0 ?
                                                                        this.state.docStatus1[element.approvalStatus].title + " by " + element.approvedByName
                                                                        : this.state.docStatus[element.approvalStatus].title + " by " + element.approvedByName
                                                                    }</td>
                                                                </tr>
                                                                : null

                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer ">
                                    <div>
                                        <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={() => this.Docmodal(0, "")}> Close </button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* -----------Modal end----------- */}

                    {/* ASSIGN ENGINEER MODAL */}
                    <Modal isOpen={this.state.assignmodal} >
                        <div className={"modal-bg" + (this.state.assignmodal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header modalheader">
                                    <div><h4 >Approve & Assign Engineer </h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={this.assignmodal} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body modalbody1">
                                    <div className="row ">
                                        <div className="col-sm-6">
                                            Upload Document (Optional)
                                        </div>
                                        <div className="col-sm-6">
                                            <input type="file" className="form-control-file" name="" onChange={(e) => { this.handleFileInputforRevision(e) }} id="exampleFormControlFile2" />
                                        </div>
                                    </div>
                                    <div className="row ml-2 pt-2">
                                        <div className="col-md-5"><b>Comments <em>(if any)</em> :</b></div>
                                        <div className="col-md-7">
                                            <textarea className="form-control" rows="2" value={this.state.comments} onChange={this.comments}></textarea>
                                        </div>
                                    </div>
                                    {/* {this.state.revisedPayload.param.DocumentTypeId == 86 ? */}
                                    <div className="row pt-2">
                                        <div className="col-md-6"><b>Assign Engineer :</b></div>
                                        <div className="col-md-6 " >
                                            {/* <DropdownFlat defaultopt="Select Option" data={this.state.engineeringData} keyObjName={"UserId"} valueObjName={"FullName"} actions={this.handleengineer} /> */}
                                            <Select maxMenuHeight={130} isMulti mode="multiple" options={this.state.engineeringData} onChange={(e) => this.handleengineer(e)}
                                            />
                                        </div>
                                    </div>
                                    {/* : null} */}
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer modalfooterWide">
                                    <div>
                                        <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={this.assignmodal} type="submit">Cancel</button>
                                        {/* <Link  to ={{ pathname: '/',state :  { } } }> */}
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right"
                                            // onClick={() => this.submitassignmodal(this.props.poDetails.poDetails.poId, this.state.LineItemID, "",
                                            //     this.state.approvalStatus.approved, "", this.state.docStatus['1'].status)} 
                                            onClick={() => this.formSaveAction()}
                                            type="submit">Approve and Assign</button>
                                        {/* </Link> */}
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* ASSIGN ENGINEER MODAL ENDS */}

                    {/* Add Drawing MODAL starts */}
                    <Modal isOpen={this.state.addDrawingmodal} >
                        <div className={"modal-bg" + (this.state.addDrawingmodal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 >Add Document </h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={() => { this.addDrawingInputmodal() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body">
                                    <div className="row ml-2 pt-2">
                                        <div className="col-md-5"><b>Document Name :</b></div>
                                        <div className="col-md-7">
                                            <input type="text" className="form-control" value={this.state.documentName} onChange={(e) => this.setDocumentName(e)}></input>
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.addDrawingInputmodal() }} type="submit">Cancel</button>
                                        {this.state.fl == 1 ? <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.addDrawingtoList(1) }} type="submit">Add Document</button>
                                            : <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.addDrawingtoList() }} type="submit">Add Document</button>}
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* Add Drawing MODAL ENDS */}
                    {/* Add Document MODAL starts */}
                    <Modal isOpen={this.state.addDocumentmodal} >
                        <div className={"modal-bg" + (this.state.addDocumentmodal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 >Add Documents </h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={() => { this.addDocumentmodal() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body">
                                    <div className="row ml-2 pt-2">
                                        <div className="col-md-5"><b>Document Name :</b></div>
                                        <div className="col-md-7">
                                            <input type="text" className="form-control" value={this.state.transmittleDocumentName} onChange={(e) => this.setTransmittleDocumentName(e)}></input>
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.addDocumentmodal() }} type="submit">Cancel</button>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.addDocumentstoList(this.state.indicator) }} type="submit">Add Document</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* Add Document MODAL ENDS */}
                    {/* Add Document MODAL starts */}
                    <Modal isOpen={this.state.addBillingScheduleDetails} >
                        <div className={"modal-bg" + (this.state.addBillingScheduleDetails === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 >Add Documents </h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={() => { this.addBillingScheduleDetails() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body">
                                    <div className="row ml-2 pt-2">
                                        <div className="col-md-5"><b>Billing Schedule No. :</b></div>
                                        <div className="col-md-7">
                                            <input type="text" className="form-control" value={this.state.BillingScheduleNo} onChange={(e) => this.handleBillingScheduleNo(e)}></input>
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.addBillingScheduleDetails() }} type="submit">Cancel</button>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.handleaddBillingScheduleDetails() }} type="submit">Add</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* Add Document MODAL ENDS */}

                    {/* --------Success Failure Modal for upload delivery schedule for supplier Start-------------- */}
                    <div>
                        <SuccessFailureModal action={this.state.modal} toggleSuccessModal={(e) => this.toggleSuccessModal(e)}
                            headertitle={this.state.headertitle} text={this.state.text} icon='check-circle' iconcolor="green" FooterButton="OK" path='/TestModal' />
                    </div>
                    {/* --------Success Failure Modal End-------------- */}
                    {/*----------QA Document comment-------------- */}
                    {this.state.showCommentPopUp && <DocumentCommentsPopUp showCommentPopUp={this.state.showCommentPopUp} docStatus={this.state.docStatus} uploadedId={this.state.uploadedId} revisedPayload={this.state.revisedPayload1} purchaseLIneItemID={this.state.LineItemID} purchaseOrderId={this.props.poDetails.poDetails.poId} documentComments={(payLoad, id) => this.documentComments(payLoad, id)} />}
                    {/*----------QA Document comment End-------------- */}

                    {/* Modal for Approval start */}
                    {/* ---------- Version Modal Start -------------*/}
                    {this.state.uploadedId && this.state.OpenVersionmodal && <FileVersionModal OpenVersionmodal={this.state.OpenVersionmodal} uploadedId={this.state.uploadedId} OpenVersionModal={(uploadId) => this.OpenVersionModal(uploadId)} />}
                    {/* ---------- Vendor Modal End -------------*/}
                    {/*---------Document Reject popup */}
                    {this.state.showRejectPopUp && <DocumentRejectPopUp rejectPopUpAction={(payLoad, status, callAct) => this.rejectPopUpAction(payLoad, status, callAct)} showRejectPopUp={this.state.showRejectPopUp} revisedPayload={this.state.revisedPayload} purchaseLIneItemID={this.state.purchaseLIneItemID} purchaseOrderId={this.state.purchaseOrderId} />}
                    {/*---------Document Reject popup End */}
                    {/*----------Document comment-------------- */}
                    {/* Modal for Approval end */}

                    {/* revise modal start */}
                    {this.state.showRevisedPopUp && <Modal isOpen={this.state.showRevisedPopUp} >
                        <div className={"modal-bg modal-lg" + (this.state.OpenVersionmodal == true ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div className="modal-text"><h4 >{this.state.revisedPayload && this.state.revisedPayload.param && this.state.revisedPayload.param.documentTypeName ? `${this.state.revisedPayload.param.documentTypeName}` : null}</h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={(e) => this.close()} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div>
                                <ModalBody Style="modal-body">

                                    <div className="row ">
                                        <div className="col-8"></div>
                                        <div className="col-4 pb-2">
                                            {/* <DropdownFlat defaultopt="-Select-"  data={this.state.Date} actions={this.handleSelect} keyObjName={"value"} valueObjName={"label"} /> */}
                                        </div>
                                    </div>

                                    <div className="row col-sm-12" style={{ textAlign: "center", display: "none", top: "40%" }}>
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>

                                    <div className="row ">
                                        <div className="col-sm-6">
                                            Upload Document (Optional)
                                        </div>
                                        <div className="col-sm-6">
                                            <input type="file" className="form-control-file" name="" onChange={(e) => { this.handleFileInputforRevision(e) }} id="exampleFormControlFile2" />
                                        </div>
                                    </div>

                                    <div className="row mt-4">
                                        <div className="col-sm-6">
                                            Comment
                                        </div>
                                        <div className="col-sm-6">
                                            <textarea className="form-control" onChange={(e) => this.formChange(e)}>{this.state.reviseForm.comment}</textarea>
                                        </div>
                                    </div>
                                    {roles[12] && this.state.revisedPayload.param.DocumentTypeId == 86 && this.state.actionstatus == 1 ?
                                        <>
                                            {this.state.revisedPayload.actionType == "Supplier Documents-New Version" ?
                                                <div className="row pt-2">
                                                    <div className="col-md-6"><b>Approval From Engineer * :</b></div>
                                                    <div className="col-md-6">
                                                        <DropdownFlat defaultopt="Select Option" selectedValue={this.state.byPassEngineer} data={this.state.byPassEngineerData} keyObjName={"label"} valueObjName={"value"} actions={this.handleByPassEngineer} />
                                                    </div>
                                                </div>
                                                : null}
                                            {this.state.revisedPayload.actionType == "Supplier Documents-New Version" ?
                                                this.state.byPassEngineer == 'No' ? null :
                                                    (<div className="row pt-2">
                                                        <div className="col-md-6"><b>Assign Engineer :</b></div>
                                                        {/* <div className="col-md-5"><b>{JSON.stringify(this.state.revisedPayload.param.DocumentTypeId)}</b></div> */}
                                                        <div className="col-md-6 " >
                                                            {/* <DropdownFlat defaultopt="Select Option" data={this.state.engineeringData} keyObjName={"UserId"} valueObjName={"FullName"} actions={this.handleengineer} /> */}
                                                            <Select maxMenuHeight={130} isMulti mode="multiple" options={this.state.engineeringData} onChange={(e) => this.handleengineer(e)} />
                                                        </div>
                                                    </div>)
                                                : this.props.expediting.getAllAssignedEngineerDetails.recordset.filter((elem) => elem.approvalStatus == 1 && elem.DrawingDocumentDetailsId == this.state.revisedPayload.param.DrawingDocumentDetailsid).length > 0 ?
                                                    null :
                                                    (
                                                        <>
                                                            <div className="row pt-2">
                                                                <div className="col-md-6"><b>Approval From Engineer * :</b></div>
                                                                <div className="col-md-6">
                                                                    <DropdownFlat defaultopt="Select Option" selectedValue={this.state.byPassEngineer} data={this.state.byPassEngineerData} keyObjName={"label"} valueObjName={"value"} actions={this.handleByPassEngineer} />
                                                                </div>
                                                            </div>
                                                            {this.state.byPassEngineer == 'No' ? null :
                                                                <div className="row pt-2">
                                                                    <div className="col-md-6"><b>Assign Engineer :</b></div>
                                                                    {/* <div className="col-md-5"><b>{JSON.stringify(this.state.revisedPayload.param.DocumentTypeId)}</b></div> */}
                                                                    <div className="col-md-6 " >
                                                                        {/* <DropdownFlat defaultopt="Select Option" data={this.state.engineeringData} keyObjName={"UserId"} valueObjName={"FullName"} actions={this.handleengineer} /> */}
                                                                        <Select maxMenuHeight={130} isMulti mode="multiple" options={this.state.engineeringData} onChange={(e) => this.handleengineer(e)} />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </>)
                                            }
                                        </>
                                        : roles[7] && this.state.revisedPayload.param.DocumentTypeId == 86 && this.state.actionstatus == 1 ?
                                            <div className="row pt-2">
                                                <div className="col-md-6"><b>Assign TPM :</b></div>
                                                {/* <div className="col-md-5"><b>{JSON.stringify(this.state.revisedPayload.param.DocumentTypeId)}</b></div> */}
                                                <div className="col-md-6 " >
                                                    {/* <DropdownFlat defaultopt="Select Option" data={this.state.engineeringData} keyObjName={"UserId"} valueObjName={"FullName"} actions={this.handleengineer} /> */}
                                                    <Select maxMenuHeight={130} isMulti mode="multiple" options={this.state.TPMData} onChange={(e) => this.handleengineer(e)} />
                                                </div>
                                            </div>
                                            : null}
                                </ModalBody>
                            </div>
                            <div className="">
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 ml-2 float-right" onClick={() => this.formSaveAction()} type="submit">Save</button>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 ml-2 " onClick={() => this.close()} type="submit">Close</button>

                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    }

                    {/* Assigned engineer list start */}
                    <Modal isOpen={this.state.AssignedEngineerModal} >
                        <div className={"modal-bg" + (this.props.assignedEnginnermodal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div className="modal-text">
                                        {
                                            this.state.editFlag == 1 ?
                                                <h4>Assigned TPM</h4>
                                                : <h4>Assigned Engineers</h4>
                                        }
                                    </div>
                                    <button type="button" className="close" aria-label="Close" onClick={(e) => this.OpenAssignedEngineerModal(false)} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div>
                                <ModalBody Style="modal-body modalbodys">

                                    <div className="row ">
                                        <div className="col-8"></div>
                                        <div className="col-4 pb-2">
                                            {/* <DropdownFlat defaultopt="-Select-"  data={this.state.Date} actions={this.handleSelect} keyObjName={"value"} valueObjName={"label"} /> */}
                                        </div>
                                    </div>
                                    {this.state.editFlag == 1 ?
                                        this.state.tpmList && this.state.tpmList.length < 1 && <div className="row col-sm-12" style={{ textAlign: "center", display: "block", top: "40%" }}>
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                        :
                                        this.state.engineerList && this.state.engineerList.length < 1 && <div className="row col-sm-12" style={{ textAlign: "center", display: "block", top: "40%" }}>
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    }
                                    <div>
                                    </div>
                                    {this.state.editFlag == 0 ?
                                        this.state.engineerList && this.state.engineerList.map((item, i) => {

                                            return <div key={i} className="">
                                                <div className="row border border-radius-modal ml-2 mr-2 mt-2">
                                                    <div className="col-8">
                                                        <div><h5>{item.FullName}</h5></div>
                                                        {/* <div className="text-left">comments(<em>if any</em>): None</div> */}
                                                        <div className=" row text-left">
                                                            <div className="col-md-12 ">Engineer Name: {item.FullName}</div>
                                                            <div className="col-12">Assigned On: {FormatDateTimeInIST(item.CreatedOn)}</div>
                                                            {item.approvalStatus !== 0 ?
                                                                <div className="col-12"><span className="badge badge-success">Acted On: {FormatDateTimeInIST(item.approvedOn)}</span></div>
                                                                : null}
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="row pt-4" style={{ float: "right", paddingRight: "10px" }}>
                                                            <div className="ml-4 border" >
                                                                {item.approvalStatus == 0 ?
                                                                    <FontAwesomeIcon icon={"trash"} color={"red"} title="View" size="lg" onClick={(e) => { this.deleteEngineer(item.AssignedEngineersForDrawingId) }} />
                                                                    : null}
                                                            </div>
                                                            {/* <div className="ml-4 border"> <FontAwesomeIcon icon={i==0?'check-circle':'history'} color={i==0?'green':'red'} size="lg" /></div>  */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        })
                                        :
                                        this.state.tpmList && this.state.tpmList.map((item, i) => {

                                            return <div key={i} className="">
                                                <div className="row border border-radius-modal ml-2 mr-2 mt-2">
                                                    <div className="col-8">
                                                        <div><h5>{item.FullName}</h5></div>
                                                        {/* <div className="text-left">comments(<em>if any</em>): None</div> */}
                                                        <div className=" row text-left">
                                                            <div className="col-md-12 ">TPM Name: {item.FullName}</div>
                                                            <div className="col-12">Assigned On: {FormatDateTimeInIST(item.CreatedOn)}</div>
                                                            {item.approvalStatus !== 0 ?
                                                                <div className="col-12"><span className="badge badge-success">Acted On: {FormatDateTimeInIST(item.approvedOn)}</span></div>
                                                                : null}
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="row pt-4" style={{ float: "right", paddingRight: "10px" }}>
                                                            <div className="ml-4 border" >
                                                                {item.approvalStatus == 0 ?
                                                                    <FontAwesomeIcon icon={"trash"} color={"red"} title="View" size="lg" onClick={(e) => { this.deleteEngineer(item.AssignedEngineersForDrawingId) }} />
                                                                    : null}
                                                            </div>
                                                            {/* <div className="ml-4 border"> <FontAwesomeIcon icon={i==0?'check-circle':'history'} color={i==0?'green':'red'} size="lg" /></div>  */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        })
                                    }
                                    {this.state.editFlag == 0 ?
                                        <div className="row ml-2 pt-2">
                                            <div className="col-md-5"><b>Assign Engineer :</b></div>
                                            <div className="col-md-7 " >
                                                <Select maxMenuHeight={130} isMulti mode="multiple" options={this.state.engineeringData.filter(elem => !this.state.engineerList.find(i => i.UserId == elem.value))} onChange={(e) => this.handleengineer(e)} />
                                            </div>
                                        </div>
                                        :
                                        <div className="row ml-2 pt-2">
                                            <div className="col-md-5"><b>Assign TPM :</b></div>
                                            <div className="col-md-7 " >
                                                <Select maxMenuHeight={130} isMulti mode="multiple" options={this.state.TPMData.filter(elem => !this.state.tpmList.find(i => i.UserId == elem.value))} onChange={(e) => this.handletpm(e)} />
                                            </div>
                                        </div>
                                    }
                                </ModalBody>
                            </div>
                            <div className="">
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={() => this.OpenAssignedEngineerModal(false)} type="submit">Close</button>
                                        {this.state.editFlag == 0 ?
                                            <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={() => this.saveEngineerDetails(this.state.editDocType, 0)} type="submit">Save</button>
                                            : <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={() => this.saveEngineerDetails(this.state.editDocType, 1)} type="submit">Save</button>
                                        }
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* Assigned engineer list end */}
                    {/* ----Accept Modal Start----- */}

                    <Modal isOpen={this.state.Acceptmodal} className="modal-lg">
                        <div
                            className={
                                "modal-bg" + (this.state.Acceptmodal === "false" ? "open" : "")
                            }
                        >
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div>
                                        <h4> Proforma Invoice Details </h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        aria-label="Close"
                                        onClick={this.Acceptmodal}
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>

                            <div>
                                <ModalBody Style="modal-body">
                                    {this.state.invoiceDetails.length > 0 && this.state.invoiceDetails.map((elem, index) =>
                                        <div key={index}>
                                            <div className="row pt-2 mt-4">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <b> Proforma Invoice No: </b>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <input type="text" className="form-control text-center" value={this.state.InvoiceNo ? this.state.InvoiceNo : elem.InvoiceNo} onChange={(e) => this.InvoiceNoInput(e)}></input>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <b>Proforma Invoice Date:</b>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <input type="date" max={formatDate(new Date())} className="form-control text-center" value={this.state.InvoiceDate ? this.state.InvoiceDate : formatDate(elem.InvoiceDate)} onChange={(e) => this.handleInvoiceDate(e)}></input>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row  pt-2 mt-4">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <b> Project code: </b>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <input
                                                                type="text"
                                                                readOnly
                                                                className="form-control text-center"
                                                                value={this.props.poDetails.paymentTermDetailsByPoId.wbsCode ? (this.props.poDetails.paymentTermDetailsByPoId.wbsCode).substring(0, 6) : "NA"}
                                                            ></input>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <b> Due Date:</b>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <input
                                                                type="date"
                                                                min={formatDate(new Date())}
                                                                max={formatDate(this.state.InvoiceDate)}
                                                                className="form-control text-center"
                                                                value={this.state.DueDate}
                                                                onChange={this.handleDueDate}
                                                            ></input>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                            <div className="row pt-2 mt-4">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <b>Proforma Invoice Amount: </b>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center"
                                                                value={this.state.InvoiceAmount ? this.state.InvoiceAmount : elem.InvoiceAmount}
                                                                onValueChange={(value, name) => this.InvoiceAmountInput(value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.props.poDetails.paymentTermDetailsByPoId.Currency && this.props.poDetails.paymentTermDetailsByPoId.Currency.trim() === "INR" ?
                                                    <div className="col-md-6">
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <b> Exchange Rate: </b>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <CurrencyInput allowNegativeValue={false} decimalScale="4" className="form-control text-center" value={1} readOnly />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="col-md-6">
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <b> Exchange Rate: </b>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <CurrencyInput allowNegativeValue={false} decimalScale="4" className="form-control text-center"
                                                                    value={this.state.ExchangeRate ? this.state.ExchangeRate : elem.ExchangeRate}
                                                                    onValueChange={(value, name) => this.handleExchangeRate(value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="row pt-2 mt-4">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <b> Currency: </b>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <input
                                                                type="text"
                                                                readOnly
                                                                className="form-control text-center"
                                                                value={this.props.poDetails.paymentTermDetailsByPoId.Currency ? this.props.poDetails.paymentTermDetailsByPoId.Currency.trim() : "NA"}
                                                            ></input>
                                                        </div>
                                                    </div>
                                                </div>
                                                {elem.IsPartial != null || elem.IsPartial != 0 ?
                                                    <div className="col-md-6">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <b>Opted For :</b>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <Switch onChange={(e) => this.handleSwitchByApTeam(e)} checked={this.state.checkedSwitchByApTeam != 0 ? this.state.checkedSwitch : elem.IsPartial} onColor="#86d3ff" onHandleColor="#2693e6" handleDiameter={30} uncheckedIcon={false} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" id="material-switch" />
                                                            </div>
                                                            <div className="col-md-4">
                                                                {this.state.checkedSwitchByApTeam != 0 ?
                                                                    this.state.checkedSwitch ? <span className="badge badge-primary">Partial Payment</span> : <span className="badge badge-warning">Full Payment</span>
                                                                    : elem.IsPartial == 1 || elem.IsPartial == 2 ? <span className="badge badge-primary">Partial Payment</span> : <span className="badge badge-warning">Full Payment</span>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : null}

                                            </div>
                                            <div className="row pt-2 mt-4">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <b>Proforma Invoice Amount (INR): </b>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.ExchangeRate ? (elem.InvoiceAmount * this.state.ExchangeRate) : (elem.InvoiceAmount * elem.ExchangeRate)} readOnly />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer ">
                                    <div>
                                        <button className="btn2 btn-sms1 mt-2 rounded-pill ml-4 float-right" onClick={() => this.handleApproval(this.props.poDetails.paymentTermDetailsByPoId.poId, this.state.DocumentTypeId, this.state.approvalStatus.approved, this.state.DocumentTypeName, this.state.docStatus['1'].status, this.state.dataFull, this.state.invoiceDetails)} type="submit">
                                            Accept
                                        </button>
                                        <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={this.Acceptmodal}>{" "}Cancel{" "}</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>

                    {/* ---- Accept Modal End-------- */}
                    {/* ----Accept Modal Partial Start----- */}

                    <Modal isOpen={this.state.AcceptmodalPartial} className="modal-lg">
                        <div
                            className={
                                "modal-bg" + (this.state.AcceptmodalPartial === "false" ? "open" : "")
                            }
                        >
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div>
                                        <h4> Proforma Invoice Details </h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        aria-label="Close"
                                        onClick={this.AcceptmodalPartial}
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>

                            <div>
                                <ModalBody Style="modal-body">
                                    {this.state.invoiceDetails.length > 0 && this.state.invoiceDetails.map((elem, index) =>
                                        <div key={index}>
                                            <div className="row pt-2 mt-4">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <b> Proforma Invoice No: </b>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <input type="text" className="form-control text-center" value={this.state.InvoiceNo ? this.state.InvoiceNo : elem.InvoiceNo} onChange={(e) => this.InvoiceNoInput(e)}></input>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <b>Proforma Invoice Date:</b>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <input type="date" max={formatDate(new Date())} className="form-control text-center" value={this.state.InvoiceDate ? this.state.InvoiceDate : formatDate(elem.InvoiceDate)} onChange={(e) => this.handleInvoiceDate(e)}></input>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row  pt-2 mt-4">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <b> Project code: </b>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <input
                                                                type="text"
                                                                readOnly
                                                                className="form-control text-center"
                                                                value={this.props.poDetails.paymentTermDetailsByPoId.wbsCode ? (this.props.poDetails.paymentTermDetailsByPoId.wbsCode).substring(0, 6) : "NA"}
                                                            ></input>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <b> Due Date:</b>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <input
                                                                type="date"
                                                                min={formatDate(new Date())}
                                                                max={formatDate(this.state.InvoiceDate)}
                                                                className="form-control text-center"
                                                                value={this.state.DueDate}
                                                                onChange={this.handleDueDate}
                                                            ></input>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                            <div className="row pt-2 mt-4">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <b>Proforma Invoice Amount: </b>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center"
                                                                value={this.state.InvoiceAmount ? this.state.InvoiceAmount : elem.InvoiceAmount}
                                                                onValueChange={(value, name) => this.InvoiceAmountInput(value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.props.poDetails.paymentTermDetailsByPoId.Currency && this.props.poDetails.paymentTermDetailsByPoId.Currency.trim() === "INR" ?
                                                    <div className="col-md-6">
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <b> Exchange Rate: </b>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <CurrencyInput allowNegativeValue={false} decimalScale="4" className="form-control text-center" value={1} readOnly />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="col-md-6">
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <b> Exchange Rate: </b>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <CurrencyInput allowNegativeValue={false} decimalScale="4" className="form-control text-center" value={this.state.ExchangeRate ? this.state.ExchangeRate : elem.ExchangeRate} onValueChange={(value) => this.handleExchangeRate(value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="row pt-2 mt-4">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <b> Currency: </b>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <input
                                                                type="text"
                                                                readOnly
                                                                className="form-control text-center"
                                                                value={this.props.poDetails.paymentTermDetailsByPoId.Currency ? this.props.poDetails.paymentTermDetailsByPoId.Currency.trim() : "NA"}
                                                            ></input>
                                                        </div>
                                                    </div>
                                                </div>
                                                {elem.IsPartial != null || elem.IsPartial != 0 ?
                                                    <div className="col-md-6">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <b>Opted For :</b>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <Switch onChange={(e) => this.handleSwitchByApTeam(e)} checked={this.state.checkedSwitchByApTeam != 0 ? this.state.checkedSwitch : elem.IsPartial} onColor="#86d3ff" onHandleColor="#2693e6" handleDiameter={30} uncheckedIcon={false} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" id="material-switch" />
                                                            </div>
                                                            <div className="col-md-4">
                                                                {this.state.checkedSwitchByApTeam != 0 ?
                                                                    this.state.checkedSwitch ? <span className="badge badge-primary">Partial Payment</span> : <span className="badge badge-warning">Full Payment</span>
                                                                    : elem.IsPartial == 1 || elem.IsPartial == 2 ? <span className="badge badge-primary">Partial Payment</span> : <span className="badge badge-warning">Full Payment</span>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : null}

                                            </div>
                                            <div className="row pt-2 mt-4">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <b>Proforma Invoice Amount (INR): </b>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.ExchangeRate ? (elem.InvoiceAmount * this.state.ExchangeRate) : (elem.InvoiceAmount * elem.ExchangeRate)} readOnly />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer ">
                                    <div>
                                        <button className="btn2 btn-sms1 mt-2 rounded-pill ml-4 float-right" onClick={() => this.handleApprovalPartial(this.state.AdvanceStageDocumentMappingIdPartial, this.state.approvalStatus.approved, this.state.dataFull, this.state.invoiceDetails)} type="submit">
                                            Accept
                                        </button>
                                        <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={this.AcceptmodalPartial}>{" "}Cancel{" "}</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>

                    {/* ---- Accept Modal Partial End-------- */}
                    {/* ----Accept Modal For Supplier Start----- */}

                    <Modal isOpen={this.state.AcceptmodalForSupplier} className="modal-lg">
                        <div
                            className={
                                "modal-bg" + (this.state.AcceptmodalForSupplier === "false" ? "open" : "")
                            }
                        >
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div>
                                        <h4> Proforma Invoice Details </h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        aria-label="Close"
                                        onClick={this.AcceptmodalForSupplier}
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>

                            <div>
                                <ModalBody Style="modal-body">
                                    <div className="row pt-2 mt-4">
                                        <div className="col-md-6 ">
                                            <div className="row">
                                                <div className="col-md-7">
                                                    <b> Proforma Invoice No: </b>
                                                </div>
                                                <div className="col-md-5">
                                                    <input
                                                        type="text"
                                                        className="form-control text-center"
                                                        value={this.state.InvoiceNo}
                                                        onChange={this.InvoiceNoInput}
                                                    ></input>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <b>Proforma Invoice Date:</b>
                                                </div>
                                                <div className="col-md-6">
                                                    <input
                                                        type="date"
                                                        max={formatDate(new Date())}
                                                        className="form-control text-center"
                                                        value={this.state.InvoiceDate}
                                                        onChange={this.handleInvoiceDate}
                                                    ></input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row  pt-2 mt-4">
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-7">
                                                    <b> Project code: </b>
                                                </div>
                                                <div className="col-md-5">
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        className="form-control text-center"
                                                        value={this.props.poDetails.paymentTermDetailsByPoId.wbsCode ? (this.props.poDetails.paymentTermDetailsByPoId.wbsCode).substring(0, 6) : "NA"}
                                                    ></input>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <Switch onChange={(e) => this.handleSwitch(e)} checked={this.state.checkedSwitch} onColor="#86d3ff" onHandleColor="#2693e6" handleDiameter={30} uncheckedIcon={false} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" id="material-switch" />
                                                </div>
                                                <div className="col-md-10">
                                                    {this.state.checkedSwitch ? <span className="badge badge-primary">Partial Payment</span> : <span className="badge badge-warning">Full Payment</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pt-2 mt-4">
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-7">
                                                    <b>Proforma Invoice Amount: </b>
                                                </div>
                                                <div className="col-md-5">
                                                    <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center"
                                                        value={this.state.InvoiceAmount ? this.state.InvoiceAmount : 0}
                                                        onValueChange={(value) => this.InvoiceAmountInput(value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pt-2 mt-4">
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-7">
                                                    <b> Currency: </b>
                                                </div>
                                                <div className="col-md-5">
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        className="form-control text-center"
                                                        value={this.props.poDetails.paymentTermDetailsByPoId.Currency ? this.props.poDetails.paymentTermDetailsByPoId.Currency.trim() : "NA"}
                                                    ></input>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer ">
                                    <div>
                                        <button className="btn2 btn-sms1 mt-2 rounded-pill ml-4 float-right" onClick={() => this.InsertInvoiceDetailsForSupplier(this.state.dataFullForSupplier)} type="submit"> Submit </button>
                                        <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={this.AcceptmodalForSupplier}>{" "}Cancel{" "}</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>

                    {/* ---- Accept Modal End-------- */}
                    {/* ----Accept Modal For Supplier Partial Start----- */}

                    <Modal isOpen={this.state.AcceptmodalForSupplierPartial} className="modal-lg">
                        <div
                            className={
                                "modal-bg" + (this.state.AcceptmodalForSupplierPartial === "false" ? "open" : "")
                            }
                        >
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div>
                                        <h4> Proforma Invoice Details </h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        aria-label="Close"
                                        onClick={this.AcceptmodalForSupplierPartial}
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>

                            <div>
                                <ModalBody Style="modal-body">
                                    <div className="row pt-2 mt-4">
                                        <div className="col-md-6 ">
                                            <div className="row">
                                                <div className="col-md-7">
                                                    <b> Proforma Invoice No: </b>
                                                </div>
                                                <div className="col-md-5">
                                                    <input
                                                        type="text"
                                                        className="form-control text-center"
                                                        value={this.state.InvoiceNo}
                                                        onChange={this.InvoiceNoInput}
                                                    ></input>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <b>Proforma Invoice Date:</b>
                                                </div>
                                                <div className="col-md-6">
                                                    <input
                                                        type="date"
                                                        max={formatDate(new Date())}
                                                        className="form-control text-center"
                                                        value={this.state.InvoiceDate}
                                                        onChange={this.handleInvoiceDate}
                                                    ></input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row  pt-2 mt-4">
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-7">
                                                    <b> Project code: </b>
                                                </div>
                                                <div className="col-md-5">
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        className="form-control text-center"
                                                        value={this.props.poDetails.paymentTermDetailsByPoId.wbsCode ? (this.props.poDetails.paymentTermDetailsByPoId.wbsCode).substring(0, 6) : "NA"}
                                                    ></input>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <Switch onChange={(e) => this.handleSwitch(e)} checked={this.state.checkedSwitch} onColor="#86d3ff" onHandleColor="#2693e6" handleDiameter={30} uncheckedIcon={false} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" id="material-switch" />
                                                </div>
                                                <div className="col-md-10">
                                                    {this.state.checkedSwitch ? <span className="badge badge-primary">Partial Payment</span> : <span className="badge badge-warning">Full Payment</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pt-2 mt-4">
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-7">
                                                    <b>Proforma Invoice Amount: </b>
                                                </div>
                                                <div className="col-md-5">
                                                    <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center"
                                                        value={this.state.InvoiceAmount ? this.state.InvoiceAmount : 0}
                                                        onValueChange={(value) => this.InvoiceAmountInput(value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pt-2 mt-4">
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-7">
                                                    <b> Currency: </b>
                                                </div>
                                                <div className="col-md-5">
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        className="form-control text-center"
                                                        value={this.props.poDetails.paymentTermDetailsByPoId.Currency ? this.props.poDetails.paymentTermDetailsByPoId.Currency.trim() : "NA"}
                                                    ></input>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer ">
                                    <div>
                                        <button className="btn2 btn-sms1 mt-2 rounded-pill ml-4 float-right" onClick={() => this.InsertInvoiceDetailsForSupplierPartial(this.state.dataFullForSupplier)} type="submit"> Submit </button>
                                        <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={this.AcceptmodalForSupplierPartial}>{" "}Cancel{" "}</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>

                    {/* ---- Accept Modal Supplier Partial End-------- */}
                    {/* Link GRN Modal */}
                    <Modal isOpen={this.state.GRNModal} className="modal-lg">
                        <div className={"modal-bg" + (this.state.GRNModal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header  ">
                                    {this.state.infoValGRN == 1 ? <div><h4 >Assigned GRN Details :</h4></div> : <div><h4 >GRN Link With Invoice :</h4></div>}
                                    <button type="button" className="close" aria-label="Close" onClick={() => this.GRNModal()} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>

                            <div >
                                <ModalBody Style="modal-body modalbodysWideBudget ">
                                    {this.state.infoValGRN == 1 ?
                                        <div className="row  mt-4 align">
                                            <div className="col ">
                                                <table border="1" className="table5 table" >
                                                    <thead>
                                                        <tr className="headerbar ">
                                                            <th>PO LineItem No.</th>
                                                            <th>Service LineItem No.</th>
                                                            <th>GRN No.</th>
                                                            <th>SRN No.</th>
                                                            <th>GRN Qty.</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.GRNTableData && this.state.GRNTableData.map((data, index) =>
                                                            <tr key={index} className="rows headeralign">
                                                                <td>{data.POLineItemSAPCode}</td>
                                                                <td>{data.ServiceLineItemNumber ? data.ServiceLineItemNumber : ""}</td>
                                                                <td>{data.GRNDocNo}</td>
                                                                <td>{data.SRN ? data.SRN : ""}</td>
                                                                <td>{data.GRNQty}</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        :
                                        <div className="col-md-12 pt-2">
                                            <div className="row ">
                                                <div className="col-md-4 pt-2 " >
                                                    <b>GRN Link With Invoice :</b>
                                                </div>
                                                <div className="col-md-6 pt-2 " >
                                                    <Select maxMenuHeight={500} placeholder="GRNS" value={this.state.GRNDocNo} styles={customStyles} options={this.state.GRNDropDownData} onChange={(e) => this.handleSelectGRN(e)} />
                                                </div>
                                            </div>
                                            <div className="row  mt-4 align">
                                                <div className="col ">
                                                    <table border="1" className="table5 table" >
                                                        <thead>
                                                            <tr className="headerbar ">
                                                                <th>PO LineItem No.</th>
                                                                <th>Service LineItem No.</th>
                                                                <th>GRN No.</th>
                                                                <th>SRN No.</th>
                                                                <th>GRN Qty.</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.GRNTableData && this.state.GRNTableData.map((data, index) =>
                                                                <tr key={index} className="rows headeralign">
                                                                    <td>{data.POLineItemSAPCode}</td>
                                                                    <td>{data.ServiceLineItemNumber ? data.ServiceLineItemNumber : ""}</td>
                                                                    <td>{data.GRNDocNo}</td>
                                                                    <td>{data.SRN ? data.SRN : ""}</td>
                                                                    <td>{data.GRNQty}</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer ">
                                    <div>
                                        <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={() => this.GRNModal()}> Close </button>
                                        {this.state.infoValGRN != 1 ?
                                            <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={() => this.SubmitGRNData()}> Submit </button>
                                            : null}
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* Link GRN Modal END */}
                    {/* revise modal end */}
                    {this.state.showRevisedPopUpPayment && <Modal isOpen={this.state.showRevisedPopUpPayment} >
                        <div className={"modal-bg" + (this.state.OpenVersionmodal == true ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div className="modal-text"><h4 >{this.state.revisedPayload && this.state.revisedPayload.param && this.state.revisedPayload.param.documentTypeName ? `${this.state.revisedPayload.param.documentTypeName}` : null}</h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={(e) => this.revisePopUpActionPayment(false)} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div>
                                <ModalBody Style="modal-body modalbodyssmall">

                                    <div className="row ">
                                        <div className="col-8"></div>
                                        <div className="col-4 pb-2">
                                            {/* <DropdownFlat defaultopt="-Select-"  data={this.state.Date} actions={this.handleSelect} keyObjName={"value"} valueObjName={"label"} /> */}
                                        </div>
                                    </div>

                                    <div className="row col-sm-12" style={{ textAlign: "center", display: "none", top: "40%" }}>
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>

                                    <div className="row ">
                                        <div className="col-sm-6">
                                            Upload Document (Optional)
                                        </div>
                                        <div className="col-sm-6">
                                            <input type="file" className="form-control-file" name="" onChange={(e) => { this.handleFileInputforRevisionPayment(e) }} id="exampleFormControlFile2" />
                                        </div>
                                    </div>

                                    <div className="row mt-4">
                                        <div className="col-sm-6">
                                            Comment
                                        </div>
                                        <div className="col-sm-6">
                                            <textarea className="form-control" onChange={(e) => this.formChangePayment(e)}>{this.state.reviseForm.comment}</textarea>
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div className="">
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className="btn2 btn-sms1 mt-2 ml-2 float-right" onClick={() => this.formSaveActionPayment()} type="submit">Save</button>
                                        <button className="btn2 btn-sms1 mt-2 ml-2 " onClick={() => this.revisePopUpActionPayment(false)} type="submit">Close</button>

                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    }


                    <div className="row-md-12" style={{ marginTop: "1.5rem" }} >
                        <div className="row">
                            <div className="col-md-4">
                                <h4>Purchase Order Details : </h4>
                            </div>
                            <div className="col-md-8">
                                {roles[7] ?
                                    <div className="row" >
                                        <div className="col-md-9 " >
                                            <div className="float-right">
                                                <Switch onColor="#86d3ff" onHandleColor="#2693e6" handleDiameter={30} uncheckedIcon={false} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch mt-2" id="material-switch" checked={this.state.billingScheduleRequiredDetails == 1 ? true : false} onChange={() => this.handleCheck()} />
                                            </div>
                                        </div>
                                        <div className="col-md-2 pt-2 ">
                                            <span className={this.state.billingScheduleRequiredDetails == 1 ? "badge badge-info" : "badge badge-danger"}>{this.state.billingScheduleRequiredDetails == 1 ? "Required" : "Not Required"}</span>
                                        </div>
                                        <div className="col-md-1">
                                            <button className="btn2 btn-sms1 rounded-pill float-right" onClick={() => this.SaveToggleBillingInput()}>Save</button>
                                        </div>
                                    </div>
                                    : null}
                            </div>

                        </div>
                        <hr></hr>
                        <div>
                            <div className="row ">
                                <div className="col " >
                                    <div className="row">
                                        <div className="col-md-4 " ><b>Project Code: </b></div>
                                        <div className="col">{this.props.poDetails.poDetails.wbsCode ? ((this.props.poDetails.poDetails.wbsCode).substring(0, 6)) : ""}</div>
                                    </div>

                                </div>
                                <div className="col">
                                    <div className="row">
                                        <div className="col-md-6 " ><b>WBS Number: </b></div>
                                        <div className="col ">{this.props.poDetails.poDetails.wbsCode ? this.props.poDetails.poDetails.wbsCode : ""}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="row ">
                                <div className="col " >
                                    <div className="row">
                                        <div className="col-md-4 " ><b>PO No: </b></div>
                                        <div className="col">{this.props.location.state.POSAPId}</div>
                                    </div>

                                </div>
                                <div className="col">
                                    <div className="row">
                                        <div className="col-md-6 " ><b>Supplier Name: </b></div>
                                        <div className="col ">{this.props.poDetails.poDetails.vendorName}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="row ">
                                <div className="col" >
                                    <div className="row">
                                        <div className="col-md-4 " ><b>PO Line Item: </b></div>
                                        <div className="col">{this.props.location.state.lineItemSAPId}</div>
                                    </div>

                                </div>
                                <div className="col">
                                    <div className="row">
                                        <div className="col-md-6 " ><b>Material Number: </b></div>
                                        <div className="col ">{temp.MaterialNumber}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="row ">
                                <div className="col " >
                                    <div className="row">
                                        <div className="col-md-4 " ><b>PO Quantity: </b></div>
                                        <div className="col">{`${temp.poLineItemQuantity} ${temp.OrderUnit}`}</div>
                                    </div>

                                </div>
                                <div className="col">
                                    <div className="row">
                                        <div className="col-md-6 " ><b>Material Name: </b></div>
                                        <div className="col ">{temp.poLineItemDescription}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col " >
                                    <div className="row">
                                        <div className="col-md-4 " ><b>Size/ Dimensions: </b></div>
                                        <div className="col">{temp.Dimension}</div>
                                    </div>

                                </div>
                                <div className="col">
                                    <div className="row">
                                        <div className="col-md-6 " ><b>PO Date: </b></div>
                                        <div className="col ">{this.props.poDetails.poDetails.poDate ? dateFormater(this.props.poDetails.poDetails.poDate) : "---"}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col " >
                                    <div className="row">
                                        <div className="col-md-4 " ><b>Location: </b></div>
                                        <div className="col">{this.props.poDetails.poDetails.location}</div>
                                    </div>

                                </div>
                                <div className="col">
                                    <div className="row">
                                        <div className="col-md-6 " ><b>Payment Term: </b></div>
                                        <div className="col ">{this.props.poDetails.poDetails.paymentTermCode}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col " >
                                    <div className="row">
                                        <div className="col-md-4 " ><b>Expected Delivery Date: </b></div>
                                        <div className="col">
                                            {this.state.ExpectedDeliveryDate ? dateFormater(this.state.ExpectedDeliveryDate) : "---"}

                                        </div>
                                    </div>

                                </div>
                                <div className="col">
                                    <div className="row">
                                        <div className="col-md-6 " ><b>Document Submission Due Date: </b></div>
                                        <div className="col ">{this.state.DocumentSubmissionDueDate ? dateFormater(this.state.DocumentSubmissionDueDate) : "---"}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col " >
                                    <div className="row">
                                        <div className="col-md-4 " ><b>PO Document: </b></div>
                                        <div className="col">
                                            <FontAwesomeIcon className="mr-3" icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(this.props.poDetails.poDetails.poDetailsDocumentId)} />
                                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.props.poDetails.poDetails.poDetailsDocumentId + "/download"} target="_blank" download>
                                                <FontAwesomeIcon icon={"file-download"} color={"black"} title={"Download"} size="lg" />
                                            </a>
                                        </div>
                                    </div>

                                </div>
                                <div className="col">
                                    <div className="row">
                                        <div className="col" ><b>PO Acceptance Document: </b></div>
                                        <div className="col">
                                            <FontAwesomeIcon className="mr-3" icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(this.props.poDetails.poDetails.poAcceptanceDocumentId)} />
                                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.props.poDetails.poDetails.poAcceptanceDocumentId + "/download"} target="_blank" download>
                                                <FontAwesomeIcon icon={"file-download"} color={"black"} title={"Download"} size="lg" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* {roles[5] ? */}
                            <div className="row">
                                <div className="col " >
                                    <div className="row pt-2">
                                        <div className="col-md-4 " ><b>Claimed By:</b></div>
                                        <div className="col">
                                            {this.state.ClaimByName ? this.state.ClaimByName : '---'}
                                        </div>
                                    </div>
                                </div>
                                <div className="col ">
                                    <div className="row pt-2">
                                        <div className="col-md-6" ><b>Claimed By Date:</b></div>
                                        <div className="col-md-6">
                                            {this.state.ClaimByDate ? formatDate(this.state.ClaimByDate) : '---'}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <div className="row">
                                        <div className="col-md-2" ><b>Claimed Planner Name :</b></div>
                                        <div className="col">
                                            {this.props.poDetails.paymentTermDetailsByPoId.claimBy == null ? "To be claimed" : this.props.poDetails.paymentTermDetailsByPoId.claimBy}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                        </div>
                    </div>

                    {1 === 1 ?
                        <div className="row-md-8 pr-4">
                            <Accordion defaultActiveKey="0">
                                <Card >
                                    <Accordion.Toggle
                                        as={"h5"} className="accordion-background mb-0 pb-2 pt-2 pl-2 pr-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(1)} onClick={() => this.setState({ activeEventKey: JSON.stringify(1) })}>
                                        <div className="pl-2">
                                            Drawing List : (By Vendor)
                                            <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                        </div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={JSON.stringify(1)}>
                                        <Card.Body>
                                            {(roles[5] || roles[7]) && this.state.isSubmittedFlag !== 1 ?
                                                <div className="row pb-2">
                                                    <div className="col-md-2">
                                                        <b>Add More Documents : </b>
                                                    </div>
                                                    <div className="col">
                                                        <div className="">
                                                            {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                                <FontAwesomeIcon className="align-middle" icon={"plus-circle"} title="Add More Documents" color={"blue"} size="lg" onClick={() => { this.addDrawingInputmodal() }} />
                                                                : null}
                                                        </div>
                                                    </div>
                                                </div>
                                                : null}
                                            <TableComp cols={DrawingtableConstants(this.state.Drawingdetails, this.state.engineerUserID)} data={this.state.Drawingarray} />
                                            {(roles[12] || roles[5]) && this.state.isSubmittedFlag == 1 ?
                                                <>
                                                    <hr></hr>
                                                    <div className="row justify-content-end">
                                                        <div className="col-md-4">
                                                            <h5>All documents submitted From Vendor's End</h5>
                                                        </div>
                                                    </div>
                                                </>
                                                : roles[5] && !temp.DeletionIndicator && temp.isHold !== 1 ?
                                                    <>
                                                        <hr></hr>
                                                        <div className="row justify-content-end">
                                                            <div className="col-md-4">
                                                                <h5>Are all documents submitted? </h5>
                                                            </div>
                                                            <div className="col-md-1">
                                                                <FontAwesomeIcon icon={"check-circle"} title="View" color={"blue"} size="2x" onClick={(e) => this.allDocumentSubmitted(this.state.poID, this.state.LineItemID)} />
                                                            </div>
                                                        </div>
                                                        <hr></hr></>
                                                    : null}
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </div> : null}



                    <div className="row-md-8 pr-4">
                        <Accordion defaultActiveKey="0">
                            <Card >
                                <Accordion.Toggle
                                    as={"h5"} className="accordion-background mb-0 pb-2 pt-2 pl-2 pr-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(2)} onClick={() => this.setState({ activeEventKey: JSON.stringify(2) })}>
                                    <div className="pl-2">
                                        PO Attachments: (By SMS)
                                        <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                    </div>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey={JSON.stringify(2)}>
                                    <Card.Body>
                                        <Accordion defaultActiveKey="0">
                                            <Card >
                                                <Accordion.Toggle as={"h5"} className="accordion-background1 mb-0 pb-2 pt-2 pl-2 pr-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(25)} onClick={() => this.setState({ activeEventKey: JSON.stringify(25) })}>
                                                    <div className="pl-2">
                                                        PO Annexures:
                                                        <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                                    </div>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey={JSON.stringify(25)}>
                                                    <Card.Body>
                                                        {roles[15] ?
                                                            <div className="row">
                                                                <div className="col-md-2"><b>Add More Documents : </b></div>
                                                                <div className="col">
                                                                    <div className="col-md-1 pt-1">
                                                                        {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                                            <FontAwesomeIcon className="align-middle" icon={"plus-circle"} title="Add More Documents" color={"blue"} size="lg" onClick={() => { this.addDocumentmodal(1) }} />
                                                                            : null}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : null}
                                                        <TableComp cols={TransmittalTableConstants()} data={this.state.PoAnnexure} />
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>
                                        <Accordion defaultActiveKey="0">
                                            <Card >
                                                <Accordion.Toggle as={"h5"} className="accordion-background1 mb-0 pb-2 pt-2 pl-2 pr-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(26)} onClick={() => this.setState({ activeEventKey: JSON.stringify(26) })}>
                                                    <div className="pl-2">
                                                        Drawing Transmittal:
                                                        <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                                    </div>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey={JSON.stringify(26)}>
                                                    <Card.Body>
                                                        {roles[15] ?
                                                            <div className="row">
                                                                <div className="col-md-2"><b>Add More Documents : </b></div>
                                                                <div className="col">
                                                                    <div className="col-md-1 pt-1">
                                                                        {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                                            <FontAwesomeIcon className="align-middle" icon={"plus-circle"} title="Add More Documents" color={"blue"} size="lg" onClick={() => { this.addDocumentmodal(2) }} />
                                                                            : null}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : null}
                                                        <TableComp cols={TransmittalTableConstantsDrawing()} data={this.state.DrawingTransmittal} />
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </div>


                    <div className="row-md-8 pr-4">
                        <Accordion defaultActiveKey="0">
                            <Card >
                                <Accordion.Toggle
                                    as={"h5"} className="accordion-background mb-0 pb-2 pt-2 pl-2 pr-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(3)} onClick={() => this.setState({ activeEventKey: JSON.stringify(3) })}>
                                    <div className="pl-2">
                                        All Documents :
                                        <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                    </div>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey={JSON.stringify(3)}>
                                    <Card.Body>
                                        <TableComp cols={tableConstants(this.state.allDocumentsDetails, this.state.actingRoles)} data={this.state.allDocuments} />
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </div>
                    <div className="row-md-8 pr-4">
                        <Accordion defaultActiveKey="0">
                            <Card >
                                <Accordion.Toggle
                                    as={"h5"} className="accordion-background mb-0 pb-2 pt-2 pl-2 pr-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(4)} onClick={() => this.setState({ activeEventKey: JSON.stringify(4) })}>
                                    <div className="pl-2">
                                        Progress Report :
                                        <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                    </div>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey={JSON.stringify(4)}>
                                    <Card.Body>
                                        <div className="row pb-2">
                                            <div className="col-md-2"><b>Add More Documents : </b></div>
                                            <div className="col">
                                                {roles[5] || roles[7] ?
                                                    <div className="col-md-1">
                                                        {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                            <FontAwesomeIcon className="align-middle" icon={"plus-circle"} title="Add More Documents" color={"blue"} size="lg" onClick={() => { this.addDrawingInputmodal(1) }} />
                                                            : null}
                                                    </div>
                                                    : null}
                                            </div>
                                            <div className="col-md-2">
                                                <div className="col-md-4 float-right">
                                                    <FontAwesomeIcon className="align-middle float-right" icon={"sms"} title="Chat" color={"black"} size="2x" onClick={() => { this.rowClickProgress(102, this.props.poDetails.poDetails.poId, this.state.LineItemID) }} />
                                                </div>
                                            </div>
                                        </div>
                                        <TableComp cols={ProgresstableConstants(this.state.allDocumentsDetails, this.state.actingRoles)} data={this.state.progressReportDocuments.length > 0 ? this.state.progressReportDocuments : this.state.Progressarray} />
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </div>
                    {this.props.poDetails && this.props.poDetails.loading == true ?
                        <div className="row-md-8 pr-4">
                            <div className="accordion-background mb-0 pb-2 pl-2 pt-2">
                                <h5 className='pl-2' style={{ textDecoration: "none", color: 'white', cursor: 'pointer' }}>Fetching Data ...</h5>
                            </div>
                        </div>
                        : this.state.poLineItemDetails.poLineItemTemplateId != null && this.state.ClaimByName && this.props.poDetails.poDetails && this.props.poDetails.poDetails.lineItems && this.props.poDetails.poDetails.lineItems.length > 0 && this.props.poDetails.poDetails.lineItems[0].poLineItemStatus !== "No Inspection needed" ?
                            <div className="row-md-8 pr-4">
                                <div className="accordion-background mb-0 pb-2 pl-2 pt-2">
                                    <Link to={{ pathname: '/InspectiondashboardDocument', state: { poid: this.props.location.state.POSAPId, itemNo: this.state.poLineItemDetails.poLineItemSapCode, po: this.state.poID, polineitemID: this.state.poLineItemDetails.poLineItemId } }}>
                                        <h5 className='pl-2' style={{ textDecoration: "none", color: 'white', cursor: 'pointer' }}>QA Documents</h5>
                                    </Link>
                                </div>
                            </div>
                            : <div className="row-md-8 pr-4">
                                <div className="accordion-background mb-0 pb-2 pl-2 pt-2">
                                    {
                                        roles[7] && this.props.poDetails.poDetails && this.props.poDetails.poDetails.lineItems && this.props.poDetails.poDetails.lineItems.length > 0 && (this.props.poDetails.poDetails.lineItems.find((item) => item.poLineItemId == this.state.LineItemID && (item.poLineItemTemplateName === "Special" || item.poLineItemStatus === 'No Inspection needed'))) ?
                                            <h5 className='pl-2' style={{ textDecoration: "none", color: 'white', cursor: 'pointer' }}>QA Documents <span className='badge badge-danger'>No Action Required</span></h5>
                                            : (roles[7] && (this.state.ClaimByName === '' || this.state.ClaimByName === null)) && this.props.poDetails.poDetails && this.props.poDetails.poDetails.lineItems && this.props.poDetails.poDetails.lineItems.length > 0 && this.props.poDetails.poDetails.lineItems[0].poLineItemTemplateName !== "Special" ?
                                                <h5 className='pl-2' style={{ textDecoration: "none", color: 'white', cursor: 'pointer' }}>Template Assigned</h5>
                                                : <h5 className='pl-2' style={{ textDecoration: "none", color: 'white', cursor: 'pointer' }}>Template Not Assigned Yet</h5>}
                                    {/* {roles[7] && (this.state.ClaimByName === '' || this.state.ClaimByName === null) && this.props.poDetails.poDetails && this.props.poDetails.poDetails.lineItems && this.props.poDetails.poDetails.lineItems.length > 0 && this.props.poDetails.poDetails.lineItems[0].poLineItemTemplateName !== "Special" ?
                                        <span className='badge badge-danger'>Please Claim PO</span>
                                        : ''} */}
                                </div>
                            </div>
                    }
                    <div className="row-md-8 pr-4">
                        <div className="accordion-background mb-0 pb-2 pl-2 pt-2">
                            <Link to={{ pathname: '/PoAcceptanceTrail', state: { poSAPId: this.props.location.state.POSAPId, poId: this.state.poID, PoAmount: this.props.poDetails.poDetails.poAmount } }}>
                                <h5 className='pl-2' style={{ textDecoration: "none", color: 'white', cursor: 'pointer' }}>Payment Documents</h5>
                            </Link>
                        </div>
                    </div>
                    {/* {!roles[5] ? 
                        <div className="row-md-8 pr-4">
                            <Accordion defaultActiveKey="0">
                                <Card >
                                    <Accordion.Toggle
                                        as={"h5"} className="accordion-background mb-0 pb-2 pl-2 pt-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(5)} onClick={() => this.setState({ activeEventKey: JSON.stringify(5) })}>
                                        <div className="pl-2">
                                            Payment Documents :
                                            <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                        </div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={JSON.stringify(5)}>
                                        <Card.Body>
                                            {this.state.paymentTermDocuments.map((item, index) =>
                                                <>
                                                    {(roles[5] && (item.PaymentTypeId == 1 || item.InvoiceId)) ?
                                                        (<Accordion defaultActiveKey="10">
                                                            <Card >
                                                                <Accordion.Toggle as={"h6"} className="accordion-background1 mb-0 pb-2 pl-2 pr-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(index)} onClick={() => this.setState({ activeEventKey: JSON.stringify(index) })}>
                                                                    <div className="row pl-2">
                                                                        <div className="col pt-2">
                                                                            {item.TypeFor != null ? `${item.PaymentType} Against ${item.TypeFor}`
                                                                                : item.PaymentType}{item.Counter > 0 ? " - " + (item.Counter + 1) : " - 1"}
                                                                            <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                                                        </div>
                                                                        {!roles[5] ?
                                                                            <div className="col mt-2">
                                                                                {/* <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="lg" onClick={()=>this.actioncheck(item)}/>
                                                                                <Link to={{ pathname: '/PoAcceptanceTrail', state: { poId: item.PurchaseOrderId, poSAPId: item.POSAPId, PoAmount: item.POAmount } }}>
                                                                                    <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                                                                                </Link>
                                                                            </div>
                                                                            : null}
                                                                    </div>
                                                                </Accordion.Toggle>
                                                            </Card>
                                                            <Accordion.Collapse eventKey={JSON.stringify(index)}>
                                                                <Card.Body>
                                                                    {item.Documents.filter((data) => data.ActingDeptGroupId == 19).length == 0 && roles[12] && this.state.approvalDetailsByCPMorTPM.find((data) => data.approvalStatus != 0) && !this.state.approvalDetailsByCPMorTPM.find((data) => data.TypeFor == item.TypeFor && data.PaymentType == item.PaymentTypeId && data.approvalStatus == 1 && data.ActedGroupId == 19) ?
                                                                        <div className="row">
                                                                            <div className="col">
                                                                                <button className="float-right btn2 btn-sms1 mr-4 rounded-pill" onClick={() => this.approveByCPMandTPM(item, 19)}>Approve</button>
                                                                            </div>
                                                                        </div>
                                                                        : null}
                                                                    {item.Documents.filter((data) => data.ActingDeptGroupId == 26).length == 0 && roles[19] && this.state.approvalDetailsByCPMorTPM.find((data) => data.approvalStatus != 0) && !this.state.approvalDetailsByCPMorTPM.find((data) => data.TypeFor == item.TypeFor && data.PaymentType == item.PaymentTypeId && data.approvalStatus == 1 && data.ActedGroupId == 26) ?
                                                                        <div className="row">
                                                                            <div className="col">
                                                                                <button className="float-right btn2 btn-sms1 mr-4 rounded-pill" onClick={() => this.approveByCPMandTPM(item, 26)}>Approve</button>
                                                                            </div>
                                                                        </div>
                                                                        : null}
                                                                    <div className="row row-md-8 pr-4">
                                                                        {roles[5] && (!item.Documents.find(el => el.AdvanceStageDocumentMappingId) || item.Documents.find(el => el.approvalStatus == 0 && el.PaymentTypeId == item.PaymentTypeId && el.TypeFor == item.TypeFor)) ?
                                                                            <div className="col-12">
                                                                                <button className="float-right btn2 btn-sms1 rounded-pill" onClick={() => this.submitInvoiceDocuments(item)}>Submit Invoice</button>
                                                                            </div>
                                                                            : null}
                                                                        <div className="col-12 ">
                                                                            <div className="row  headerbar" style={{ backgroundColor: "#0989cb", color: "white" }}>
                                                                                <div className="col-md-3 pt-2 pb-2 borderheaderbar">Document Type</div>
                                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">Acting Department</div>
                                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">Submitted On</div>
                                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">Acted On</div>
                                                                                <div className="col-md-3 pt-2 pb-2 borderheaderbar">Actions</div>
                                                                            </div>

                                                                            {console.log(item, "IIKIKKI")}
                                                                            {item.Documents.map((element, Index) =>
                                                                                <div className={Index % 2 == 0 ? 'row border ' : 'row  background '}
                                                                                    // onClick={() => this.togglebutton(Index)} 
                                                                                    data-toggle="collapse" data-target={`.multi-collapse${Index}`}>

                                                                                    <div className="col-md-3 pt-2 pb-2 borderheaderbar text-left">{`${element.DocumentTypeName} (${element.Amount}${element.AmountTypeName})`}</div>
                                                                                    {
                                                                                        roles[5] ?
                                                                                            <div className="col-md-2 pt-2 pb-2 borderheaderbar text-left">SMS Team</div>
                                                                                            :
                                                                                            element.DocumentTypeId && element.DocumentId && element.approvalStatus == 3 ?
                                                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar text-left">{this.props.poDetails.paymentTermDetailsByPoId.vendorName}</div>
                                                                                                :
                                                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar text-left">{element.GroupName}</div>
                                                                                    }
                                                                                    {/* <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{JSON.stringify(this.props.poDetails.poDetailsForAdvance[element.DocumentTypeId])}</div>
                                                                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center">{element.CreatedOn ? dateFormater(element.CreatedOn) : null}</div>
                                                                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center">{element.approvedOn ? dateFormater(element.approvedOn) : null}</div>
                                                                                    <div className="col-md-3 pt-2 pb-2 text-center">
                                                                                        {/* {element.DocumentId && element.approvalStatus == 0 && !roles[5] ?

                                                                                        {element.DocumentId == null || (element.DocumentId && (element.approvalStatus == 3 || element.approvalStatus == 2)) ?
                                                                                            element.DocumentTypeId == 40 && this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentId != null ?
                                                                                                <div className="row">
                                                                                                    <div className="col align-middle">
                                                                                                        <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.props.poDetails.paymentTermDetailsByPoId.poAcceptanceDocumentId + "/download"} target="_blank" download>
                                                                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="View" color={"black"} size="2x" />
                                                                                                        </a>
                                                                                                    </div>
                                                                                                </div>
                                                                                                :
                                                                                                roles[5] && element.isWaivedOff !== 2 ?
                                                                                                    <>
                                                                                                        <div className="view-button justify-content-between row">
                                                                                                            <div className="col dark">
                                                                                                                <input type="file" className="form-control-file" style={{ width: "69%" }} onChange={(e) => { this.handleFileInput(e, element) }} id="exampleFormControlFile1" />
                                                                                                            </div>
                                                                                                            <div className="col-md-4 mr-2">
                                                                                                                {element.DocumentTypeId == 84 || element.DocumentTypeId == 73 || element.DocumentTypeId == 52 || element.DocumentTypeId == 36 || element.DocumentTypeId == 41 || element.DocumentTypeId == 46 || element.DocumentTypeId == 101 || element.DocumentTypeId == 110 || element.DocumentTypeId == 111 || element.DocumentTypeId == 112 || element.DocumentTypeId == 113 || element.DocumentTypeId == 114 || element.DocumentTypeId == 115 || element.DocumentTypeId == 118 || element.DocumentTypeId == 119 ?
                                                                                                                    <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={(e) => { this.AcceptmodalForSupplier(element) }} color={"black"} title={"Upload File"} size="lg" />
                                                                                                                    : <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={(e) => { this.onclickUpload(element) }} color={"black"} title={"Upload File"} size="lg" />
                                                                                                                }
                                                                                                                {element.DocumentTypeId in this.props.poDetails.poDetailsForAdvance && element.approvalStatus == 3 ?
                                                                                                                    <>
                                                                                                                        <FontAwesomeIcon className="align-middle mr-2" icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(element.DocumentId)} />
                                                                                                                        <FontAwesomeIcon className="align-middle" icon={"sms"} color={"block"} title="Comments" size="lg" onClick={() => this.rowClickPayment(element.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, 0)} />
                                                                                                                    </>
                                                                                                                    : null
                                                                                                                }
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        {element.DocumentTypeId in this.props.poDetails.poDetailsForAdvance && element.approvalStatus == 3 ?
                                                                                                            <span className={"badge " + this.state.docStatus[element.approvalStatus]['badge']}>
                                                                                                                {this.state.docStatus[element.approvalStatus]['title']}
                                                                                                            </span>
                                                                                                            : null}
                                                                                                    </>
                                                                                                    : (element.DocumentTypeId in this.props.poDetails.poDetailsForAdvance && (element.approvalStatus == 3 || element.approvalStatus == 2)) ?
                                                                                                        <>
                                                                                                            <div className="row align-middle">
                                                                                                                <div className="col align-middle">
                                                                                                                    <FontAwesomeIcon
                                                                                                                        className="align-middle pr-2"
                                                                                                                        icon={"code-branch"}
                                                                                                                        color={"black"}
                                                                                                                        title="Document Version"
                                                                                                                        size="2x" onClick={() => this.OpenVersionModal(element.DocumentId)} />
                                                                                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.DocumentId + "/download"} target="_blank" download>
                                                                                                                        <FontAwesomeIcon icon={"file-download"} title="Download" color={"black"} size="lg" />
                                                                                                                    </a>
                                                                                                                    <FontAwesomeIcon className="align-middle ml-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClickPayment(element.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, 0)} />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <span className={"badge " + this.state.docStatus[element.approvalStatus]['badge']}>
                                                                                                                {this.state.docStatus[element.approvalStatus]['title']}
                                                                                                            </span>
                                                                                                        </>
                                                                                                        :
                                                                                                        <FontAwesomeIcon icon={"stopwatch"} title="Awaiting upload from supplier" color={"grey"} size="lg" />

                                                                                            :

                                                                                            element.DocumentId && element.approvalStatus == 6 && !roles[5] && groups[element.ActingDeptGroupId] ?
                                                                                                (
                                                                                                    <>
                                                                                                        <div className="row">
                                                                                                            <div className="col align-middle">
                                                                                                                <FontAwesomeIcon
                                                                                                                    className="align-middle pr-2"
                                                                                                                    icon={"code-branch"}
                                                                                                                    color={"black"}
                                                                                                                    title="Document Version"
                                                                                                                    size="2x" onClick={() => this.OpenVersionModal(element.DocumentId)} />
                                                                                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.DocumentId + "/download"} target="_blank" download>
                                                                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"file-download"} title="Download" color={"black"} size="2x" />
                                                                                                                </a>

                                                                                                                {roles[8] == true && groups[8] == true && ((element.DocumentTypeId == 84 || element.DocumentTypeId == 73 || element.DocumentTypeId == 52 || element.DocumentTypeId == 36 || element.DocumentTypeId == 41 || element.DocumentTypeId == 46 || element.DocumentTypeId == 101 || element.DocumentTypeId == 110 || element.DocumentTypeId == 111 || element.DocumentTypeId == 112 || element.DocumentTypeId == 113 || element.DocumentTypeId == 114 || element.DocumentTypeId == 115 || element.DocumentTypeId == 118 || element.DocumentTypeId == 119)) ?
                                                                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.Acceptmodal(element.DocumentTypeId, element.DocumentTypeName, element, element.DocumentId)} />
                                                                                                                    : <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: element, qATemplateStageId: 1 }, true, 0, element.DocumentId, this.state.approvalStatus.approved)} />
                                                                                                                }

                                                                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: element, qATemplateStageId: 1 }, true, 0, element.DocumentId, this.state.approvalStatus.revise)} />
                                                                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClickPayment(element.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, 0)} />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <span className={"badge " + this.state.docStatus[element.approvalStatus]['badge']}>
                                                                                                            {this.state.docStatus[element.approvalStatus]['title']}
                                                                                                        </span>
                                                                                                    </>

                                                                                                )
                                                                                                :
                                                                                                element.DocumentId ?
                                                                                                    (
                                                                                                        <>
                                                                                                            <div className="row align-middle">
                                                                                                                <div className="col align-middle">
                                                                                                                    <FontAwesomeIcon
                                                                                                                        className="align-middle pr-2"
                                                                                                                        icon={"code-branch"}
                                                                                                                        color={"black"}
                                                                                                                        title="Document Version"
                                                                                                                        size="2x" onClick={() => this.OpenVersionModal(element.DocumentId)} />
                                                                                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.DocumentId + "/download"} target="_blank" download>
                                                                                                                        <FontAwesomeIcon icon={"file-download"} title="Download" color={"black"} size="lg" />
                                                                                                                    </a>
                                                                                                                    <FontAwesomeIcon className="align-middle ml-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" onClick={() => this.rowClickPayment(element.DocumentId, this.props.poDetails.paymentTermDetailsByPoId.poId, element.DocumentTypeId, 0)} />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <span className={"badge " + this.state.docStatus[element.approvalStatus]['badge']}>
                                                                                                                {this.state.docStatus[element.approvalStatus]['title']}
                                                                                                            </span>
                                                                                                        </>
                                                                                                    )
                                                                                                    : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            {!roles[5] && item.PaymentTypeId == 3 && item.InvoiceId != null && item.Documents.filter(data => !data.AdvanceStageDocumentMappingId && (data.DocumentTypeId == 38 || data.DocumentTypeId == 41 || data.DocumentTypeId == 46 || data.DocumentTypeId == 52 || data.DocumentTypeId == 37 || data.DocumentTypeId == 36)).length == 0 && this.state.GRNbyPOId.length > 0 ?
                                                                                (
                                                                                    <div className='row border '>
                                                                                        <div className="col-md-3 pt-2 pb-2 borderheaderbar text-left">GRN</div>
                                                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar text-left">TPM</div>
                                                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center">{this.state.GRNbyPOId.find(data => data.InvoiceId == item.InvoiceId) ? this.state.GRNbyPOId.find(data => data.InvoiceId == item.InvoiceId).SubmissionDate ? dateFormater(this.state.GRNbyPOId.find(data => data.InvoiceId == item.InvoiceId).SubmissionDate) : "" : ""}</div>
                                                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center"></div>
                                                                                        <div className="col-md-3 pt-2 pb-2 borderheaderbar text-center">
                                                                                            {roles[12] && item.GRN.length == 0 ?
                                                                                                <div className="view-button justify-content-between row">
                                                                                                    <div className="col dark">
                                                                                                        <input type="file" className="form-control-file" style={{ width: "69%" }} onChange={(e) => { this.handleFileInput(e, { DocumentTypeId: 122 }) }} id="exampleFormControlFile1" />
                                                                                                    </div>
                                                                                                    <div className="col-md-4 mr-2">
                                                                                                        <FontAwesomeIcon className="mr-2" icon={"cloud-upload-alt"} onClick={() => this.GRNSubmit(item)} color={"black"} title={"Upload File"} size="lg" />
                                                                                                    </div>
                                                                                                </div>
                                                                                                : item.GRN.length > 0 ?
                                                                                                    <>
                                                                                                        <div className="row align-middle">
                                                                                                            <div className="col align-middle">
                                                                                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.state.GRNbyPOId.find(elem => elem.InvoiceId == item.InvoiceId).GRNDocumentId + "/download"} target="_blank" download>
                                                                                                                    <FontAwesomeIcon icon={"file-download"} title="Download" color={"black"} size="lg" />
                                                                                                                </a>
                                                                                                                <FontAwesomeIcon className="ml-2" icon={"info-circle"} title="info" color={"black"} size="lg" onClick={() => this.GRNinfo(1, item.GRN)} />                                                                                    </div>
                                                                                                        </div>
                                                                                                        <span className={"badge badge-warning"}>Document Submitted</span>
                                                                                                    </>

                                                                                                    : <FontAwesomeIcon icon={"stopwatch"} title="Awaiting for upload" color={"black"} size="lg" />
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                )

                                                                                : null}

                                                                        </div>
                                                                    </div>
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        </Accordion>)
                                                        : null}
                                                </>
                                            )}
                                            {this.props.poDetails && this.props.poDetails.paymentTermDocuments && this.props.poDetails.paymentTermDocuments.recordsets && this.props.poDetails.paymentTermDocuments.recordsets[3].length > 0 ?
                                                <>
                                                    {this.state.paymentTermDocumentsPartial.map((item, index) =>
                                                        item.Documents.length > 0 ?
                                                            <>
                                                                <Accordion defaultActiveKey="20">
                                                                    <Card >
                                                                        <Accordion.Toggle as={"h6"} className="accordion-background1 mb-0 pb-2 pl-2 pr-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(index)} onClick={() => this.setState({ activeEventKey: JSON.stringify(index) })}>
                                                                            <div className="row pl-4 pr-4">
                                                                                <div className="col pt-2">
                                                                                    {item.TypeFor != null ? `${item.PaymentType} Against ${item.TypeFor}` : item.PaymentType}{" - " + (item.Counter + 1)}
                                                                                    <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                                                                </div>
                                                                                <div className="col pt-2">
                                                                                    <p className="badge badge-warning" style={{ backgroundColor: "#ffc107c2" }}>Partial Payment</p>
                                                                                </div>
                                                                                {!roles[5] ?
                                                                                    <div className="col mt-2" style={{ left: '25px' }}>
                                                                                        {item.ApprovalDepartments.filter((data) => data.ActingDeptGroupId == 19).length == 0 ? this.state.approvalDetailsByCPMorTPMPartial.find((data) => data.Counter == item.Counter && data.approvalStatus == 1 && data.DocumentTypeId == 0 && data.DocumentId == null && data.ActedGroupId == 19) ?
                                                                                            <div className="float-right ml-1">
                                                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={100}>
                                                                                                    <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>PM</div>
                                                                                                </CircularProgressbarWithChildren>
                                                                                            </div>
                                                                                            : <div className="float-right ml-1">
                                                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={0}>
                                                                                                    <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>PM</div>
                                                                                                </CircularProgressbarWithChildren>
                                                                                            </div>
                                                                                            : null}
                                                                                        {item.ApprovalDepartments.filter((data) => data.ActingDeptGroupId == 26).length == 0 ? this.state.approvalDetailsByCPMorTPMPartial.find((data) => data.Counter == item.Counter && data.PoId == item.PoId && data.approvalStatus == 1 && data.DocumentTypeId == 0 && data.DocumentId == null && data.ActedGroupId == 26) ?
                                                                                            <div className="float-right ml-1">
                                                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={100}>
                                                                                                    <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>CM</div>
                                                                                                </CircularProgressbarWithChildren>
                                                                                            </div>
                                                                                            : <div className="float-right ml-1">
                                                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={0}>
                                                                                                    <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>CM</div>
                                                                                                </CircularProgressbarWithChildren>
                                                                                            </div>
                                                                                            : null
                                                                                        }
                                                                                        {item.ApprovalDepartments.map((elem) =>
                                                                                            <div className="float-right ml-1">
                                                                                                <CircularProgressbarWithChildren className='approvalcircle' strokeWidth={50} styles={buildStyles({ pathColor: "#4db665", strokeLinecap: "butt" })} value={Math.round((elem.ApprovedCount / elem.TotalApprovalCount) * 100)}>
                                                                                                    <div style={{ fontSize: '12px', color: 'black', fontWeight: 'bold' }}>{elem.ShortDeptName}</div>
                                                                                                </CircularProgressbarWithChildren>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                    : null}
                                                                            </div>
                                                                        </Accordion.Toggle>
                                                                    </Card>
                                                                    <Accordion.Collapse eventKey={JSON.stringify(index)}>
                                                                        <Card.Body>
                                                                            {roles[5] && item.Documents.find(el => this.state.paymentTermPartialDetails[el.AdvanceStageDocumentMappingIdPartial].approvalStatus == 0 && this.state.paymentTermPartialDetails[el.AdvanceStageDocumentMappingIdPartial].PaymentType == item.PaymentTypeId && this.state.paymentTermPartialDetails[el.AdvanceStageDocumentMappingIdPartial].TypeFor == item.TypeFor) ?
                                                                                <div className="col-12">
                                                                                    <button className="float-right btn2 btn-sms1 rounded-pill" onClick={() => this.submitInvoiceDocumentsPartial(item)}>Submit Invoice</button>
                                                                                </div>
                                                                                : null}
                                                                            {item.PaymentType != "Dispatch" && item.Documents.filter((data) => data.ActingDeptGroupId == 19).length == 0 && roles[12] && this.state.approvalDetailsByCPMorTPMPartial.find((data) => data.Counter == item.Counter && data.DocumentId != null && data.approvalStatus != 0) && !this.state.approvalDetailsByCPMorTPMPartial.find((data) => data.Counter == item.Counter && data.approvalStatus == 1 && data.ActedGroupId == 19) ?
                                                                                <div className="row">
                                                                                    <div className="col">
                                                                                        <button className="float-right btn2 btn-sms1 mr-4 rounded-pill" onClick={() => this.approveByCPMandTPMPartial(item, 19)}>Approve</button>
                                                                                    </div>
                                                                                </div>
                                                                                : null}
                                                                            {item.PaymentType != "Dispatch" && item.Documents.filter((data) => data.ActingDeptGroupId == 26).length == 0 && roles[19] && this.state.approvalDetailsByCPMorTPMPartial.find((data) => data.Counter == item.Counter && data.DocumentId != null && data.approvalStatus != 0) && !this.state.approvalDetailsByCPMorTPMPartial.find((data) => data.Counter == item.Counter && data.approvalStatus == 1 && data.ActedGroupId == 26) ?
                                                                                <div className="row">
                                                                                    <div className="col">
                                                                                        <button className="float-right btn2 btn-sms1 mr-4 rounded-pill" onClick={() => this.approveByCPMandTPMPartial(item, 26)}>Approve</button>
                                                                                    </div>
                                                                                </div>
                                                                                : null}
                                                                            <TableComp cols={partialPayment()} data={item.Documents.filter((data) => data.DocumentTypeId != null && data.DocumentTypeId != 0)} />
                                                                        </Card.Body>
                                                                    </Accordion.Collapse>
                                                                </Accordion>
                                                            </>
                                                            : null
                                                    )}
                                                </>
                                                : null}
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </div>
                        : null}   */}
                    <div className="row-md-8 pr-4">
                        {this.state.billingScheduleRequiredDetails == 1 ?
                            <Accordion defaultActiveKey="0">
                                <Card >
                                    <Accordion.Toggle
                                        as={"h5"} className="accordion-background mb-0 pb-2 pt-2 pl-2 pr-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(6)} onClick={() => this.setState({ activeEventKey: JSON.stringify(6) })}>
                                        <div className="pl-2">
                                            Billing Schedule:
                                            <FontAwesomeIcon className="ml-2" icon={"caret-down"} title="View" color={"white"} size="1x" />
                                        </div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={JSON.stringify(6)}>
                                        <Card.Body>
                                            {this.state.billingScheduleDetails.filter(data => data.PoLineItemId == this.state.LineItemID && data.ActedPurchaserId !== null && data.isRequested > 0).length > 0 ?
                                                <div className="row pb-2">
                                                    <div className="col"><span className="badge badge-success float-right">Approved By {this.state.billingScheduleDetails.filter(data => data.PoLineItemId == this.state.LineItemID && data.ActedPurchaserId !== null && data.isRequested > 0)[0].PurchaserName}</span></div>
                                                </div>
                                                :
                                                null}
                                            {this.state.billingScheduleDetails.filter(data => data.PoLineItemId == this.state.LineItemID && data.ActedPMId !== null && data.isRequested > 0).length > 0 ?
                                                <div className="row pb-2">
                                                    <div className="col"><span className="badge badge-success float-right">Approved By {this.state.billingScheduleDetails.filter(data => data.PoLineItemId == this.state.LineItemID && data.ActedPMId !== null && data.isRequested > 0)[0].PMName}</span></div>
                                                </div>
                                                :
                                                null}
                                            {roles[5] && !this.state.billingScheduleDetails.filter(data => data.PoLineItemId == this.state.LineItemID && data.isRequested != 0).length > 0 ?
                                                <div className="row pb-2">
                                                    <div className="col-md-2">
                                                        <b>Add More Documents : </b>
                                                    </div>
                                                    <div className="col">
                                                        <div className="">
                                                            {!temp.DeletionIndicator && temp.isHold !== 1 ?
                                                                <div className="row">
                                                                    <div className="col">
                                                                        <FontAwesomeIcon className="align-middle" icon={"plus-circle"} title="Add More Documents" color={"blue"} size="lg" onClick={() => { this.addBillingScheduleDetails() }} />
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <b className="float-right">Total Po Line Item Value :</b>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center"
                                                                            value={this.state.polineItemTotalVale}
                                                                            readOnly
                                                                        />
                                                                    </div>
                                                                </div>
                                                                : null}
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <button className="btn2 btn-sms1 rounded-pill float-right" onClick={() => this.submitBillingSchedule()}>Submit</button>
                                                    </div>
                                                </div>
                                                : roles[12] && this.state.billingScheduleDetails.filter(data => data.PoLineItemId == this.state.LineItemID && data.isRequested == 2).length > 0 ?
                                                    <div className="row pb-2">
                                                        <div className="col">
                                                            <button className="btn2 btn-sms1 rounded-pill float-right">Comments</button>
                                                            <button className="btn2 btn-sms1 rounded-pill float-right" onClick={() => this.updateBillingScheduleNo(8, this.state.LineItemID)}>Revise</button>
                                                            <button className="btn2 btn-sms1 rounded-pill float-right" onClick={() => this.updateBillingScheduleNo(9, this.state.LineItemID)}>Approve</button>
                                                        </div>
                                                    </div>
                                                    : roles[15] && this.state.billingScheduleDetails.filter(data => data.PoLineItemId == this.state.LineItemID && data.isRequested == 1).length > 0 ?
                                                        <div className="row pb-2">
                                                            <div className="col">
                                                                <button className="btn2 btn-sms1 rounded-pill float-right">Comments</button>
                                                                <button className="btn2 btn-sms1 rounded-pill float-right" onClick={() => this.updateBillingScheduleNo(8, this.state.LineItemID)}>Revise</button>
                                                                <button className="btn2 btn-sms1 rounded-pill float-right" onClick={() => this.updateBillingScheduleNo(7, this.state.LineItemID)}>Approve</button>
                                                            </div>
                                                        </div>
                                                        : null}
                                            {this.state.billingScheduleDetails.filter(data => data.PoLineItemId == this.state.LineItemID && (data.isRequested != 0 || data.isRequested == 2)).length > 0 ?
                                                <TableComp cols={BillingScheduleTableConstantNotEditable()} data={this.state.billingScheduleDetails} />
                                                :
                                                roles[5] ? <TableComp cols={BillingScheduleTableConstant()} data={this.state.billingScheduleDetails} />
                                                    :
                                                    <TableComp cols={BillingScheduleTableConstantNotEditable()} data={this.state.billingScheduleDetails} />
                                            }
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                            : null}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({ invoices: state.invoice, udploadedpofords: state.vendorReducer, poDetails: state.poDetails, file: state.file, expediting: state.expediting, masterReducer: state.masterReducer, dispatchOrderDetailsReducer: state.dispatchOrderDetailsReducer })
export default connect(mapStateToProps, {
    GetAllDetailsOfPoUploadedForDS, getPODetails, postDeliveryScheduleDetails, uploadPaymentAcknowledgement, getAllDocumentsForExpediting,
    getDocumentDetailsForExpediting, postDocumentDetailsForExpediting, approveDocumentsForExpediting, uploadFileGeneric, GetDocumentApprovalDetailsForExpediting, GetNextActedRoleIdForApproval,
    getEngineeringMaster, getExpeditingStatusIdForPolineItems, postCommentsForPOs, getAllDocumentsWithDetailsForExpediting, updateDeliveryScheduleDetails, uploadFile, downloadFile,
    getDocumentVersions, GenericUploadVersionFile, postComment, UpdateStatusForExpediting, GetAssignedEngineers, UpdateEngineerAssignment, getAllDrawingDocuments, GetDrawingDocumentApprovalDetails,
    ApproveDrawingDocuments, GetNextActedUserId, GetAssignedEngineerDetails, PostAssignedEngineerDetails, GetClaimDetailsByPoId, GenericPostCommentsbyDocumentID, GenericGetCommentsbyDocumentID,
    postPoTransmittleDocumnetDtails, GetTransmittalDocumentDetails, UpdateTransmittalDocumentDetails, PartialApproval, InsertProgressReportDocuments, GetProgressReportDocuments, AllDocumentsSubmittedByVendor,
    DeleteAssignedEngineerDetails, GetAllDocumentsForQA, RemoveRowsFromDocumentTable, getPaymentTermDocuments, GetDocumentsForAdvance, postMapAdvanceDocumentIDsToPO, postUpdateAdvanceDocumentStatus, GetPaymentTermDetailByPOId, PaymentTermDocumentsApprovalByPMs,
    postApprovePOAcceptance, GetPaymentTermDetails, UpdatePartialPaymentDetails, submitInvoiceDocuments, UpdateApprovalForAdvanceDocumentPartial, setInvoicePaymentMedium, getAllInvoices, updateStatusForFinance, GetAllInvoicesForSupplier, InsertInvoiceDetails,
    GetInvoiceDetailsForAPteamApproval, InsertBillingScheduleDetails, getBillingScheduleDetails, InsertBillingScheduleClaimedDetail, GetGRNDetails, postGRNDetails,
})(ExpeditingApprovedPOAcceptance);

